import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import axios from "axios";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { v4 as uuid } from "uuid";
import {
  getAgentSignup,
  regenerateAgentLink,
  cancelAgentLink,
  getSmtpSettings,
  addSmtpSettings,
  getPaymentSettings,
  addPaymentSettings,
  verifySmtpSettings,
  getQuotationSettings,
  addQuotationSettings,
  getCommissionSettings,
  addCommissionSettings,
  getClientNotes,
  editClientNotes,
  getSignatorySettings,
  deleteSignatorySettings,
  getRFQSettings,
  editRfqSettings,
  getOnboardingItems,
  getSignatorySettingsByID,
  getCustomSettings,
  addCustomSettings,
  getAllowedDomains,
  addAllowedDomains,
  deleteAllowedDomain,
  updateAllowedDomain,
  OnboardingSaveSettings,
  getClientRegistrationSettings,
  saveClientRegistrationSettings,
  getSharelinks,
  setDefaultSharelink,
  restoreSharelink,
  sendSharelinkEmail,
  saveOrdersSettings,
  getOrdersSettings,
} from "./../../../config/reseller_api_calls";

import { listForms } from "./../../../config/forms_api_calls";
import {
  getMandatoryClientAgreements,
  getMandatoryPartnerAgreements,
} from "./../../../config/api_calls";
import HelperClass from "./../../../config/helperClass";
import {
  THEME_TEXT_COLOR,
  THEME_COLOR,
  AGENT_SERVER_URL,
  APP_LIVE_URL,
} from "./../../../config/config";
import { addSettings, addMsaInfo } from "../../../actions";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { Fileupload } from "../../../components/Image/Fileupload";
import Tooltip from "@material-ui/core/Tooltip";
import MutextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PageTitle from "../ExtraComponents/PageTitle";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";
//import { Editor } from "@tinymce/tinymce-react";
import dateFormat, { masks } from "dateformat";
import Select from "react-select";
import makeAnimated from "react-select/animated";
//import { CKEditor } from "@ckeditor/ckeditor5-react";
//import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";

import { ValidateEmail } from "./../../../config/utility";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { PhoneNumberUtil } from "google-libphonenumber";
import countryList from "react-select-country-list";
import localization from "../../../localization/enUS";
import { QRCodeSVG } from "qrcode.react";
import UserPermissionHelper from "../../../components/Reseller/UserPermissionHelper";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import NotificationToast from "../../../components/Notification/NotificationToast";

const animatedComponents = makeAnimated();

const auth = new HelperClass();

class Upgrades extends Component {
  constructor() {
    super();
    this.cropperRef = React.createRef();
    this.signatoryFileInputRef = React.createRef();
    this.signatoryFileInputUpdateRef = React.createRef();
    this.decimalPoint = Number(auth.getDecimalPoint());
    this.billing_decimalPoint = Number(auth.getBillingDecimalPoint());
    this.state = {
      tableData: [],
      errorMessage: "",
      agentId: "",
      successMessage: "",
      toastMessage: "",
      toastType: "success",
      toastTitle: "",
      SmtpErrorMessage: "",
      SmtpSuccessMessage: "",
      smtp_reg_button: false,
      onboarding_reg_button: false,
      smtp_test_button: false,
      paymentErrorMessage: "",
      paymentSuccessMessage: "",
      quotationErrorMessage: "",
      quotationSuccessMessage: "",
      payment_reg_button: false,
      quotation_button: false,
      visibleTabs: [],
      settingsTabsMap: new Map(),
      rfqInSettings: false, // Track if RFQ Settings is in Settings menu
      commissionErrorMessage: "",
      commissionSuccessMessage: "",
      commissionErrorTitle: "",
      commission_button: false,
      commission_type: "paid_on_collected",
      commission_value_type: "percentage",
      apply_commission: "agent_account",
      draw_threshold: (0).toFixed(this.decimalPoint),
      draw_threshold_billing: (0).toFixed(this.billing_decimalPoint),
      commission_value: "",
      bank_account_details: "",
      wire_transfer_details: "",
      quotation_notes: "",
      payment_terms: "",
      selected_payment_terms: null,
      currency: "",
      decimalPoint: 2,
      selected_currency: null,
      contact_person: "",
      contact_email: "",
      validity: "",
      waitMessage: "",
      tableLoader: true,
      tableLoaderNotes: false,
      tableLoaderRfq: false,
      client_rfq_button: false,
      tableLoaderPayment: false,
      signup_link: "",
      copied: false,
      copied2: false,
      cpied_value: "",
      current_id: "",
      reg_button: false,
      reg_button_login: false,
      cancel_button: false,
      tableLoaderQuote: true,
      login_url: "",
      logo: "",
      signature_image: "",
      smtp_host: "",
      smtp_user: "",
      smtp_password: "",
      smtp_method: "tls",
      smtp_port: "",
      errorHostName: "",
      errorUser: "",
      errorPassword: "",
      from_email: "",
      errorFromEmail: "",
      is_working: "",
      notifications_email: "",
      billing_email: "",
      sales_email: "",
      settings_type: "",
      clientNotes: "",
      otherSettingSuccessMessage: "",
      otherSettingErrorMessage: "",
      client_setting_button: false,
      //Signatory Settings
      signatory_name: "",
      signatory_company: "",
      signatory_title: "",
      signatory_signature_image: "",
      signatory_status: "",
      signatorySettingSuccessMessage: "",
      signatorySettingErrorMessage: "",
      signatorySettingErrorTitle: "",
      signatorySettingNotFound: "",
      signatory_button: false,
      signatoryDetails: [],
      columnsignatoryDetails: [],
      add_picture: "",
      add_picture_name: "",
      add_picture_update: "",
      add_picture_name_update: "",
      signatory_button_delete: false,
      signatory_id: "",
      signatoryDeleteSuccessMessage: "",
      signatoryDeleteErrorMessage: "",
      signatoryDeleteErrorTitle: "",
      signatoryDeleteNotFound: "",
      signatory_button_delete: false,
      isEditorReady: false,
      //RFQ Settings
      rfqSettingTitle: "",
      rfqSettingHeading: "",
      rfqSettingDesc: "",
      rfqSettingSuccessMessage: "",
      rfqSettingErrorMessage: "",
      rfq_setting_button: false,
      //Cropper
      brightness: 100,
      showBrightnessRange: false,
      add_picture_existing: "",
      loading: false,

      signatory_email: "",
      signatory_phone: "",
      signatory_address: "",
      signatory_address2: "",
      signatory_city: "",
      signatory_zip: "",
      signatory_state: "",
      signatory_country: "United States",
      signatory_search: "",
      signatory_view_data: null,
      signatory_drag_over: false,
      signatory_drag_over_update: false,
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
      isLoading: true,
      isFileUploaded: false,

      billing_decimalPoint: 2,
      passwordShown: false,
      smtpCredentialInputsReady: false,

      showPasswordVerificationModal: false,
      loginPassword: "",
      loginPasswordError: "",
      verifyingPassword: false,
      loginPasswordVerified: false,
      passwordShownVerify: false,

      notification_sidebar: "",
      show_tutorial: "",
      address_autocomplete: "",
      address_validation: "",
      allowed_domain: "",
      google_login: "",
      google_direct_registration: "",
      required_sub_user_type: "",
      sales_order_sequence_no: "",
      custom_reg_button: false,
      CustomErrorMessage: "",
      CustomSuccessMessage: "",
      CustomErrorMessageDomain: "",
      CustomSuccessMessageDomain: "",
      copied3: false,
      allowed_domain_list: [],
      domain_reg_button: false,
      domain_id: "",
      CustomErrorMessageDomainDel: "",
      CustomSuccessMessageDomainDel: "",
      onboarding_id: "",
      onboardingErrorMessageDelete: "",
      onboardingSuccessMessageDelete: "",
      isProcessing: false,
      editingDomainId: null,
      editingDomainValue: "",
      // Edit Onboarding Item Modal
      editOnboardingId: "",
      editOnboardingTitle: "",
      editOnboardingForm: "",
      editOnboardingAnswerType: "",
      editOnboardingAllowSkip: false,
      editOnboardingAllowAI: false,
      editOnboardingDescription: "",
      editOnboardingLoader: false,
      editQuestionErrorMessage: "",
      editQuestionSuccessMessage: "",
      newQuestion: [],
      questionErrorMessage: "",
      questionErrorMessageTitle: "",
      questionSuccessMessage: "",
      add_question_loader: false,
      currentAnswerType: "",
      // Onboarding Items State
      onboardingItems: [],
      newStepCounter: 0,
      onboardingErrorMessage: "",
      onboardingErrorMessageTitle: "",
      onboardingSuccessMessage: "",
      onboardingItemsWithErrors: [],
      onboarding_save_loading: false,
      // Onboarding Template Settings
      onboarding_title: "",
      onboarding_message: "",
      errorOnboardingTitle: "",
      errorOnboardingMessage: "",
      // Forms Data
      formsList: [],
      formsLoading: false,
      // Agreements Data for Onboarding
      agreementsList: [],
      agreementsLoading: false,
      // Add/Edit Onboarding Modal Type
      addOnboardingType: "form",
      editOnboardingType: "form",
      editOnboardingAgreement: "",
      editOnboardingAgreementTitle: "",
      editOnboardingAgreementInstruction: "",
      editOnboardingAgreementSource: "",
      addOnboardingAgreementTab: "Partner",
      editOnboardingAgreementTab: "Partner",

      // Client Registration Settings
      registrationFields: {},
      registrationSettingsLoading: false,
      registrationSettingsErrorMessage: "",
      registrationSettingsSuccessMessage: "",
      registration_save_button: false,

      // Sharelink Settings
      sharelinkTableData: [],
      sharelinkTableLoader: false,
      sharelinkErrorMessage: "",
      defaultSharelinkLoading: null,
      sharelinkActionSuccessMessage: "",
      sharelinkActionSuccessMessageTitle: "",
      sharelinkModalLink: "",
      sharelinkModalTitle: "",
      sharelinkModalCopied: false,
      sharelinkModalShow_regenerate: "",
      sharelinkModalCustomLink: "",
      sharelinkModalReg_button: false,
      sharelinkModalSend_email: "0",
      sharelinkModalEmail_to: "",
      sharelinkModalName: "",
      sharelinkModalComment: "",
      sharelinkModalReg_email_button: false,
      sharelinkModalLinkErrorMessage: "",
      sharelinkModalLinkSuccessMessage: "",
      sharelinkModalEErrorMessage: "",
      sharelinkModalESuccessMessage: "",
      sharelinkModalMakeDefault: false,
      sharelinkModalMakeMain: false,
      sharelinkModalSaveLoading: false,
      sharelinkModalLinkHash: "",
      sharelinkModalLinkIdentifier: "",
      // Sharelink Action Modal State
      sharelinkActionMakeDefault: false,
      sharelinkActionMakeMain: false,
      sharelinkActionSaveLoading: false,
      sharelinkActionLinkHash: "",
      sharelinkActionLinkIdentifier: "",
      sharelinkActionErrorMessage: "",
      sharelinkActionSuccessMessage: "",
      defaultSharelinkLoading: null,
      sharelinkActionSuccessMessage: "",
      sharelinkActionSuccessMessageTitle: "",
      sharelink_search: "",
      sharelink_search_input: "",
      sharelinkColumns: [
        {
          name: "Agent Name",
          label: "Agent Name",
          options: {
            customBodyRender: (value, tableMeta) => {
              const email = tableMeta.rowData[1] || "";
              const initials = this.getSignatoryInitials(value);
              return (
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div
                    style={{
                      width: 34,
                      height: 34,
                      borderRadius: 8,
                      background: "#6576ff",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 12,
                      fontWeight: 700,
                      flexShrink: 0,
                    }}
                  >
                    {initials}
                  </div>
                  <div>
                    <div style={{ fontWeight: 600 }}>{value || "---"}</div>
                    <div style={{ fontSize: 12, color: "#8094ae" }}>
                      {email || "---"}
                    </div>
                  </div>
                </div>
              );
            },
          },
        },
        {
          name: "Agent Email",
          label: "Agent Email",
          options: { display: false, filter: false, sort: false },
        },
        { name: "Title" },
        {
          name: "Date Added",
          options: {
            customBodyRender: (value) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        {
          name: "is_default",
          label: "Default",
          options: {
            customBodyRender: (value) =>
              value === 1 || value === "1" ? (
                <Tooltip title="Apply default sharelink content to all sharelinks" placement="top">
                <span className="badge badge-outline-primary">
                  <em className="icon ni ni-check"></em> Default
                </span>
                </Tooltip>
              ) : ( 
                <span className="badge badge-outline-secondary">Not Default</span>
              ),
          },
        },
         {
          name: "main_sharelink",
          label: "Main Sharelink",
          options: {
            customBodyRender: (value) =>
              value === 1 || value === "1" ? (
                <Tooltip title="Main ShareLink for Marketing Website" placement="top">
                <span className="badge badge-outline-primary">
                  <em className="icon ni ni-check"></em> Main Sharelink
                </span>
                </Tooltip>
              ) : ( 
                <span className="badge badge-outline-secondary">Not Main Sharelink</span>
              ),
          },
        },
        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta) =>
              parseInt(tableMeta.rowData[10], 10) === 1 ? (
                <span className="badge badge-outline-secondary">
                  <em className="icon ni ni-trash"></em> Deleted
                </span>
              ) : value === 1 || value === "1" ? (
                <span className="badge badge-outline-success">
                  <em className="icon ni ni-done"></em> Active
                </span>
              ) : (
                <span className="badge badge-outline-danger">
                  <em className="icon ni ni-na"></em> Inactive
                </span>
              ),
          },
        },
        {
          name: "View Link",
          options: {
            customBodyRender: (value, tableMeta) => {
              if (!value) return "—";
              const title = tableMeta.rowData[0];
              const linkHash = tableMeta.rowData[9];
              const linkIdentifier = tableMeta.rowData[8];
              return (
                <a
                  style={{ cursor: "pointer", color: "#0000EE" }}
                  onClick={() => {
                    this.setState({
                      sharelinkModalLink: value,
                      sharelinkModalTitle: title,
                      sharelinkModalCopied: false,
                      sharelinkModalLinkHash: linkHash,
                      sharelinkModalLinkIdentifier: linkIdentifier,
                    });
                    window.$("#modalSharelinkView").modal("show");
                  }}
                  title="View Sharelink"
                >
                  View
                  <em
                    className="icon ni ni-external-alt"
                    style={{ marginLeft: "3px" }}
                  ></em>
                </a>
              );
            },
          },
        },
        {
          name: "link_hash",
          label: "link_hash",
          options: { display: false, filter: false, sort: false },
        },
        {
          name: "Actions",
          label: "Actions",
          options: {
            sort: false,
            customBodyRender: (value, tableMeta) => {
              const isDisabled =
                this.props.is_msa_signed === "No" ||
                this.props.defaultSettings === "missing";

              return (
                <div
                  className="nk-tb-col nk-tb-col-tools"
                  style={{ padding: "0px" }}
                >
                  <ul className="nk-tb-actions gx-1">
                    <li>
                      <div className="drodown">
                        <a
                          href="#"
                          title="Other Actions"
                          className="dropdown-toggle btn btn-icon btn-outline-light"
                          data-toggle="dropdown"
                          style={{
                            pointerEvents: isDisabled ? "none" : "auto",
                            opacity: isDisabled ? 0.5 : 1,
                          }}
                        >
                          <em className="icon ni ni-more-h"></em>
                        </a>
                        <div className="dropdown-menu dropdown-menu-right">
                          <ul className="link-list-opt no-bdr">
                            <li>
                              <a
                                href="#"
                                data-toggle="tooltip"
                                data-placement="left"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  if (!isDisabled) {
                                    const title = tableMeta.rowData[0];
                                    const linkHash = tableMeta.rowData[9];
                                    const linkIdentifier = tableMeta.rowData[8];
                                    const isDefault = tableMeta.rowData[4];
                                    const isMain = tableMeta.rowData[5];
                                    this.setState({
                                      sharelinkActionLinkHash: linkHash,
                                      sharelinkActionLinkIdentifier: linkIdentifier,
                                      sharelinkActionMakeDefault: isDefault === 1 || isDefault === "1",
                                      sharelinkActionMakeMain: isMain === 1 || isMain === "1",
                                      sharelinkActionErrorMessage: "",
                                      sharelinkActionSuccessMessage: "",
                                    });
                                    window.$("#modalSharelinkAction").modal("show");
                                  }
                                }}
                                title="Sharelink Settings"
                                style={{
                                  cursor: isDisabled ? "not-allowed" : "pointer",
                                  opacity: isDisabled ? 0.5 : 1,
                                  pointerEvents: isDisabled ? "none" : "auto",
                                }}
                              >
                                <em className="icon ni ni-setting"></em>
                                <span>Settings</span>
                              </a>
                            </li>
                            {parseInt(tableMeta.rowData[10], 10) === 1 && (
                              <li>
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (!isDisabled) {
                                      const linkHash = tableMeta.rowData[9];
                                      const linkIdentifier = tableMeta.rowData[8];
                                      this.restoreSharelinkFun(
                                        linkHash,
                                        linkIdentifier
                                      );
                                    }
                                  }}
                                  title="Restore Sharelink"
                                  style={{
                                    cursor: isDisabled ? "not-allowed" : "pointer",
                                    opacity: isDisabled ? 0.5 : 1,
                                    pointerEvents: isDisabled ? "none" : "auto",
                                  }}
                                >
                                  <em className="icon ni ni-redo"></em>
                                  <span>Restore</span>
                                </a>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              );
            },
          },
        },
        {
          name: "is_deleted",
          label: "is_deleted",
          options: { display: false, filter: false, sort: false },
        },
      ],

      permission_upload_logo: 0,
      permission_upload_signature: 0,
      permission_link_cancel: 0,
      permission_link_regenare: 0,
      //SMTP Settings
      permission_smtp_verify: 0,
      permission_smtp_edit: 0,

      //Onboarding Settings
      permission_onboarding_edit: 0,
      //Payment Settings
      permission_payment_edit: 0,
      //Quotation Settings
      permission_quotation_edit: 0,
      //Commission Settings
      permission_commission_edit: 0,
      //Profiles Settings
      permission_profile_edit: 0,
      permission_profile_add: 0,
      permission_profile_delete: 0,
      //Other Settings
      permission_other_edit: 0,
      //Custom Settings
      permission_custom_edit: 0,
      //RFQ Settins
      permission_rfq_edit: 0,
      //Client Registration Settings
      permission_registration_edit: 0,
      
      // Order Settings - Summary Sections
      orderSettingsErrorMessage: "",
      orderSettingsSuccessMessage: "",
      orderSettingsTableLoader: true,
      orderSettingsButton: false,
      summarySections: [],
      showAddSummarySectionModal: false,
      summarySection_title: "",
      summarySection_type: "SUBTRACT",
      summarySection_module_type: "DISCOUNT",
      summarySection_scope: "PERCENTAGE",
      summarySection_fields: {
        type: { label: "Type", visible: true },
        value: { label: "Value", visible: true },
        description: { label: "Description", visible: true },
      },
      summarySection_title_error: "",
      summarySection_type_error: "",
      add_summary_section_loader: false,
      // Edit Summary Section
      showEditSummarySectionModal: false,
      editSummarySection_id: "",
      editSummarySection_title: "",
      editSummarySection_type: "SUBTRACT",
      editSummarySection_module_type: "DISCOUNT",
      editSummarySection_scope: "PERCENTAGE",
      editSummarySection_fields: {
        type: { label: "Type", visible: true },
        value: { label: "Value", visible: true },
        description: { label: "Description", visible: true },
      },
      editSummarySection_title_error: "",
      editSummarySection_type_error: "",
      edit_summary_section_loader: false,
      permission_order_settings_edit: 0,
    };
    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands",
      )
      .sort((a, b) => {
        if (a.label === "United States") return -1;
        if (b.label === "United States") return 1;
        return a.label.localeCompare(b.label);
      });
  }

  getSettingsTabsFromMenu = () => {
    const { leftMenuItems } = this.props;

    // Find the Settings menu item
    const settingsMenu = leftMenuItems?.find(
      (menu) => menu.alt === "Settings" || menu.link?.includes("upgrades"),
    );

    let rfqInSettings = false; // Track if RFQ Settings is in Settings menu

    if (
      settingsMenu &&
      settingsMenu.submenu &&
      settingsMenu.submenu.length > 0
    ) {
      const tabsMap = new Map();

      // Map each submenu item to its settings_type extracted from the link
      settingsMenu.submenu.forEach((item) => {
        if (item.link) {
          // Extract settings_type from link (e.g., "/upgrades/general_settings" -> "general_settings")
          const linkParts = item.link.split("/");
          const settingsType = linkParts[linkParts.length - 1];

          // Check if this is RFQ Settings in Settings menu
          if (settingsType === "rfq_settings") {
            rfqInSettings = true;
          }

          // Store the mapping: settings_type -> tab info
          tabsMap.set(settingsType, {
            name: item.alt,
            link: item.link,
            settingsType: settingsType,
          });
        }
      });

      // Also check if RFQ Settings exists in Quotations menu
      const quotationsMenu = leftMenuItems?.find(
        (menu) => menu.alt === "Quotations",
      );

      if (
        quotationsMenu &&
        quotationsMenu.submenu &&
        quotationsMenu.submenu.length > 0
      ) {
        const rfqInQuotations = quotationsMenu.submenu.find(
          (item) =>
            item.alt === "RFQ Settings" || item.link?.includes("rfq_settings"),
        );

        // If RFQ Settings is found in Quotations, add it to tabs even if not in Settings
        if (rfqInQuotations) {
          tabsMap.set("rfq_settings", {
            name: rfqInQuotations.alt || "RFQ Settings",
            link: rfqInQuotations.link,
            settingsType: "rfq_settings",
          });
        }
      }

      this.setState({
        settingsTabsMap: tabsMap,
        visibleTabs: Array.from(tabsMap.keys()),
        rfqInSettings: rfqInSettings, // Store whether RFQ is in Settings menu
      });
    }
  };

  // Helper method to check if a tab should be visible based on API response
  isTabVisible = (settingsType) => {
    const { visibleTabs, settings_type } = this.state;

    // Only show tabs that are explicitly in the visibleTabs array from API
    if (visibleTabs && visibleTabs.length > 0) {
      return visibleTabs.includes(settingsType);
    }

    // If menu hasn't loaded yet, only show the currently active tab from URL
    return settings_type === settingsType;
  };

  async componentDidMount() {
    // Extract settings tabs from menu API response
    this.getSettingsTabsFromMenu();

    const passwordVerifiedAt = localStorage.getItem("passwordVerifiedAt");
    if (passwordVerifiedAt) {
      const verifiedTime = new Date(passwordVerifiedAt);
      const now = new Date();
      const diffMinutes = (now - verifiedTime) / (1000 * 60);
      if (diffMinutes <= 30) {
        this.setState({
          loginPasswordVerified: true,
          passwordShown: false,
        });
      } else {
        // expired session
        localStorage.removeItem("passwordVerifiedAt");
      }
    }

    //settings_type
    let settings_type = this.props.props.match.params.settings_type;
    // console.log("settings_type: ", settings_type);
    this.setState({
      settings_type: settings_type,
    });
    if (settings_type === "smtp_settings") {
      this.get_smtp_settings();
    }
    if (settings_type === "onboarding_settings") {
      this.get_onboarding_settings();
    }
    if (settings_type === "payment_settings") {
      this.get_payment_settings();
    }
    if (settings_type === "quotation_settings") {
      this.get_quotation_settings();
    }
    if (settings_type === "commission_settings") {
      this.get_commission_settings();
    }
    if (settings_type === "other_settings") {
      this.get_other_settings();
    }
    if (settings_type === "signatory_settings") {
      this.get_signatory_settings();
    }
    if (settings_type === "rfq_settings") {
      this.get_rfq_settings();
    }
    if (settings_type === "custom_settings") {
      this.get_custom_settings();
      this.get_allowed_domain();
    }
    if (settings_type === "registration_settings") {
      this.get_registration_settings();
    }
    if (settings_type === "sharelink_settings") {
      this.get_sharelink_settings();
    }
    if (settings_type === "order_settings") {
      this.get_order_settings();
    }
    const servicesResponce = await getAgentSignup(
      auth.getAccount(),
      auth.getToken(),
    );
    //console.log("Hash Data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        signup_link: servicesResponce.data.data,
        login_url: servicesResponce.data.login_url,
        logo: servicesResponce.data.logo,
        signature_image: servicesResponce.data.signature,
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }

    // Fetch forms list
    this.get_forms_list();
    // Fetch agreements list for onboarding
    this.get_agreements_list();
  }

  // Fetch Forms from API
  get_forms_list = async () => {
    this.setState({ formsLoading: true });
    try {
      const response = await listForms(auth.getAccount(), auth.getToken());
      if (response && response.data && response.data.status === 200) {
        // Handle different possible response structures
        let formsData = response.data.data || response.data.forms || [];

        // Ensure it's an array
        if (!Array.isArray(formsData)) {
          formsData = [];
        }
        this.setState({
          formsList: formsData,
          formsLoading: false,
        });
      } else {
        this.setState({
          formsList: [],
          formsLoading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching forms:", error);
      this.setState({
        formsList: [],
        formsLoading: false,
      });
    }
  };

  get_agreements_list = async () => {
    this.setState({ agreementsLoading: true });
    try {
      const [partnerResponse, clientResponse] = await Promise.all([
        getMandatoryPartnerAgreements(auth.getAccount(), auth.getToken()),
        getMandatoryClientAgreements(auth.getAccount(), auth.getToken()),
      ]);

      const partnerAgreements =
        partnerResponse &&
        partnerResponse.data &&
        partnerResponse.data.status === 200 &&
        partnerResponse.data.message === "success"
          ? (partnerResponse.data.data || []).map((agr) => ({
                agreement_accountno: agr.agreement_accountno,
                agreement_title: agr.agreement_title,
                agreement_instruction: agr.agreement_instruction || "",
                source: "Partner",
              }))
          : [];

      const clientAgreements =
        clientResponse &&
        clientResponse.data &&
        clientResponse.data.status === 200 &&
        clientResponse.data.message === "success"
          ? (clientResponse.data.data || []).map((agr) => ({
              agreement_accountno: agr.agreement_accountno,
              agreement_title: agr.agreement_title,
              agreement_instruction: agr.agreement_instruction || "",
              source: "Client",
            }))
          : [];

      this.setState({
        agreementsList: [...partnerAgreements, ...clientAgreements],
        agreementsLoading: false,
      });
    } catch (error) {
      this.setState({ agreementsList: [], agreementsLoading: false });
    }
  };

  // Centralized notification toast. Clearing first lets identical
  // consecutive messages re-trigger the slide-in animation.
  showToast = (message, type = "error", title) => {
    const cleaned = String(message || "")
      .replace(/<br\s*\/?\s*>/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();
    if (cleaned === "") return;
    this.setState({ toastMessage: "" }, () =>
      this.setState({
        toastMessage: cleaned,
        toastType: type,
        toastTitle:
          title ||
          (type === "success"
            ? "Success"
            : type === "warning"
              ? "Warning"
              : type === "error"
                ? "Error"
                : "Info"),
      }),
    );
  };

  // Bridge: any *ErrorMessage / *SuccessMessage / *WarningMessage state field
  // that becomes non-empty is surfaced as a notification toast instead of an
  // inline alert. Validation/required-field copy maps to a "warning" toast,
  // backend failures map to "error", and *SuccessMessage maps to "success".
  fireMessageToasts = (prevState) => {
    // Matches `xxxSuccessMessage` / `xxxErrorMessage` / `xxxWarningMessage`
    // including the delete-modal variants (`...MessageDelete`,
    // `...MessageDomainDel`). Deliberately excludes `...MessageDomain`
    // (add-domain field validation stays inline next to its input).
    const MSG_SUFFIX = /(success|error|warning)message(domaindel|delete)?$/i;
    const isMsgKey = (k) => MSG_SUFFIX.test(k);
    const keys = Object.keys(this.state).filter(isMsgKey);
    for (const k of keys) {
      const val = this.state[k];
      if (!val || val === prevState[k]) continue;

      // Find a companion title state field (naming varies between
      // `xxxErrorTitle` and `xxxErrorMessageTitle`) for a richer toast title.
      const base = k.replace(MSG_SUFFIX, "");
      const titleKey = Object.keys(this.state).find((t) =>
        new RegExp(
          "^" + base + "(success|error|warning)(message)?title$",
          "i",
        ).test(t),
      );
      const title = titleKey ? this.state[titleKey] : "";

      let type;
      if (/successmessage(domaindel|delete)?$/i.test(k)) {
        type = "success";
      } else if (/warningmessage(domaindel|delete)?$/i.test(k)) {
        type = "warning";
      } else if (/missing|required|field/i.test(title)) {
        type = "warning";
      } else if (/system error/i.test(title)) {
        type = "error";
      } else {
        // *ErrorMessage: distinguish client-side validation (warning) from
        // backend/server errors (error) by inspecting the message copy.
        type =
          /\b(required|invalid|please|must|select|enter|provide|valid|choose|cannot|missing|empty)\b/i.test(
            val,
          )
            ? "warning"
            : "error";
      }
      this.showToast(val, type, title || undefined);
      break; // surface the first newly-set message this cycle
    }
  };

  componentDidUpdate(prevProps, prevState) {
    this.fireMessageToasts(prevState);

    // Re-extract tabs when leftMenuItems changes
    if (prevProps.leftMenuItems !== this.props.leftMenuItems) {
      this.getSettingsTabsFromMenu();
    }

    // Reload order settings when switching to order_settings tab
    if (
      prevState.settings_type !== this.state.settings_type &&
      this.state.settings_type === "order_settings"
    ) {
      this.get_order_settings();
    }

    if (prevProps.userRoleItems !== this.props.userRoleItems) {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "settings",
        "general_settings",
      );
      // console.log("general_settings:", canEdit);

      this.setState({ permissionsState: canEdit });
      if (canEdit && canEdit.length > 0) {
        this.setState({
          permission_upload_logo: canEdit[0].upload_logo,
          permission_upload_signature: canEdit[0].upload_signature,
          permission_link_cancel: canEdit[0].link_cancel,
          permission_link_regenare: canEdit[0].link_regenare,
        });
      }
      //console.log("Can Edit Clients:", canEdit);
    }
  }

  regenerate_link = async () => {
    this.setState({
      reg_button: true,
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await regenerateAgentLink(
      auth.getAccount(),
      auth.getToken(),
    );
    //console.log("servicesResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while updating the signup link.",
        successMessage: "",
        reg_button: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        signup_link: servicesResponce.data.data,
        errorMessage: "",
        successMessage: "Link generated successfully.",
        reg_button: false,
      });
    } else {
      this.setState({
        errorMessage: "There is some error while updating the signup link.",
        successMessage: "",
        reg_button: false,
      });
      // window.location.replace("/error");
    }
    setTimeout(() => {
      this.setState({ successMessage: "", errorMessage: "" });
    }, 5000);
  };

  cancel_link = async () => {
    this.setState({
      cancel_button: true,
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await cancelAgentLink(
      auth.getAccount(),
      auth.getToken(),
    );
    //console.log("cancel_link: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while removing the signup link.",
        successMessage: "",
        cancel_button: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        signup_link: servicesResponce.data.data,
        errorMessage: "",
        successMessage: "Link removed successfully.",
        cancel_button: false,
      });
    } else {
      this.setState({
        errorMessage: "There is some error while removing the signup link.",
        successMessage: "",
        cancel_button: false,
      });
      // window.location.replace("/error");
    }
    setTimeout(() => {
      this.setState({ successMessage: "", errorMessage: "" });
    }, 5000);
  };

  get_smtp_settings = async () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await getSmtpSettings(
      auth.getAccount(),
      auth.getToken(),
    );
    //console.log("get_smtp_settings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while getting SMTP settings.",
        successMessage: "",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success" &&
      Array.isArray(servicesResponce.data.data) &&
      servicesResponce.data.data.length > 0
    ) {
      const row = servicesResponce.data.data[0];
      this.setState({
        smtp_host: row.smtp_host || "",
        smtp_user: row.smtp_user || "",
        smtp_password: row.smtp_password || "",
        smtp_method: row.smtp_method || "tls",
        smtp_port: row.smtp_port || "",
        from_email: row.from_email || "",
        notifications_email: row.notifications_email || "",
        is_working: row.is_working || "no",
        isEditorReady: true,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      (servicesResponce.data.message === "no_record" ||
        servicesResponce.data.message === "not_found" ||
        servicesResponce.data.message === "success")
    ) {
      // No SMTP record configured yet (or success with empty data) — show blank defaults.
      this.setState({
        smtp_host: "",
        smtp_user: "",
        smtp_password: "",
        smtp_method: "tls",
        smtp_port: "",
        from_email: "",
        notifications_email: "",
        is_working: "no",
        isEditorReady: true,
      });
    } else {
      this.setState({
        errorMessage: "There is some error while getting SMTP settings.",
        successMessage: "",
      });
    }
    const canEdit = UserPermissionHelper.getAllRoles(
      this.props.userRoleItems,
      "settings",
      "smtp_settings",
    );
    // console.log("smtp_settings:", canEdit);

    if (canEdit && canEdit.length > 0) {
      this.setState({
        permission_smtp_verify: canEdit[0].verify,
        permission_smtp_edit: canEdit[0].edit,
      });
    }
    //this.validateEmailAdd("sajid");
  };

  get_onboarding_settings = async () => {
    await this.getOnboardingItems();
  };

  add_custom_settings = async () => {
    let {
      notification_sidebar,
      show_tutorial,
      address_autocomplete,
      address_validation,
      allowed_domain,
      google_login,
      google_direct_registration,
      required_sub_user_type,
      sales_order_sequence_no,
    } = this.state;
    this.setState({
      CustomErrorMessage: "",
      CustomSuccessMessage: "",
      custom_reg_button: true,
    });

    if (notification_sidebar === "") {
      this.setState({
        CustomErrorMessage: "Notification Sidebar value is required.",
        custom_reg_button: false,
      });

      setTimeout(() => {
        this.setState({ CustomErrorMessage: "" });
      }, 3000);

      return;
    }

    if (show_tutorial === "") {
      this.setState({
        CustomErrorMessage: "Show Tutorial value is required.",
        custom_reg_button: false,
      });
      setTimeout(() => {
        this.setState({ CustomErrorMessage: "" });
      }, 3000);

      return;
    }

    if (address_autocomplete === "") {
      this.setState({
        CustomErrorMessage: "Address autocomplete value is required.",
        custom_reg_button: false,
      });

      setTimeout(() => {
        this.setState({ CustomErrorMessage: "" });
      }, 3000);

      return;
    }

    if (address_validation === "") {
      this.setState({
        CustomErrorMessage: "Address validation value is required.",
        custom_reg_button: false,
      });

      setTimeout(() => {
        this.setState({ CustomErrorMessage: "" });
      }, 3000);

      return;
    }

    if (allowed_domain === "") {
      this.setState({
        CustomErrorMessage: "Allowed domain value is required.",
        custom_reg_button: false,
      });

      setTimeout(() => {
        this.setState({ CustomErrorMessage: "" });
      }, 3000);

      return;
    }

    if (google_login === "") {
      this.setState({
        CustomErrorMessage: "Google login value is required.",
        custom_reg_button: false,
      });

      setTimeout(() => {
        this.setState({ CustomErrorMessage: "" });
      }, 3000);

      return;
    }

    if (google_direct_registration === "") {
      this.setState({
        CustomErrorMessage: "Google direct registration value is required.",
        custom_reg_button: false,
      });

      setTimeout(() => {
        this.setState({ CustomErrorMessage: "" });
      }, 3000);

      return;
    }

    if (required_sub_user_type === "") {
      this.setState({
        CustomErrorMessage: "Google direct registration value is required.",
        custom_reg_button: false,
      });

      setTimeout(() => {
        this.setState({ CustomErrorMessage: "" });
      }, 3000);

      return;
    }

    const servicesResponce = await addCustomSettings(
      auth.getAccount(),
      auth.getToken(),
      notification_sidebar,
      show_tutorial,
      address_autocomplete,
      address_validation,
      allowed_domain,
      google_login,
      google_direct_registration,
      required_sub_user_type,
      sales_order_sequence_no,
    );
    // console.log("addCustomSettings: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        CustomErrorMessage: "There is some error while adding Custom settings.",
        CustomSuccessMessage: "",
        custom_reg_button: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        CustomErrorMessage: "",
        CustomSuccessMessage: "Custom settings added successfully.",
        custom_reg_button: false,
      });
    } else {
      this.setState({
        CustomErrorMessage: "There is some error while adding Custom settings.",
        CustomSuccessMessage: "",
        custom_reg_button: false,
      });
    }

    setTimeout(() => {
      this.setState({ CustomErrorMessage: "", CustomSuccessMessage: "" });
    }, 5000);
  };

  get_allowed_domain = async () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await getAllowedDomains(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("get_allowed_domain: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while getting allowed domains.",
        successMessage: "",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        allowed_domain_list: servicesResponce.data.data,
        isEditorReady: true,
      });
    } else {
      this.setState({
        errorMessage: "There is some error while getting SMTP settings.",
        successMessage: "",
      });
    }
    //this.validateEmailAdd("sajid");
  };

  add_allowed_domains = async () => {
    let { allowed_domain_list, new_domain } = this.state;
    const trimmed = (new_domain || "").trim();

    const domainPattern = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;

    this.setState({
      CustomErrorMessageDomain: "",
      CustomSuccessMessageDomain: "",
      domain_reg_button: true,
    });

    // Empty input check
    if (!trimmed) {
      this.setState({
        CustomErrorMessageDomain: "Please enter a domain.",
        domain_reg_button: false,
      });
      setTimeout(() => {
        this.setState({ CustomErrorMessageDomain: "" });
      }, 3000);
      return;
    }

    // Format check
    if (!domainPattern.test(trimmed)) {
      this.setState({
        CustomErrorMessageDomain: "Invalid domain format (e.g. example.com).",
        domain_reg_button: false,
      });
      setTimeout(() => {
        this.setState({ CustomErrorMessageDomain: "" });
      }, 3000);
      return;
    }

    // Local duplicate check (for already visible list)
    if (allowed_domain_list.includes(trimmed)) {
      this.setState({
        CustomErrorMessageDomain: "Domain already added.",
        domain_reg_button: false,
      });
      setTimeout(() => {
        this.setState({ CustomErrorMessageDomain: "" });
      }, 3000);
      return;
    }

    // Call backend to add
    const servicesResponce = await addAllowedDomains(
      auth.getAccount(),
      auth.getToken(),
      [trimmed], // Only send the new domain, not full list
    );

    // console.log("addAllowedDomains response: ", servicesResponce.data);

    // Auth errors
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    }

    // Already exists
    if (servicesResponce.data.status === 409) {
      this.setState({
        CustomErrorMessageDomain: "This domain is already added.",
        domain_reg_button: false,
      });
      setTimeout(() => {
        this.setState({ CustomErrorMessageDomain: "" });
      }, 3000);
      return;
    }

    // General failure
    if (
      servicesResponce.data.status === 404 ||
      servicesResponce.data.status === 405
    ) {
      this.setState({
        CustomErrorMessageDomain: "Error while adding allowed domains.",
        domain_reg_button: false,
      });
      setTimeout(() => {
        this.setState({ CustomErrorMessageDomain: "" });
      }, 3000);
      return;
    }

    // Success case
    if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        CustomSuccessMessageDomain: "Allowed domain added successfully.",
        new_domain: "",
        domain_reg_button: false,
      });

      // Refetch only on success
      await this.get_allowed_domain();

      setTimeout(() => {
        this.setState({ CustomSuccessMessageDomain: "" });
      }, 3000);
    }
  };

  add_smtp_settings = async () => {
    let {
      smtp_host,
      smtp_user,
      smtp_password,
      smtp_method,
      smtp_port,
      from_email,
      notifications_email,
    } = this.state;
    this.setState({
      SmtpErrorMessage: "",
      SmtpSuccessMessage: "",
      smtp_reg_button: true,
      errorHostName: "",
      errorUser: "",
      errorPassword: "",
    });
    var is_validated = true;

    if (smtp_host === "") {
      this.setState({
        errorHostName: "error",
        SmtpErrorMessage: "SMTP host is required.",
        smtp_reg_button: false,
      });
      is_validated = false;
    } else if (smtp_host !== "") {
      if (this.validateDomain(smtp_host) === false) {
        this.setState({
          errorHostName: "error",
          SmtpErrorMessage: "Invalid domain/host format.",
          smtp_reg_button: false,
        });
        is_validated = false;
      }
    }

    if (smtp_user === "") {
      this.setState({
        errorUser: "error",
        SmtpErrorMessage: "Username is required.",
        smtp_reg_button: false,
      });
      is_validated = false;
    } else if (smtp_user !== "") {
      // if (this.validateEmailAdd(smtp_user) === false) {
      //   //console.log("smtp_user: ", smtp_user);
      //   this.setState({
      //     errorUser: "error",
      //     SmtpErrorMessage: "Invalid usernamt format.",
      //     smtp_reg_button: false,
      //   });
      //   is_validated = false;
      // }
    }
    if (smtp_password === "") {
      this.setState({
        errorPassword: "error",
        SmtpErrorMessage: "Password is required.",
        smtp_reg_button: false,
      });
      is_validated = false;
    }
    if (notifications_email === "") {
      this.setState({
        errorUser: "error",
        SmtpErrorMessage: "Notifications email is required.",
        smtp_reg_button: false,
      });
      is_validated = false;
    } else if (notifications_email !== "") {
      if (this.validateEmailAdd(notifications_email) === false) {
        //console.log("smtp_user: ", smtp_user);
        this.setState({
          errorUser: "error",
          SmtpErrorMessage: "Invalid notifications email format.",
          smtp_reg_button: false,
        });
        is_validated = false;
      }
    }
    if (is_validated) {
      const servicesResponce = await addSmtpSettings(
        auth.getAccount(),
        auth.getToken(),
        smtp_host,
        smtp_user,
        smtp_password,
        smtp_method,
        smtp_port,
        from_email,
        notifications_email,
      );
      //console.log("addSmtpSettings: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          SmtpErrorMessage: "There is some error while adding SMTP settings.",
          SmtpSuccessMessage: "",
          smtp_reg_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          SmtpErrorMessage: "",
          SmtpSuccessMessage: "SMTP settings added successfully.",
          smtp_reg_button: false,
        });
      } else {
        this.setState({
          SmtpErrorMessage: "There is some error while adding SMTP settings.",
          SmtpSuccessMessage: "",
          smtp_reg_button: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({ SmtpErrorMessage: "", SmtpSuccessMessage: "" });
    }, 5000);
  };

  //Test SMTP Settings

  verify_smtp_settings = async () => {
    let {
      smtp_host,
      smtp_user,
      smtp_password,
      smtp_method,
      smtp_port,
      from_email,
      notifications_email,
    } = this.state;
    this.setState({
      SmtpErrorMessage: "",
      SmtpSuccessMessage: "",
      smtp_test_button: true,
      errorHostName: "",
      errorUser: "",
      errorPassword: "",
    });
    var is_validated = true;

    if (smtp_host === "") {
      this.setState({
        errorHostName: "error",
        SmtpErrorMessage: "SMTP host is required.",
        smtp_test_button: false,
      });
      is_validated = false;
    } else if (smtp_host !== "") {
      if (this.validateDomain(smtp_host) === false) {
        this.setState({
          errorHostName: "error",
          SmtpErrorMessage: "Invalid domain/host format.",
          smtp_test_button: false,
        });
        is_validated = false;
      }
    }

    if (smtp_user === "") {
      this.setState({
        errorUser: "error",
        SmtpErrorMessage: "Username is required.",
        smtp_test_button: false,
      });
      is_validated = false;
    } else if (smtp_user !== "") {
      // if (this.validateEmailAdd(smtp_user) === false) {
      //   //console.log("smtp_user: ", smtp_user);
      //   this.setState({
      //     errorUser: "error",
      //     SmtpErrorMessage: "Invalid username (email) format.",
      //     smtp_test_button: false,
      //   });
      //   is_validated = false;
      // }
    }
    if (smtp_password === "") {
      this.setState({
        errorPassword: "error",
        SmtpErrorMessage: "Password is required.",
        smtp_test_button: false,
      });
      is_validated = false;
    }
    if (is_validated) {
      const servicesResponce = await verifySmtpSettings(
        auth.getAccount(),
        auth.getToken(),
        smtp_host,
        smtp_user,
        smtp_password,
        smtp_method,
        smtp_port,
        from_email,
        notifications_email,
      );
      // console.log("verifySmtpSettings: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          SmtpErrorMessage: "There is some error while testing SMTP settings.",
          SmtpSuccessMessage: "",
          smtp_test_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          SmtpErrorMessage: "",
          SmtpSuccessMessage: "SMTP settings tested successfully.",
          smtp_test_button: false,
          is_working: "yes",
        });
      } else {
        this.setState({
          SmtpErrorMessage: "There is some error while testing SMTP settings.",
          SmtpSuccessMessage: "",
          smtp_test_button: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({ SmtpErrorMessage: "", SmtpSuccessMessage: "" });
    }, 5000);
  };

  get_custom_settings = async () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await getCustomSettings(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("get_custom_settings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while getting custom settings.",
        successMessage: "",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success" &&
      Array.isArray(servicesResponce.data.data) &&
      servicesResponce.data.data.length > 0
    ) {
      const row = servicesResponce.data.data[0];
      this.setState({
        notification_sidebar: row.notification_sidebar,
        show_tutorial: row.show_tutorial,
        address_autocomplete: row.address_autocomplete,
        address_validation: row.address_validation,
        allowed_domain: row.allowed_domain,
        google_login: row.google_login,
        google_direct_registration: row.google_direct_registration,
        required_sub_user_type: row.required_sub_user_type,
        sales_order_sequence_no: row.sales_order_sequence_no || "",
        isEditorReady: true,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      (servicesResponce.data.message === "no_record" ||
        servicesResponce.data.message === "not_found" ||
        servicesResponce.data.message === "success")
    ) {
      // No custom settings record yet (or success with empty data) — show defaults.
      this.setState({
        notification_sidebar: "",
        show_tutorial: "",
        address_autocomplete: "",
        address_validation: "",
        allowed_domain: "",
        google_login: "",
        google_direct_registration: "",
        required_sub_user_type: "",
        sales_order_sequence_no: "",
        isEditorReady: true,
      });
    } else {
      this.setState({
        errorMessage: "There is some error while getting custom settings.",
        successMessage: "",
      });
    }
    //this.validateEmailAdd("sajid");
    const canEdit = UserPermissionHelper.getAllRoles(
      this.props.userRoleItems,
      "settings",
      "custom_settings",
    );
    // console.log("smtp_settings:", canEdit);

    if (canEdit && canEdit.length > 0) {
      this.setState({
        permission_custom_edit: canEdit[0].edit,
      });
    }
  };

  get_registration_settings = async () => {
    this.setState({
      registrationSettingsLoading: true,
      registrationSettingsErrorMessage: "",
      registrationSettingsSuccessMessage: "",
    });

    const response = await getClientRegistrationSettings(
      auth.getAccount(),
      auth.getToken(),
    );

    if (
      response.data.status === 403 ||
      response.data.errors === "authentication missing" ||
      response.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      response.data.status === 200 &&
      response.data.message === "success"
    ) {
      // Only configurable fields - email, password, confirm_password are always required (locked)
      const defaultFields = {
        name: "required",
        title: "required",
        client_company: "required",
        client_phone: "required",
        client_address: "required",
        client_address2: "required",
        client_city: "required",
        client_state: "required",
        client_zip: "required",
        client_country: "required",
      };

      const fields = response.data.fields || defaultFields;

      this.setState({
        registrationFields: fields,
        registrationSettingsLoading: false,
      });
    } else if (
      response.data.status === 200 &&
      response.data.message === "no_record"
    ) {
      // No settings found, use defaults
      this.setState({
        registrationFields: {
          name: "required",
          title: "required",
          client_company: "required",
          client_phone: "required",
          client_address: "required",
          client_address2: "required",
          client_city: "required",
          client_state: "required",
          client_zip: "required",
          client_country: "required",
        },
        registrationSettingsLoading: false,
      });
    } else {
      this.setState({
        registrationSettingsErrorMessage:
          "Error loading registration settings.",
        registrationSettingsLoading: false,
      });
    }

    // Get permissions
    const canEdit = UserPermissionHelper.getAllRoles(
      this.props.userRoleItems,
      "settings",
      "registration_settings",
    );

    if (canEdit && canEdit.length > 0) {
      this.setState({
        permission_registration_edit: canEdit[0].edit,
      });
    }
  };

  get_sharelink_settings = async () => {
    this.setState({ sharelinkTableLoader: true, sharelinkErrorMessage: "" });
    try {
      const response = await getSharelinks(auth.getAccount(), auth.getToken());
      if (
        response.data.status === 200 &&
        response.data.message === "success"
      ) {
        const rows = (response.data.data || []).map((item) => [
          item.agent_name,
          item.agent_email,
          item.title,
          item.date_added,
          item.is_default,
          item.main_sharelink,
          item.status,
          item.complete_link,
          item.link_identifier,
          item.link_hash,
          item.is_deleted,
        ]);
        // Sort so default sharelink (is_default = 1) appears at top
        const sortedRows = rows.sort((a, b) => {
          return b[4] - a[4]; // b[4] and a[4] are is_default values
        });
        this.setState({
          sharelinkTableData: sortedRows,
          sharelinkTableLoader: false,
        });
      } else if (
        response.data.status === 200 &&
        response.data.message === "not_found"
      ) {
        this.setState({ sharelinkTableData: [], sharelinkTableLoader: false });
      } else {
        this.setState({
          sharelinkTableData: [],
          sharelinkTableLoader: false,
          sharelinkErrorMessage:
            response.data.message || "Failed to load sharelinks.",
        });
      }
    } catch (e) {
      this.setState({
        sharelinkTableData: [],
        sharelinkTableLoader: false,
        sharelinkErrorMessage: "Error loading sharelink data.",
      });
    }
  };

  get_order_settings = async () => {
    this.setState({
      orderSettingsErrorMessage: "",
      orderSettingsSuccessMessage: "",
      orderSettingsTableLoader: true,
    });

    try {
      const response = await getOrdersSettings(auth.getAccount(), auth.getToken());

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (response.data.status === 200) {
        const normalizedSections = Array.isArray(response.data.order_settings)
          ? response.data.order_settings.map((section) => {
              const fields = section && section.fields ? section.fields : {};
              const descriptionField = fields.description || fields.reason || {};

              return {
                ...section,
                section_is_active:
                  typeof section.section_is_active === "boolean"
                    ? section.section_is_active
                    : true,
                fields: {
                  type: fields.type || { label: "Type", visible: true },
                  value: fields.value || { label: "Value", visible: true },
                  description: {
                    label: descriptionField.label || "Description",
                    visible:
                      typeof descriptionField.visible === "boolean"
                        ? descriptionField.visible
                        : true,
                  },
                },
              };
            })
          : [];

        this.setState({
          summarySections: normalizedSections,
          orderSettingsTableLoader: false,
        });
      } else {
        this.setState({
          orderSettingsErrorMessage: "Failed to load order settings.",
          orderSettingsTableLoader: false,
        });
      }
    } catch (e) {
      this.setState({
        orderSettingsErrorMessage: "Failed to load order settings.",
        orderSettingsTableLoader: false,
      });
    }
  };

  sharelinkModal_showRegenerate = () => {
    this.setState({
      sharelinkModalShow_regenerate:
        this.state.sharelinkModalShow_regenerate === "1" ? "" : "1",
      sharelinkModalSend_email: "0",
      sharelinkModalLinkErrorMessage: "",
      sharelinkModalLinkSuccessMessage: "",
    });
  };

  sharelinkModal_showEmail = () => {
    this.setState({
      sharelinkModalSend_email:
        this.state.sharelinkModalSend_email === "1" ? "0" : "1",
      sharelinkModalShow_regenerate: "",
      sharelinkModalEErrorMessage: "",
      sharelinkModalESuccessMessage: "",
    });
  };

  handleSharelinkModalNameChange = (e) => {
    this.setState({ sharelinkModalName: e.target.value });
  };

  handleSharelinkModalEmailChange = (e) => {
    this.setState({ sharelinkModalEmail_to: e.target.value });
  };

  handleSharelinkModalCommentChange = (e) => {
    this.setState({ sharelinkModalComment: e.target.value });
  };

  sharelinkModal_sendEmail = async () => {
    const {
      sharelinkModalEmail_to,
      sharelinkModalName,
      sharelinkModalComment,
      sharelinkModalLink,
    } = this.state;

    if (!sharelinkModalName) {
      this.setState({ sharelinkModalEErrorMessage: "Please enter the name." });
      return;
    }
    if (!sharelinkModalEmail_to || !/\S+@\S+\.\S+/.test(sharelinkModalEmail_to)) {
      this.setState({ sharelinkModalEErrorMessage: "Please enter a valid email address." });
      return;
    }
    if (!sharelinkModalComment) {
      this.setState({ sharelinkModalEErrorMessage: "Please enter a comment." });
      return;
    }

    this.setState({
      sharelinkModalReg_email_button: true,
      sharelinkModalEErrorMessage: "",
      sharelinkModalESuccessMessage: "",
    });

    try {
      const response = await sendSharelinkEmail(
        auth.getAccount(),
        auth.getToken(),
        sharelinkModalLink,
        sharelinkModalEmail_to,
        sharelinkModalName,
        sharelinkModalComment
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        response.data.status === 200 &&
        response.data.message === "success"
      ) {
        this.setState({
          sharelinkModalESuccessMessage: "Email sent successfully.",
          sharelinkModalReg_email_button: false,
          sharelinkModalEmail_to: "",
          sharelinkModalName: "",
          sharelinkModalComment: "",
          sharelinkModalSend_email: "0",
        });
      } else {
        this.setState({
          sharelinkModalEErrorMessage: response.data.data || "Failed to send email.",
          sharelinkModalReg_email_button: false,
        });
      }
    } catch (e) {
      this.setState({
        sharelinkModalEErrorMessage: "Failed to send email.",
        sharelinkModalReg_email_button: false,
      });
    }
  };

  save_registration_settings = async () => {
    window.scrollTo(0, 0);

    this.setState({
      registration_save_button: true,
      registrationSettingsErrorMessage: "",
      registrationSettingsSuccessMessage: "",
    });

    const { registrationFields } = this.state;

    const response = await saveClientRegistrationSettings(
      auth.getAccount(),
      auth.getToken(),
      registrationFields,
    );

    if (
      response.data.status === 403 ||
      response.data.errors === "authentication missing" ||
      response.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      response.data.status === 200 &&
      response.data.message === "success"
    ) {
      this.setState({
        registrationSettingsSuccessMessage:
          "Client registration settings saved successfully!",
        registration_save_button: false,
      });
    } else {
      this.setState({
        registrationSettingsErrorMessage:
          response.data.errors || "Error saving registration settings.",
        registration_save_button: false,
      });
    }

    setTimeout(() => {
      this.setState({
        registrationSettingsErrorMessage: "",
        registrationSettingsSuccessMessage: "",
      });
    }, 5000);
  };

  handleRegistrationFieldChange = (fieldName, value) => {
    this.setState((prevState) => {
      const updatedFields = {
        ...prevState.registrationFields,
        [fieldName]: value,
      };

      // When Address is turned OFF, automatically turn off related address fields
      if (fieldName === "client_address" && value === "optional") {
        updatedFields.client_address2 = "optional";
        updatedFields.client_city = "optional";
        updatedFields.client_state = "optional";
        updatedFields.client_zip = "optional";
        updatedFields.client_country = "optional";
      }

      return {
        registrationFields: updatedFields,
      };
    });
  };

  get_payment_settings = async () => {
    this.setState({
      paymentErrorMessage: "",
      paymentSuccessMessage: "",
      tableLoaderPayment: true,
    });
    const servicesResponce = await getPaymentSettings(
      auth.getAccount(),
      auth.getToken(),
    );
    //console.log("get_payment_settings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        paymentErrorMessage:
          "There is some error while getting payment settings.",
        paymentSuccessMessage: "",
        tableLoaderPayment: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        isEditorReady: true,
        bank_account_details: servicesResponce.data.bank_details,
        wire_transfer_details: servicesResponce.data.wire_transfer_details,

        tableLoaderPayment: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        isEditorReady: true,
        bank_account_details: "",
        wire_transfer_details: "",
        tableLoaderPayment: false,
      });
    } else {
      this.setState({
        paymentErrorMessage:
          "There is some error while getting payment settings.",
        paymentSuccessMessage: "",
        tableLoaderPayment: false,
      });
    }
    //this.validateEmailAdd("sajid");
    const canEdit = UserPermissionHelper.getAllRoles(
      this.props.userRoleItems,
      "settings",
      "payment_settings",
    );
    // console.log("smtp_settings:", canEdit);

    if (canEdit && canEdit.length > 0) {
      this.setState({
        permission_payment_edit: canEdit[0].edit,
      });
    }
  };

  add_payment_settings = async () => {
    let { bank_account_details, wire_transfer_details } = this.state;
    this.setState({
      paymentErrorMessage: "",
      paymentSuccessMessage: "",
      payment_reg_button: true,
    });
    var is_validated = true;

    if (bank_account_details === "") {
      this.setState({
        paymentErrorMessage: "Payment details are required.",
        payment_reg_button: false,
      });
      is_validated = false;
    }
    /*if (wire_transfer_details === "") {
      this.setState({
        paymentErrorMessage: "Wire transfer details are required.",
        payment_reg_button: false,
      });
      is_validated = false;
    }*/

    if (is_validated) {
      const servicesResponce = await addPaymentSettings(
        auth.getAccount(),
        auth.getToken(),
        bank_account_details,
        wire_transfer_details,
      );
      // console.log("add_payment_settings: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          paymentErrorMessage:
            "There is some error while adding payment settings.",
          paymentSuccessMessage: "",
          payment_reg_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          paymentErrorMessage: "",
          paymentSuccessMessage: "Payment settings added successfully.",
          payment_reg_button: false,
        });
      } else {
        this.setState({
          paymentErrorMessage:
            "There is some error while adding payment settings.",
          paymentSuccessMessage: "",
          payment_reg_button: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({ paymentErrorMessage: "", paymentSuccessMessage: "" });
    }, 5000);
  };

  get_other_settings = async () => {
    this.setState({
      clientNotes: "",
      otherSettingSuccessMessage: "",
      otherSettingErrorMessage: "",
      client_setting_button: false,
      tableLoaderNotes: true,
    });
    const notesResponce = await getClientNotes(
      auth.getAccount(),
      auth.getToken(),
    );

    //console.log("Client Notes  Res: ", notesResponce.data.data);

    if (
      notesResponce.data.status === 403 ||
      notesResponce.data.errors === "authentication missing" ||
      notesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (notesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      notesResponce.data.status === 200 &&
      notesResponce.data.message === "success"
    ) {
      this.setState({
        isEditorReady: true,
        clientNotes: notesResponce.data.data
          ? notesResponce.data.data.welcome_content || ""
          : "",
        tableLoaderNotes: false,
        client_setting_button: false,
      });
    } else {
      this.setState({
        isEditorReady: true,
        clientNotes: "",
        tableLoaderNotes: false,
        client_setting_button: false,
      });
    }
    const canEdit = UserPermissionHelper.getAllRoles(
      this.props.userRoleItems,
      "settings",
      "other_settings",
    );
    // console.log("other_settings:", canEdit);

    if (canEdit && canEdit.length > 0) {
      this.setState({
        permission_other_edit: canEdit[0].edit,
      });
    }
  };

  get_rfq_settings = async () => {
    this.setState({
      rfqSettingSuccessMessage: "",
      rfqSettingErrorMessage: "",
      rfq_setting_button: false,
      tableLoaderRfq: true,
    });
    const notesResponce = await getRFQSettings(
      auth.getAccount(),
      auth.getToken(),
    );

    // console.log("get_rfq_settings  Res: ", notesResponce.data);

    if (
      notesResponce.data.status === 403 ||
      notesResponce.data.errors === "authentication missing" ||
      notesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (notesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      notesResponce.data.status === 200 &&
      notesResponce.data.message === "success"
    ) {
      const rfq = notesResponce.data.data || null;
      this.setState({
        rfqSettingTitle: rfq ? rfq.title || "" : "",
        rfqSettingHeading: rfq ? rfq.heading || "" : "",
        rfqSettingDesc: rfq ? rfq.short_desc || "" : "",
        tableLoaderRfq: false,
        rfq_setting_button: false,
      });
    } else {
      this.setState({
        rfqSettingTitle: "",
        rfqSettingHeading: "",
        rfqSettingDesc: "",
        tableLoaderRfq: false,
        rfq_setting_button: false,
      });
    }
    const canEdit = UserPermissionHelper.getAllRoles(
      this.props.userRoleItems,
      "settings",
      "rfq_settings",
    );
    // console.log("rfq_settings:", canEdit);

    if (canEdit && canEdit.length > 0) {
      this.setState({
        permission_rfq_edit: canEdit[0].edit,
      });
    }
  };

  saveRfqSettings = async () => {
    window.scrollTo(0, 0);

    const { rfqSettingTitle, rfqSettingHeading, rfqSettingDesc } = this.state;
    var validated = true;
    if (rfqSettingTitle === "") {
      validated = false;
    } else if (rfqSettingHeading === "") {
      validated = false;
    } else if (rfqSettingDesc === "") {
      validated = false;
    } else {
      validated = true;
    }
    if (validated === false) {
      return this.setState({
        rfqSettingErrorMessage: "Please enter the required field.",
        rfqSettingSuccessMessage: "",
      });
    } else {
      // console.log(
      //   "saveRfqSettings Fields: " +
      //     rfqSettingTitle +
      //     " " +
      //     rfqSettingHeading +
      //     " " +
      //     rfqSettingDesc
      // );
      this.setState({
        rfqSettingErrorMessage: "",
        rfqSettingSuccessMessage: "",
        disabled: true,
        rfq_setting_button: true,
      });

      const saveResponce = await editRfqSettings(
        auth.getAccount(),
        auth.getToken(),
        rfqSettingTitle,
        rfqSettingHeading,
        rfqSettingDesc,
      );
      // console.log("editRfqSettings: ", saveResponce.data);
      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (saveResponce.data.status === 404) {
        // window.location.replace("/error");
        this.setState({
          rfqSettingErrorMessage:
            "There is some error while updating the RFQ settings.",
          rfqSettingSuccessMessage: "",
          disabled: false,
          rfq_setting_button: false,
        });
      } else if (
        saveResponce.data.status === 200 &&
        saveResponce.data.message === "success"
      ) {
        this.setState({
          rfqSettingErrorMessage: "",
          rfqSettingSuccessMessage: "RFQ settings updated successfully.",
          disabled: false,
          rfq_setting_button: false,
        });
        setTimeout(() => {
          this.setState({
            rfqSettingErrorMessage: "",
            rfqSettingSuccessMessage: "",
            disabled: false,
            rfq_setting_button: false,
          });
          this.get_rfq_settings();
        }, 3000);
      } else {
        this.setState({
          rfqSettingErrorMessage: saveResponce.data.message,
          rfqSettingSuccessMessage: "",
          disabled: false,
          rfq_setting_button: false,
        });
        //window.location.replace("/error");
      }
    }
  };

  saveClientNotes = async () => {
    window.scrollTo(0, 0);
    const clientNotes = this.state.clientNotes;
    var validated = true;
    if (clientNotes === "") {
      validated = false;
    }
    if (validated === false) {
      return this.setState({
        otherSettingErrorMessage: "Please enter the required field.",
        otherSettingSuccessMessage: "",
      });
    } else {
      this.setState({
        otherSettingErrorMessage: "",
        otherSettingSuccessMessage: "",
        disabled: true,
        client_setting_button: true,
      });

      const saveResponce = await editClientNotes(
        auth.getAccount(),
        auth.getToken(),
        clientNotes,
      );

      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (saveResponce.data.status === 404) {
        // window.location.replace("/error");
        this.setState({
          otherSettingErrorMessage:
            "There is some error while updating the Content.",
          otherSettingSuccessMessage: "",
          disabled: false,
          client_setting_button: false,
        });
      } else if (
        saveResponce.data.status === 200 &&
        saveResponce.data.message === "success"
      ) {
        this.setState({
          otherSettingErrorMessage: "",
          otherSettingSuccessMessage: "Content updated successfully.",
          disabled: false,
          client_setting_button: false,
        });
        setTimeout(() => {
          this.setState({
            otherSettingErrorMessage: "",
            otherSettingSuccessMessage: "",
            disabled: false,
            client_setting_button: false,
          });
          this.get_other_settings();
        }, 3000);
      } else {
        this.setState({
          otherSettingErrorMessage: saveResponce.data.message,
          otherSettingSuccessMessage: "",
          disabled: false,
          client_setting_button: false,
        });
        //window.location.replace("/error");
      }
    }
  };

  handleEditorClientNotes = (updatedContent) => {
    //console.log("updatedContent: ", updatedContent);
    this.setState({ clientNotes: updatedContent });
  };

  getInitialSelectedOption = (value) => {
    // Retrieve the initial selected option from your options array
    let options = this.getOption(); // Replace with your actual options array

    if (options) {
      return options.find((option) => option.value === value) || null;
    }
  };

  getInitialSelectedTermOption = (value) => {
    // Retrieve the initial selected option from your options array
    let options = this.getTermOptions(); // Replace with your actual options array

    if (options) {
      return options.find((option) => option.value === value) || null;
    }
  };

  getOption = () => {
    const currencyOptions = [
      { value: "usd", label: "USD - US Dollar" },
      /*{ value: "eur", label: "EUR - Euro" },
      { value: "gbp", label: "GBP - British Pound" },
      { value: "jpy", label: "JPY - Japanese Yen" },
      { value: "cny", label: "CNY - Chinese Yuan" },
      { value: "inr", label: "INR - Indian Rupee" },
      { value: "aud", label: "AUD - Australian Dollar" },
      { value: "cad", label: "CAD - Canadian Dollar" },
      { value: "chf", label: "CHF - Swiss Franc" },
      { value: "sek", label: "SEK - Swedish Krona" },
      { value: "nzd", label: "NZD - New Zealand Dollar" },
      { value: "sgd", label: "SGD - Singapore Dollar" },
      { value: "hkd", label: "HKD - Hong Kong Dollar" },
      { value: "krw", label: "KRW - South Korean Won" },
      { value: "brl", label: "BRL - Brazilian Real" },
      { value: "zar", label: "ZAR - South African Rand" },
      { value: "rub", label: "RUB - Russian Ruble" },
      { value: "try", label: "TRY - Turkish Lira" },
      { value: "mxn", label: "MXN - Mexican Peso" },
      { value: "idr", label: "IDR - Indonesian Rupiah" },*/
    ];
    return currencyOptions;
  };

  getTermOptions = () => {
    const currencyOptions = [
      { value: "Net 30", label: "Net 30" },
      { value: "Net 60", label: "Net 60" },
      { value: "Net 90", label: "Net 90" },
      { value: "Due on Receipt", label: "Due on Receipt" },
      { value: "2/10 Net 30", label: "2/10 Net 30" },
      { value: "1/10 Net 30", label: "1/10 Net 30" },
      { value: "2/10 Net 60", label: "2/10 Net 60" },
      { value: "3/10 Net 30", label: "3/10 Net 30" },
      { value: "Net 45", label: "Net 45" },
      { value: "Net 120", label: "Net 120" },
      { value: "Cash on Delivery (COD)", label: "Cash on Delivery (COD)" },
      { value: "Cash in Advance (CIA)", label: "Cash in Advance (CIA)" },
      { value: "Stage Payments", label: "Stage Payments" },
      { value: "End of Month (EOM)", label: "End of Month (EOM)" },
    ];
    return currencyOptions;
  };

  get_quotation_settings = async () => {
    this.setState({
      quotationErrorMessage: "",
      quotationSuccessMessage: "",
      tableLoaderQuote: true,
    });
    const servicesResponce = await getQuotationSettings(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("get_quotation_settings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        quotationErrorMessage:
          "There is some error while getting quotation settings.",
        quotationSuccessMessage: "",
        tableLoaderQuote: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success" &&
      Array.isArray(servicesResponce.data.quotationSettings) &&
      servicesResponce.data.quotationSettings.length > 0
    ) {
      const qs = servicesResponce.data.quotationSettings[0];
      this.setState({
        quotation_notes: qs["quotation_notes"],
        payment_terms: qs["payment_terms"],
        selected_payment_terms: this.getInitialSelectedTermOption(
          qs["payment_terms"],
        ),
        currency: qs["currency"],
        selected_currency: this.getInitialSelectedOption(qs["currency"]),
        contact_person: qs["contact_person"],
        contact_email: qs["contact_email"],
        validity: qs["validity"],
        decimalPoint: qs["decimal_point"],
        billing_decimalPoint: qs["billing_decimal_point"],
        isEditorReady: true,
        tableLoaderQuote: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      (servicesResponce.data.message === "not_found" ||
        servicesResponce.data.message === "no_record" ||
        servicesResponce.data.message === "success")
    ) {
      this.setState({
        quotation_notes: "",
        payment_terms: "",
        currency: "",
        contact_person: "",
        contact_email: "",
        validity: "",
        isEditorReady: true,
        tableLoaderQuote: false,
      });
    } else {
      this.setState({
        quotationErrorMessage:
          "There is some error while getting quotation settings.",
        quotationSuccessMessage: "",
        tableLoaderQuote: false,
      });
    }
    //this.validateEmailAdd("sajid");
    const canEdit = UserPermissionHelper.getAllRoles(
      this.props.userRoleItems,
      "settings",
      "quotation_settings",
    );
    // console.log("smtp_settings:", canEdit);

    if (canEdit && canEdit.length > 0) {
      this.setState({
        permission_quotation_edit: canEdit[0].edit,
      });
    }
  };

  add_quotation_settings = async () => {
    let {
      quotation_notes,
      payment_terms,
      currency,
      contact_person,
      contact_email,
      validity,
      decimalPoint,
      billing_decimalPoint,
    } = this.state;
    this.setState({
      quotationErrorMessage: "",
      quotationSuccessMessage: "",
      quotation_button: true,
    });

    document
      .getElementById("SettingsBlock")
      ?.scrollIntoView({ top: 0, behavior: "smooth" });

    var is_validated = true;

    /*if (quotation_notes === "") {
      this.setState({
        quotationErrorMessage: "Quotation notes are required.",
        quotation_button: false,
      });
      is_validated = false;
    } else if (payment_terms === "") {
      this.setState({
        quotationErrorMessage: "Payment terms are required.",
        quotation_button: false,
      });
      is_validated = false;
    }*/
    if (decimalPoint < 2 || decimalPoint > 6) {
      this.setState({
        quotationErrorMessage:
          "Please enter a number between 2 and 6 for decimal points.",
        quotation_button: false,
      });
      is_validated = false;
    }

    if (billing_decimalPoint < 2 || billing_decimalPoint > 6) {
      this.setState({
        quotationErrorMessage:
          "Please enter a number between 2 and 6 for billing decimal points.",
        quotation_button: false,
      });
      is_validated = false;
    }

    if (currency === "") {
      this.setState({
        quotationErrorMessage: "Please select a currency from drop down.",
        quotation_button: false,
      });
      is_validated = false;
    }

    if (is_validated) {
      const servicesResponce = await addQuotationSettings(
        auth.getAccount(),
        auth.getToken(),
        quotation_notes,
        payment_terms,
        currency,
        contact_person,
        contact_email,
        validity,
        decimalPoint,
        billing_decimalPoint,
      );
      // console.log("add_quotation_settings: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          quotationErrorMessage:
            "There is some error while adding quotation settings.",
          quotationSuccessMessage: "",
          quotation_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        Cookies.remove("decimalPoint__");
        Cookies.set(
          "decimalPoint__",
          CryptoJS.AES.encrypt(
            decimalPoint.toString(),
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );
        Cookies.remove("billing_decimalPoint__");

        Cookies.set(
          "billing_decimalPoint__",
          CryptoJS.AES.encrypt(
            billing_decimalPoint.toString(),
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );
        this.setState({
          quotationErrorMessage: "",
          quotationSuccessMessage:
            "Quotation settings added successfully. Please wait while we are refreshing the page.",
          quotation_button: false,
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        this.setState({
          quotationErrorMessage:
            "There is some error while adding quotation settings.",
          quotationSuccessMessage: "",
          quotation_button: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({ quotationErrorMessage: "", quotationSuccessMessage: "" });
    }, 5000);
  };

  get_commission_settings = async () => {
    this.setState({
      commissionErrorTitle: "",
      commissionErrorMessage: "",
      commissionSuccessMessage: "",
    });
    const servicesResponce = await getCommissionSettings(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("get_commission_settings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        commissionErrorTitle: "System Error",
        commissionErrorMessage:
          "There is some error while getting commission settings.",
        commissionSuccessMessage: "",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const cs =
        (servicesResponce.data.commissionSettings &&
          servicesResponce.data.commissionSettings[0]) ||
        null;
      if (cs) {
        this.setState({
          commission_type: cs["commission_type"],
          commission_value_type: cs["commission_value_type"],
          commission_value: cs["commission_value"],
          apply_commission: cs["apply_commission"],
          draw_threshold:
            cs["draw_threshold"] != null
              ? cs["draw_threshold"].toFixed(this.billing_decimalPoint)
              : "",
          isEditorReady: true,
        });
      } else {
        this.setState({ commission_value: "", isEditorReady: true });
      }
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        commission_value: "",
      });
    } else {
      this.setState({
        commissionErrorTitle: "System Error",
        commissionErrorMessage:
          "There is some error while getting commission settings.",
        commissionSuccessMessage: "",
      });
    }
    //this.validateEmailAdd("sajid");
    const canEdit = UserPermissionHelper.getAllRoles(
      this.props.userRoleItems,
      "settings",
      "commission_settings",
    );
    // console.log("commission_settings:", canEdit);

    if (canEdit && canEdit.length > 0) {
      this.setState({
        permission_commission_edit: canEdit[0].edit,
      });
    }
  };

  add_commission_settings = async () => {
    let {
      commission_type,
      commission_value_type,
      commission_value,
      apply_commission,
      draw_threshold,
    } = this.state;
    this.setState({
      commissionErrorTitle: "",
      commissionErrorMessage: "",
      commissionSuccessMessage: "",
      commission_button: true,
    });
    var is_validated = true;

    if (commission_value === "") {
      this.setState({
        commissionErrorTitle: "Missing Field",
        commissionErrorMessage: "Commission value is required.",
        commission_button: false,
      });
      is_validated = false;
    }

    if (is_validated) {
      const servicesResponce = await addCommissionSettings(
        auth.getAccount(),
        auth.getToken(),
        commission_type,
        commission_value_type,
        commission_value,
        apply_commission,
        draw_threshold,
      );
      // console.log("add_quotation_settings: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          commissionErrorTitle: "System Error",
          commissionErrorMessage:
            "There is some error while adding commission settings.",
          commissionSuccessMessage: "",
          commission_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          commissionErrorTitle: "",
          commissionErrorMessage: "",
          commissionSuccessMessage: "Commission settings added successfully.",
          commission_button: false,
        });
      } else {
        this.setState({
          commissionErrorTitle: "System Error",
          commissionErrorMessage:
            "There is some error while adding commission settings.",
          commissionSuccessMessage: "",
          commission_button: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({
        commissionErrorMessage: "",
        commissionErrorTitle: "",
        commissionSuccessMessage: "",
      });
    }, 5000);
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    const updateState = {
      [name]: value,
    };

    // Clear errors when user starts typing in onboarding fields
    if (name === "onboarding_title") {
      updateState.errorOnboardingTitle = false;
    }
    if (name === "onboarding_message") {
      updateState.errorOnboardingMessage = false;
    }

    this.setState(updateState);
  };

  handleMappedInputChange = (name) => (event) => {
    const { target } = event;
    this.handleChange({
      target: {
        ...target,
        name,
        value: target.value,
      },
    });
  };

  unlockSmtpCredentialInputs = () => {
    if (!this.state.smtpCredentialInputsReady) {
      this.setState({
        smtpCredentialInputsReady: true,
      });
    }
  };

  handleChangeSearch = async (changed_value) => {
    // console.log("handleChangeSearch: ", changed_value);
    if (changed_value) {
      this.setState((prevState) => ({
        currency: changed_value.value,
        selected_currency: changed_value,
      }));
    } else {
      this.setState({ selected_currency: null, currency: "" });
    }
  };

  handleChangeSearchTerms = async (changed_value) => {
    // console.log("handleChangeSearchTerms: ", changed_value);
    if (changed_value) {
      this.setState((prevState) => ({
        payment_terms: changed_value.value,
        selected_payment_terms: changed_value,
      }));
    } else {
      this.setState({ selected_payment_terms: null });
    }
  };

  handleEditorBank = (updatedContent) => {
    //console.log("updatedContent: ", updatedContent);
    this.setState({ bank_account_details: updatedContent });
  };

  handleEditorQuotationNotes = (updatedContent) => {
    //console.log("updatedContent: ", updatedContent);
    this.setState({ quotation_notes: updatedContent });
  };

  get_signatory_settings = async () => {
    this.setState({
      signatorySettingSuccessMessage: "",
      signatorySettingErrorMessage: "",
      signatorySettingNotFound: "",
      signatory_button: false,
      tableLoader: true,
    });
    const notesResponce = await getSignatorySettings(
      auth.getAccount(),
      auth.getToken(),
    );

    // console.log("get_signatory_settings: ", notesResponce.data.data);

    if (
      notesResponce.data.status === 403 ||
      notesResponce.data.errors === "authentication missing" ||
      notesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (notesResponce.data.status === 404) {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "settings",
        "company_profiles",
      );
      // console.log("company_profiles:", canEdit);

      this.setState({
        permission_profile_add:
          canEdit && canEdit.length > 0 ? canEdit[0].add : 1,
        permission_profile_edit:
          canEdit && canEdit.length > 0 ? canEdit[0].edit : 1,
        permission_profile_delete:
          canEdit && canEdit.length > 0 ? canEdit[0].delete : 1,
      });
      //window.location.replace("/error");
    } else if (
      notesResponce.data.status === 200 &&
      notesResponce.data.message === "success"
    ) {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "settings",
        "company_profiles",
      );
      // console.log("company_profiles:", canEdit);

      this.setState({
        permission_profile_add:
          canEdit && canEdit.length > 0 ? canEdit[0].add : 1,
        permission_profile_edit:
          canEdit && canEdit.length > 0 ? canEdit[0].edit : 1,
        permission_profile_delete:
          canEdit && canEdit.length > 0 ? canEdit[0].delete : 1,
      });
      this.setState({
        signatoryDetails: notesResponce.data.data,
        isEditorReady: true,
        tableLoader: false,
        columnsignatoryDetails: [
          {
            name: "name",
            label: "Name",
            options: {
              filter: true,
              sort: true,
              customBodyRender: (value, tableMeta) => {
                const row = this.state.signatoryDetails.find(
                  (item) => String(item.id) === String(tableMeta.rowData[9]),
                );
                const initials = this.getSignatoryInitials(value);
                return (
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div
                      style={{
                        width: 34,
                        height: 34,
                        borderRadius: 8,
                        background: "#6576ff",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        fontWeight: 700,
                        flexShrink: 0,
                      }}
                    >
                      {initials}
                    </div>
                    <div>
                      <div style={{ fontWeight: 600 }}>{value || "---"}</div>
                      <div style={{ fontSize: 12, color: "#8094ae" }}>
                        {row?.email || "---"}
                      </div>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "title",
            label: "Title",
          },
          {
            name: "company",
            label: "Company",
          },
          {
            name: "phone",
            label: "Phone",
            options: {
              customBodyRender: (value) => value || "---",
            },
          },
          {
            name: "address",
            label: "Location",
            options: {
              customBodyRender: (value) => value || "---",
            },
          },
          {
            name: "signature_image",
            label: "Signature",
            options: {
              customBodyRender: (value, tableMeta) => {
                return <div>{this.showSignature(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "dateAdded",
            label: "Date Added",
            options: {
              customBodyRender: (value) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },

          // {
          //   name: "id",
          //   label: "Actions",
          //   options: {
          //     customBodyRender: (value, tableMeta) => {
          //       return (
          //         <div>
          //           <div
          //             className="nk-tb-col nk-tb-col-tools"
          //             style={{ padding: "0px" }}
          //           >
          //             <ul className="nk-tb-actions gx-1">
          //               <li>
          //                 <div className="drodown">
          //                   <a
          //                     style={{ cursor: "pointer" }}
          //                     title="Other Actions"
          //                     className="dropdown-toggle btn btn-icon  btn-outline-light"
          //                     data-toggle="dropdown"
          //                   >
          //                     <em className="icon ni ni-more-h"></em>
          //                   </a>
          //                   <div className="dropdown-menu dropdown-menu-right">
          //                     <ul className="link-list-opt no-bdr">
          //                       <li>
          //                         <Tooltip
          //                           title="Delete Signatory"
          //                           placement="top"
          //                         >
          //                           <a
          //                             style={{ cursor: "pointer" }}
          //                             onClick={() =>
          //                               this.deleteSignatory(value)
          //                             }
          //                             disabled={
          //                               this.props.is_msa_signed === "No" ||
          //                               this.props.defaultSettings === "missing"
          //                                 ? true
          //                                 : false
          //                             }
          //                           >
          //                             <em className="icon ni ni-trash"></em>
          //                             <span>Delete</span>
          //                           </a>
          //                         </Tooltip>
          //                       </li>
          //                       <li>
          //                         <Tooltip
          //                           title="Update Signatory"
          //                           placement="top"
          //                         >
          //                           <a
          //                             style={{ cursor: "pointer" }}
          //                             onClick={() =>
          //                               this.updateSignatory(value)
          //                             }
          //                             disabled={
          //                               this.props.is_msa_signed === "No" ||
          //                               this.props.defaultSettings === "missing"
          //                                 ? true
          //                                 : false
          //                             }
          //                           >
          //                             <em className="icon ni ni-edit"></em>
          //                             <span>Update</span>
          //                           </a>
          //                         </Tooltip>
          //                       </li>
          //                     </ul>
          //                   </div>
          //                 </div>
          //               </li>
          //             </ul>
          //           </div>
          //         </div>
          //       );
          //     },
          //   },
          // },
          {
            name: "state",
            label: "state",
            options: {
              display: false,
              filter: false,
              sort: false,
            },
          },
          {
            name: "country",
            label: "country",
            options: {
              display: false,
              filter: false,
              sort: false,
            },
          },
          {
            name: "id",
            label: "id",
            options: {
              display: false,
              filter: false,
              sort: false,
            },
          },
          {
            name: "id",
            label: "Actions",
            options: {
              customBodyRender: (value) => {
                const isDisabled =
                  this.props.is_msa_signed === "No" ||
                  this.props.defaultSettings === "missing";

                return (
                  <>
                    {canEdit &&
                    canEdit.length > 0 &&
                    (canEdit[0].edit === 1 || canEdit[0].delete === 1) ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          minHeight: 36,
                        }}
                      >
                        {/* View */}
                        <Tooltip
                          title={
                            isDisabled
                              ? "Action disabled because MSA is not signed or default settings are missing."
                              : "View Profile"
                          }
                          placement="top"
                        >
                          <span
                            role="button"
                            tabIndex={0}
                            aria-disabled={isDisabled}
                            onClick={() => {
                              if (!isDisabled) this.viewSignatory(value);
                            }}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              cursor: isDisabled ? "not-allowed" : "pointer",
                              opacity: isDisabled ? 0.3 : 1,
                              paddingLeft: 5,
                            }}
                          >
                            <em
                              className="icon ni ni-eye text-info"
                              style={{ fontSize: 20 }}
                            />
                          </span>
                        </Tooltip>
                        {canEdit &&
                        canEdit.length > 0 &&
                        canEdit[0].edit === 1 ? (
                          <Tooltip
                            title={
                              isDisabled
                                ? "Action disabled because MSA is not signed or default settings are missing."
                                : "Update Signatory"
                            }
                            placement="top"
                          >
                            <span
                              role="button"
                              tabIndex={0}
                              aria-disabled={isDisabled}
                              onClick={() => {
                                if (!isDisabled) this.updateSignatory(value);
                              }}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                opacity: isDisabled ? 0.3 : 1,
                                borderLeft: "1px solid rgb(0 0 0 / 87%)",
                              }}
                            >
                              <em
                                className="icon ni ni-edit text-primary"
                                style={{ fontSize: 20 }}
                              />
                            </span>
                          </Tooltip>
                        ) : null}
                        {/* Delete */}
                        {canEdit &&
                        canEdit.length > 0 &&
                        canEdit[0].delete === 1 ? (
                          <Tooltip
                            title={
                              isDisabled
                                ? "Action disabled because MSA is not signed or default settings are missing."
                                : "Delete Signatory"
                            }
                            placement="top"
                          >
                            <span
                              role="button"
                              tabIndex={0}
                              aria-disabled={isDisabled}
                              onClick={() => {
                                if (!isDisabled) this.deleteSignatory(value);
                              }}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                opacity: isDisabled ? 0.3 : 1,
                                borderLeft: "1px solid rgb(0 0 0 / 87%)",
                              }}
                            >
                              <em
                                className="icon ni ni-trash text-danger"
                                style={{ fontSize: 20 }}
                              />
                            </span>
                          </Tooltip>
                        ) : null}
                      </div>
                    ) : (
                      "---"
                    )}
                  </>
                );
              },
            },
          },
        ],
      });
    } else {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "settings",
        "company_profiles",
      );
      // console.log("company_profiles:", canEdit);

      this.setState({
        permission_profile_add:
          canEdit && canEdit.length > 0 ? canEdit[0].add : 1,
        permission_profile_edit:
          canEdit && canEdit.length > 0 ? canEdit[0].edit : 1,
        permission_profile_delete:
          canEdit && canEdit.length > 0 ? canEdit[0].delete : 1,
      });
    }
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy");
  };

  getSignatorySignatureUrl = (signature) => {
    if (!signature) return "";
    if (String(signature).startsWith("http")) return signature;
    return APP_LIVE_URL + "files_data/nda_signatures/" + signature;
  };

  getSignatoryInitials = (name) => {
    if (!name) return "--";
    return name
      .split(" ")
      .map((item) => item && item[0])
      .filter(Boolean)
      .join("")
      .slice(0, 2)
      .toUpperCase();
  };

  getFilteredSignatoryDetails = () => {
    const { signatoryDetails, signatory_search } = this.state;
    if (!signatory_search) return signatoryDetails || [];

    const query = String(signatory_search).toLowerCase();
    return (signatoryDetails || []).filter((item) => {
      const name = (item?.name || "").toLowerCase();
      const company = (item?.company || "").toLowerCase();
      const email = (item?.email || "").toLowerCase();
      const title = (item?.title || "").toLowerCase();
      return (
        name.includes(query) ||
        company.includes(query) ||
        email.includes(query) ||
        title.includes(query)
      );
    });
  };

  getFilteredSharelinkData = () => {
    const { sharelinkTableData, sharelink_search } = this.state;
    if (!sharelink_search) return sharelinkTableData || [];

    const query = String(sharelink_search).toLowerCase();
    const filtered = (sharelinkTableData || []).filter((row) => {
      // row[0]=agent_name, row[1]=agent_email, row[2]=title
      const agentName = (row[0] || "").toLowerCase();
      const agentEmail = (row[1] || "").toLowerCase();
      const title = (row[2] || "").toLowerCase();
      return (
        agentName.includes(query) ||
        agentEmail.includes(query) ||
        title.includes(query)
      );
    });
    
    // Sort filtered results to keep default sharelink at top
    return filtered.sort((a, b) => {
      return b[4] - a[4]; // b[4] and a[4] are is_default values
    });
  };

  showSignature = (value, tableMeta) => {
    let signature = value;
    if (signature && signature !== "") {
      signature = this.getSignatorySignatureUrl(signature);
      return (
        <div>
          <img style={{ width: "120px" }} src={signature} alt="Signature"></img>
        </div>
      );
    } else {
      return "---";
    }
  };

  viewSignatory = async (signatory_id) => {
    const inList = (this.state.signatoryDetails || []).find(
      (item) => String(item.id) === String(signatory_id),
    );
    if (inList) {
      this.setState({ signatory_view_data: inList });
      window.$("#modalViewSignatory").modal("show");
    }

    const notesResponce = await getSignatorySettingsByID(
      auth.getAccount(),
      auth.getToken(),
      signatory_id,
    );

    if (
      notesResponce?.data?.status === 200 &&
      notesResponce?.data?.message === "success" &&
      notesResponce?.data?.data?.length > 0
    ) {
      this.setState({ signatory_view_data: notesResponce.data.data[0] });
      window.$("#modalViewSignatory").modal("show");
    }
  };

  defaultSharelink = async (value, tableMeta) => {
    const link_hash = tableMeta.rowData[9];
    const link_identifier = tableMeta.rowData[8];
    const sharelink_title = tableMeta.rowData[2];

    if (!link_hash || !link_identifier) {
      console.error("Missing link_hash or link_identifier");
      return;
    }

    // A soft-deleted sharelink (index 10) cannot be set as Default or Main.
    if (parseInt(tableMeta.rowData[10], 10) === 1) {
      this.setState({
        sharelinkModalLinkErrorMessage:
          "This sharelink has been deleted and cannot be set as a Default or Main Sharelink. Please restore the sharelink before proceeding.",
      });
      setTimeout(() => {
        this.setState({ sharelinkModalLinkErrorMessage: "" });
      }, 5000);
      return;
    }

    // Set loading state
    this.setState({ defaultSharelinkLoading: link_hash });

    try {
      const response = await setDefaultSharelink(
        auth.getAccount(),
        auth.getToken(),
        1,
        link_hash,
        link_identifier
      );

      if (
        response.data.status === 200 &&
        response.data.message === "success"
      ) {
        // Update table data immediately
        const currentData = this.state.sharelinkTableData || [];
        
        // Update is_default values: set selected to 1, others to 0
        const updatedData = currentData.map((row) => {
          const rowHash = row[8];
          if (rowHash === link_hash) {
            return [...row.slice(0, 4), 1, ...row.slice(5)]; // Update is_default to 1
          } else if (row[4] === 1 || row[4] === "1") {
            return [...row.slice(0, 4), 0, ...row.slice(5)]; // Update other defaults to 0
          }
          return row;
        });
        
        // Sort so default (is_default = 1) appears at top
        const sortedData = updatedData.sort((a, b) => {
          return b[4] - a[4];
        });
        
        this.setState({
          sharelinkTableData: sortedData,
          sharelinkActionSuccessMessage: `Sharelink "${sharelink_title}" is set to default`,
          sharelinkActionSuccessMessageTitle: sharelink_title,
          defaultSharelinkLoading: null,
        });
        
        // Reload page after showing success message
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        this.setState({
          sharelinkActionSuccessMessage: "",
          defaultSharelinkLoading: null,
        });
        this.setState({
          sharelinkModalLinkErrorMessage:
            response.data.message === "sharelink_deleted"
              ? "This sharelink has been deleted and cannot be set as a Default or Main Sharelink. Please restore the sharelink before proceeding."
              : response.data.message || "Failed to set default sharelink.",
        });
        setTimeout(() => {
          this.setState({ sharelinkModalLinkErrorMessage: "" });
        }, 3000);
      }
    } catch (e) {
      this.setState({
        sharelinkActionSuccessMessage: "",
        defaultSharelinkLoading: null,
      });
      this.setState({
        sharelinkModalLinkErrorMessage: "Error setting default sharelink.",
      });
      setTimeout(() => {
        this.setState({ sharelinkModalLinkErrorMessage: "" });
      }, 3000);
    }
  };

  restoreSharelinkFun = async (link_hash, link_identifier) => {
    if (!link_hash || !link_identifier) {
      console.error("Missing link_hash or link_identifier");
      return;
    }

    try {
      const response = await restoreSharelink(
        auth.getAccount(),
        auth.getToken(),
        link_hash,
        link_identifier
      );

      if (response.data.status === 200 && response.data.message === "success") {
        this.setState({
          sharelinkActionSuccessMessage: "Sharelink restored successfully.",
        });
        setTimeout(() => {
          this.setState({ sharelinkActionSuccessMessage: "" });
        }, 2000);
        this.get_sharelink_settings();
      } else if (response.data.message === "limit_exceeded") {
        this.setState({
          sharelinkActionErrorMessage:
            (response.data.errors && response.data.errors.message) ||
            "Cannot restore: the partner has reached their sharelink limit. Please increase the limit or delete an active sharelink before restoring.",
        });
        setTimeout(() => {
          this.setState({ sharelinkActionErrorMessage: "" });
        }, 5000);
      } else {
        this.setState({
          sharelinkActionErrorMessage:
            response.data.message || "Failed to restore sharelink.",
        });
        setTimeout(() => {
          this.setState({ sharelinkActionErrorMessage: "" });
        }, 3000);
      }
    } catch (e) {
      this.setState({
        sharelinkActionErrorMessage: "Error restoring sharelink.",
      });
      setTimeout(() => {
        this.setState({ sharelinkActionErrorMessage: "" });
      }, 3000);
    }
  };

  sharelinkModalSaveSettings = async () => {
    const { sharelinkModalMakeDefault, sharelinkModalMakeMain, sharelinkModalLinkHash, sharelinkModalLinkIdentifier } = this.state;

    if (!sharelinkModalLinkHash || !sharelinkModalLinkIdentifier) {
      this.setState({
        sharelinkModalLinkErrorMessage: "Missing sharelink information.",
      });
      setTimeout(() => {
        this.setState({ sharelinkModalLinkErrorMessage: "" });
      }, 3000);
      return;
    }

    // A soft-deleted sharelink (row index 10) cannot be set as Default or Main.
    const selectedModalRow = (this.state.sharelinkTableData || []).find(
      (r) => r[9] === sharelinkModalLinkHash
    );
    if (selectedModalRow && parseInt(selectedModalRow[10], 10) === 1) {
      this.setState({
        sharelinkModalLinkErrorMessage:
          "This sharelink has been deleted and cannot be set as a Default or Main Sharelink. Please restore the sharelink before proceeding.",
      });
      setTimeout(() => {
        this.setState({ sharelinkModalLinkErrorMessage: "" });
      }, 5000);
      return;
    }

    this.setState({ sharelinkModalSaveLoading: true });

    try {
      // Send checkbox state as 1 (checked) or 0 (unchecked)
      const makeDefaultValue = sharelinkModalMakeDefault ? 1 : 0;
      const makeMainValue = sharelinkModalMakeMain ? 1 : 0;
      
      const response = await setDefaultSharelink(
        auth.getAccount(),
        auth.getToken(),
        makeDefaultValue,
        makeMainValue,
        sharelinkModalLinkHash,
        sharelinkModalLinkIdentifier
      );

      if (response.data.status === 200 && response.data.message === "success") {
        this.setState({
          sharelinkModalLinkSuccessMessage: "Sharelink settings saved successfully.",
          sharelinkModalSaveLoading: false,
        });
        setTimeout(() => {
          this.setState({ sharelinkModalLinkSuccessMessage: "" });
          window.$("#modalSharelinkView").modal("hide");
          window.location.reload();
        }, 2000);
      } else {
        this.setState({
          sharelinkModalLinkErrorMessage:
            response.data.message === "sharelink_deleted"
              ? "This sharelink has been deleted and cannot be set as a Default or Main Sharelink. Please restore the sharelink before proceeding."
              : response.data.message || "Failed to save sharelink settings.",
          sharelinkModalSaveLoading: false,
        });
        setTimeout(() => {
          this.setState({ sharelinkModalLinkErrorMessage: "" });
        }, 3000);
      }
    } catch (error) {
      this.setState({
        sharelinkModalLinkErrorMessage: "Error saving sharelink settings.",
        sharelinkModalSaveLoading: false,
      });
      setTimeout(() => {
        this.setState({ sharelinkModalLinkErrorMessage: "" });
      }, 3000);
    }
  };

  sharelinkActionModalSaveSettings = async () => {
    const { sharelinkActionMakeDefault, sharelinkActionMakeMain, sharelinkActionLinkHash, sharelinkActionLinkIdentifier } = this.state;

    if (!sharelinkActionLinkHash || !sharelinkActionLinkIdentifier) {
      this.setState({
        sharelinkActionErrorMessage: "Missing sharelink information.",
      });
      setTimeout(() => {
        this.setState({ sharelinkActionErrorMessage: "" });
      }, 3000);
      return;
    }

    // A soft-deleted sharelink (row index 10) cannot be set as Default or Main.
    const selectedActionRow = (this.state.sharelinkTableData || []).find(
      (r) => r[9] === sharelinkActionLinkHash
    );
    if (selectedActionRow && parseInt(selectedActionRow[10], 10) === 1) {
      this.setState({
        sharelinkActionErrorMessage:
          "This sharelink has been deleted and cannot be set as a Default or Main Sharelink. Please restore the sharelink before proceeding.",
      });
      setTimeout(() => {
        this.setState({ sharelinkActionErrorMessage: "" });
      }, 5000);
      return;
    }

    this.setState({ sharelinkActionSaveLoading: true });

    try {
      // Send checkbox state as 1 (checked) or 0 (unchecked)
      const makeDefaultValue = sharelinkActionMakeDefault ? 1 : 0;
      const makeMainValue = sharelinkActionMakeMain ? 1 : 0;
      
      const response = await setDefaultSharelink(
        auth.getAccount(),
        auth.getToken(),
        makeDefaultValue,
        makeMainValue,
        sharelinkActionLinkHash,
        sharelinkActionLinkIdentifier
      );

      if (response.data.status === 200 && response.data.message === "success") {
        this.setState({
          sharelinkActionSuccessMessage: "Sharelink settings saved successfully.",
          sharelinkActionSaveLoading: false,
        });
        setTimeout(() => {
          this.setState({ sharelinkActionSuccessMessage: "" });
          window.$("#modalSharelinkAction").modal("hide");
          window.location.reload();
        }, 2000);
      } else {
        this.setState({
          sharelinkActionErrorMessage:
            response.data.message === "sharelink_deleted"
              ? "This sharelink has been deleted and cannot be set as a Default or Main Sharelink. Please restore the sharelink before proceeding."
              : response.data.message || "Failed to save sharelink settings.",
          sharelinkActionSaveLoading: false,
        });
        setTimeout(() => {
          this.setState({ sharelinkActionErrorMessage: "" });
        }, 3000);
      }
    } catch (error) {
      this.setState({
        sharelinkActionErrorMessage: "Error saving sharelink settings.",
        sharelinkActionSaveLoading: false,
      });
      setTimeout(() => {
        this.setState({ sharelinkActionErrorMessage: "" });
      }, 3000);
    }
  };

  addSignatoryForm = async () => {
    this.setState({
      signatorySettingSuccessMessage: "",
      signatorySettingErrorMessage: "",
      signatorySettingErrorTitle: "",
      signatorySettingNotFound: "",
      signatory_button: false,
      signatory_name: "",
      signatory_company: "",
      signatory_title: "",
      signatory_email: "",
      signatory_phone: "",
      signatory_address: "",
      signatory_address2: "",
      signatory_city: "",
      signatory_zip: "",
      signatory_state: "",
      signatory_country: "",
      add_picture: "",
      add_picture_name: "",
      isFileUploaded: false,
      add_picture_existing: "",
      add_picture_update: "",
      add_picture_name_update: "",
      brightness: 100,
      showBrightnessRange: false,
    });
    if (this.signatoryFileInputRef?.current) {
      this.signatoryFileInputRef.current.value = "";
    }
    window.$("#modalAddSignatory").modal("show");
  };

  fieldValidationUsername = () => {
    let {
      signatory_name,
      signatory_company,
      signatory_title,
      signatory_email,
      signatory_phone,
      signatory_address,
      signatory_address2,
      signatory_city,
      signatory_zip,
      signatory_state,
      signatory_country,
      add_picture_name,
      isFileUploaded,
    } = this.state;

    if (signatory_company === "") {
      this.setState({
        signatorySettingErrorMessage: "Company name is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_name === "") {
      this.setState({
        signatorySettingErrorMessage: "Legal name is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_title === "") {
      this.setState({
        signatorySettingErrorMessage: "Title is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_email === "") {
      this.setState({
        signatorySettingErrorMessage: "Email is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (ValidateEmail(signatory_email) === false) {
      this.setState({
        signatorySettingErrorMessage: "Invalid email format.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_phone === "") {
      this.setState({
        signatorySettingErrorMessage: "Phone is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (!this.isPhoneValid(signatory_phone)) {
      this.setState({
        signatorySettingErrorMessage: "Invalid phone format.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_address === "") {
      this.setState({
        signatorySettingErrorMessage: "Address is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_city === "") {
      this.setState({
        signatorySettingErrorMessage: "City is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_state === "") {
      this.setState({
        signatorySettingErrorMessage: "State is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
      // } else if (signatory_zip === "") {
      //   this.setState({
      //     signatorySettingErrorMessage: "Zip is required.",
      //     signatorySettingErrorTitle: "Missing Fields",
      //     signatory_button: false,
      //   });
      //   setTimeout(() => {
      //     this.setState({
      //       signatorySettingErrorTitle: "",
      //       signatorySettingErrorMessage: "",
      //     });
      //   }, 4000);
      //   return false;
    } else if (signatory_country === "") {
      this.setState({
        signatorySettingErrorMessage: "Country is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (add_picture_name === false) {
      this.setState({
        signatorySettingErrorMessage: "Signature is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else {
      this.setState({
        signatorySettingErrorMessage: "",
        signatorySettingErrorTitle: "",
        disabled: true,
      });
    }

    if (!isFileUploaded) {
      this.setState({
        signatorySettingErrorMessage: "Signature is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    }

    return true;
  };

  processSelectedSignatoryFile = (selectedFile, isUpdate = false) => {
    const addPictureKey = isUpdate ? "add_picture_update" : "add_picture";
    const addPictureNameKey = isUpdate
      ? "add_picture_name_update"
      : "add_picture_name";

    if (!selectedFile) {
      return; // No file selected
    }

    // File type validation
    const allowedFileTypes = [".png", ".jpg", ".jpeg"];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    // console.log("Selected file extension:", fileExtension);

    if (!allowedFileTypes.includes("." + fileExtension)) {
      // console.log("Invalid file type:", fileExtension);
      this.setState({
        signatorySettingErrorMessage:
          "Invalid file type. Please select a valid file format (e.g., .png, .jpg, .jpeg).",
        signatorySettingErrorTitle: "Invalid Type",
        [addPictureKey]: "",
        [addPictureNameKey]: "",
        ...(isUpdate ? {} : { isFileUploaded: false }),
      }, () => {
        // Scroll modal to top to show error after state update
        const modalId = isUpdate ? "modalUpdateSignatory" : "modalAddSignatory";
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      return;
    }

    // File size validation (e.g., limit to 5MB)
    const maxSizeBytes = 10 * 1024 * 1024; // 5MB
    // console.log("maxSizeBytes", maxSizeBytes);
    if (selectedFile.size > maxSizeBytes) {
      this.setState({
        signatorySettingErrorMessage:
          "File size exceeds the limit (10MB). Please choose a smaller file.",
        signatorySettingErrorTitle: "Error",
        ...(isUpdate ? {} : { isFileUploaded: false }),
      }, () => {
        // Scroll modal to top to show error after state update
        const modalId = isUpdate ? "modalUpdateSignatory" : "modalAddSignatory";
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      return;
    }

    // Clear any previous errors if file passes validations
    this.setState({
      [addPictureKey]: URL.createObjectURL(selectedFile),
      signatorySettingErrorTitle: "",
      [addPictureNameKey]: selectedFile.name,
      ...(isUpdate ? {} : { isFileUploaded: true }),
    });
  };

  handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    this.processSelectedSignatoryFile(selectedFile, false);
  };

  handleSignatoryDragOver = (e, isUpdate = false) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      [isUpdate ? "signatory_drag_over_update" : "signatory_drag_over"]: true,
    });
  };

  handleSignatoryDragLeave = (e, isUpdate = false) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      [isUpdate ? "signatory_drag_over_update" : "signatory_drag_over"]: false,
    });
  };

  handleSignatoryDrop = (e, isUpdate = false) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      [isUpdate ? "signatory_drag_over_update" : "signatory_drag_over"]: false,
    });
    const selectedFile = e?.dataTransfer?.files?.[0];
    if (selectedFile) {
      this.processSelectedSignatoryFile(selectedFile, isUpdate);
    }
  };

  clearSignatoryUpload = (isUpdate = false) => {
    if (isUpdate) {
      this.setState({ add_picture_update: "", add_picture_name_update: "" });
      if (this.signatoryFileInputUpdateRef?.current) {
        this.signatoryFileInputUpdateRef.current.value = "";
      }
      return;
    }

    this.setState({ add_picture: "", add_picture_name: "", isFileUploaded: false });
    if (this.signatoryFileInputRef?.current) {
      this.signatoryFileInputRef.current.value = "";
    }
  };

  downloadCroppedSignature = () => {
    if (!this.cropperRef?.current?.cropper) return;
    const cropper = this.cropperRef.current.cropper;
    const croppedCanvas = cropper.getCroppedCanvas();
    if (!croppedCanvas) return;
    const dataUrl = croppedCanvas.toDataURL("image/png");
    const anchor = document.createElement("a");
    anchor.href = dataUrl;
    anchor.download = "signature_resized.png";
    anchor.click();
  };

  /*handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      return; // No file selected
    }

    // File type validation
    const allowedFileTypes = [".png", ".jpg", ".jpeg"];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    if (!allowedFileTypes.includes(`.${fileExtension}`)) {
      this.setState({
        signatorySettingErrorMessage:
          "Invalid file type. Please select a valid file format.",
        signatorySettingErrorTitle: "Invalid Type",
        add_picture: "",
        add_picture_name: "",
      });
      return;
    }

    // File size validation (e.g., limit to 5MB)
    const maxSizeBytes = 5 * 1024 * 1024; // 5MB
    if (selectedFile.size > maxSizeBytes) {
      this.setState({
        signatorySettingErrorMessage:
          "File size exceeds the limit (5MB). Please choose a smaller file.",
        signatorySettingErrorTitle: "Size limit exceeded",
        add_picture: "",
        add_picture_name: "",
      });
      return;
    }

    // Image dimension validation
    const imageReader = new FileReader();

    imageReader.onload = (event) => {
      const image = new Image();
      image.src = event.target.result;

      // Define dimensions based on image type
      let maxWidth, maxHeight, minWidth, minHeight;

      maxWidth = 300;
      maxHeight = 66;
      minWidth = 200;
      minHeight = 44;

      // Wait for the image to be fully loaded before checking dimensions
      image.onload = () => {
        if (image.width > maxWidth || image.height > maxHeight) {
          this.setState({
            signatorySettingErrorMessage: `Image dimensions exceed the limit (${maxWidth}x${maxHeight}). Please choose a smaller image.`,
            signatorySettingErrorTitle: "Invalid Height/Width",
            add_picture: "",
            add_picture_name: "",
          });
        } else if (image.width < minWidth || image.height < minHeight) {
          this.setState({
            signatorySettingErrorMessage: `Image dimensions should be at least (${minWidth}x${minHeight}). Please choose a larger image.`,
            signatorySettingErrorTitle: "Invalid Height/Width",
            add_picture: "",
            add_picture_name: "",
          });
        } else {
          // Clear any previous errors
          this.setState({
            add_picture: selectedFile,
            signatorySettingErrorMessage: "",
            add_picture_name: selectedFile.name,
          });
        }
      };
    };

    imageReader.readAsDataURL(selectedFile);
  };*/

  submitSignatory = async () => {
    let {
      signatory_name,
      signatory_company,
      signatory_title,
      signatory_email,
      signatory_phone,
      signatory_address,
      signatory_address2,
      signatory_city,
      signatory_zip,
      signatory_state,
      signatory_country,
      signatory_status,
      add_picture,
      add_picture_name,
    } = this.state;
    this.setState({
      signatory_button: true,
    });
    // Scroll modal to top to show any errors
    const modal = document.getElementById("modalAddSignatory");
    if (modal) {
      modal.scrollTop = 0;
    }
    const croppedBlob = await this.getCroppedBlob();
    if (this.fieldValidationUsername() === true) {
      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
      formData.append("accountno", auth.getAccount());
      formData.append("file", croppedBlob, add_picture_name);
      formData.append("fileName", add_picture_name);
      formData.append("signatory_name", signatory_name);
      formData.append("signatory_company", signatory_company);
      formData.append("signatory_title", signatory_title);
      formData.append("signatory_email", signatory_email);
      formData.append("signatory_phone", signatory_phone);
      formData.append("signatory_address", signatory_address);
      formData.append("signatory_address2", signatory_address2);
      formData.append("signatory_city", signatory_city);
      formData.append("signatory_state", signatory_state);
      formData.append("signatory_zip", signatory_zip);
      formData.append("signatory_country", signatory_country);
      try {
        axios
          .post(
            process.env.REACT_APP_API_URL + "resellers/submit_signatory",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Credentials": true,
              },
            },
            {},
          )
          .then((response) => {
            // console.log("submitSignatory response.data : ", response.data);
            if (
              response.data.status === 404 &&
              response.data.message === "no_record"
            ) {
              this.setState({
                signatorySettingErrorMessage: "Record not found.",
                signatorySettingErrorTitle: "System Error",
                signatory_button: false,
                signatorySettingSuccessMessage: "",
              });
            } else if (response.data.status === 403) {
              this.setState({
                signatorySettingErrorTitle: "System Error",
                signatorySettingErrorMessage: response.data.message,
                signatory_button: false,
                signatorySettingSuccessMessage: "",
              });
            } else if (
              response.data.status === 409 &&
              response.data.message === "Address validation failed"
            ) {
              const formattedErrorMessage = response.data.errors
                ? String(response.data.errors).replace(/,/g, "<br />")
                : "Address validation failed";

              this.setState({
                signatorySettingErrorTitle: "Error",
                signatorySettingErrorMessage: formattedErrorMessage,
                signatory_button: false,
                signatorySettingSuccessMessage: "",
              });
            } else if (
              response.data.status === 200 &&
              response.data.message === "success"
            ) {
              this.setState({
                signatorySettingSuccessMessage:
                  "Comapny profile added successfully.",
                signatorySettingErrorMessage: "",
                signatorySettingErrorTitle: "",
                showLoginButton: true,
                signatory_title: "",
                add_picture: "",
                signatory_company: "",
                signatory_name: "",
                signatory_email: "",
                signatory_phone: "",
                signatory_address: "",
                signatory_address2: "",
                signatory_city: "",
                signatory_zip: "",
                signatory_state: "",
                signatory_country: "",
                brightness: "",
              });

              setTimeout(() => {
                this.get_signatory_settings();
                window.$("#modalAddSignatory").modal("hide");
              }, 3000);
            } else {
              this.setState({
                signatorySettingErrorTitle: "System Error",
                signatorySettingErrorMessage:
                  "There is some error while adding the comapny profile.",
                signatorySettingSuccessMessage: "",
                signatory_button: false,
              });
            }
          });
      } catch (error) {
        this.setState({
          signatorySettingErrorTitle: "System Error",
          signatorySettingErrorMessage:
            "There is some error while adding the comapny profile.",
          disabled: false,
          successMessage: "",
          signatory_button: false,
        });

        // console.log("catch : ", error);
      }
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
    }
  };

  deleteSignatory = async (signatory_id) => {
    this.setState({
      signatory_id: signatory_id,
      signatoryDeleteSuccessMessage: "",
      signatoryDeleteErrorMessage: "",
      signatoryDeleteErrorTitle: "",
      signatoryDeleteNotFound: "",
      signatory_button_delete: false,
    });
    window.$("#modalDeleteSignatory").modal("show");
  };

  closeViewSignatory = () => {
    this.setState({ signatory_view_data: null });
    window.$("#modalViewSignatory").modal("hide");
  };

  closeDeleteSignatory = () => {
    window.$("#modalDeleteSignatory").modal("hide");
  };

  submitDeleteSignatory = async () => {
    const { signatory_id } = this.state;
    this.setState({
      signatoryDeleteSuccessMessage: "",
      signatoryDeleteErrorMessage: "",
      signatoryDeleteErrorTitle: "",
      signatoryDeleteNotFound: "",
      signatory_button_delete: true,
    });
    const notesResponce = await deleteSignatorySettings(
      auth.getAccount(),
      auth.getToken(),
      signatory_id,
    );

    //console.log("get_signatory_settings: ", notesResponce.data.data);

    if (
      notesResponce.data.status === 403 ||
      notesResponce.data.errors === "authentication missing" ||
      notesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      notesResponce.data.status === 404 &&
      notesResponce.data.message === "not_found"
    ) {
      this.setState({
        signatoryDeleteSuccessMessage: "",
        signatoryDeleteErrorMessage: "Company profile not found.",
        signatoryDeleteErrorTitle: "Not Found",

        signatory_button_delete: false,
      });
    } else if (
      notesResponce.data.status === 200 &&
      notesResponce.data.message === "success"
    ) {
      this.setState({
        signatoryDeleteSuccessMessage: "Company profile deleted successfully.",
        signatoryDeleteErrorMessage: "",
        signatoryDeleteErrorTitle: "",
        signatory_button_delete: false,
      });
      setTimeout(() => {
        this.get_signatory_settings();
        window.$("#modalDeleteSignatory").modal("hide");
      }, 3000);
    } else {
      this.setState({
        signatoryDeleteSuccessMessage: "",
        signatoryDeleteErrorMessage:
          "There is some error while deleting the profile.",
        signatoryDeleteErrorTitle: "Error",

        signatory_button_delete: false,
      });
    }
  };

  handleEditorWire = (content, editor) => {
    this.setState({
      wire_transfer_details: content,
    });
    //console.log("Content was updated:", content);
  };

  validateIPAddress = (ipAddress) => {
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
    const isValid = ipRegex.test(ipAddress);
    //console.log(`Is IP Address valid? ${isValid}`);
    return isValid;
  };

  validateDomain = (domain) => {
    const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = domainRegex.test(domain);
    //console.log(`Is domain valid? ${isValid}`);
    if (isValid) {
      return true;
    }
    return false;
  };

  validateEmailAdd = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);
    //console.log("isValidEmail: " + " " + email + " = " + isValidEmail);
    if (isValidEmail) {
      return true;
    }
    return false;
  };

  onCrop = () => {
    if (!this.cropperRef?.current?.cropper) return;
    const cropper = this.cropperRef.current.cropper;
    const data = cropper.getCropBoxData();
    const cropSizeElement = document.getElementById("cropSize");
    if (cropSizeElement) {
      cropSizeElement.textContent = `Current Crop Size: W: ${Math.round(data.width)} x H: ${Math.round(data.height)}`;
    }
  };

  rotateImage = (degree) => {
    if (!this.cropperRef?.current?.cropper) return;
    const cropper = this.cropperRef.current.cropper;
    cropper.rotate(degree);
  };

  handleZoomIn = () => {
    if (!this.cropperRef?.current?.cropper) return;
    const cropper = this.cropperRef.current.cropper;
    cropper.zoom(0.1); // Adjust zoom factor as needed
  };

  handleZoomOut = () => {
    if (!this.cropperRef?.current?.cropper) return;
    const cropper = this.cropperRef.current.cropper;
    cropper.zoom(-0.1); // Adjust zoom factor as needed
  };

  flipBoth = () => {
    if (!this.cropperRef?.current?.cropper) return;
    const cropper = this.cropperRef.current.cropper;
    cropper.scale(-1);
  };

  flipHorizontal = () => {
    if (!this.cropperRef?.current?.cropper) return;
    const cropper = this.cropperRef.current.cropper;
    cropper.scale(-1, 1);
  };

  flipVertical = () => {
    if (!this.cropperRef?.current?.cropper) return;
    const cropper = this.cropperRef.current.cropper;
    cropper.scale(1, -1);
  };

  getCroppedBlob = () => {
    return new Promise((resolve, reject) => {
      const imageElement = this.cropperRef.current;

      if (imageElement && imageElement.cropper) {
        const cropper = imageElement.cropper;
        const croppedCanvas = cropper.getCroppedCanvas();

        if (croppedCanvas) {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = croppedCanvas.width;
          canvas.height = croppedCanvas.height;

          ctx.filter = `brightness(${this.state.brightness}%)`;
          ctx.drawImage(croppedCanvas, 0, 0, canvas.width, canvas.height);

          canvas.toBlob((blob) => {
            resolve(blob);
          }, "image/png");
        } else {
          reject(new Error("Failed to get cropped canvas."));
        }
      } else if (this.state.add_picture_existing) {
        fetch(this.state.add_picture_existing)
          .then((response) => response.blob())
          .then((blob) => resolve(blob))
          .catch((error) =>
            reject(new Error("Failed to fetch existing image.")),
          );
      } else {
        // Prevent rejection by resolving with null if no cropper and no existing image
        resolve(null);
      }
    });
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        // console.log("addressComponents", addressComponents);
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";

        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });

        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }

        this.setState({
          signatory_city: city && city !== "" ? city : "",
          signatory_state: state && state !== "" ? state : "",
          signatory_zip: zipCode && zipCode !== "" ? zipCode : "",
          signatory_country: country && country !== "" ? country : "",
          signatory_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          signatory_address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone),
      );
    } catch (error) {
      return false;
    }
  };

  handleReady = () => {
    if (!this.cropperRef?.current?.cropper) return;
    const cropper = this.cropperRef.current.cropper;
    const containerData = cropper.getContainerData();
    const imageData = cropper.getImageData();
    const canvasData = cropper.getCanvasData();
    const naturalW = imageData.naturalWidth;
    const naturalH = imageData.naturalHeight;

    // If the image is smaller than the container, show it at 1:1 pixel ratio
    // so it stays sharp and doesn't look blurry from upscaling
    if (naturalW <= containerData.width && naturalH <= containerData.height) {
      cropper.zoomTo(1); // 1:1 pixel ratio — no scaling
      // After zoom, re-read canvas data since it changed
      const updatedCanvas = cropper.getCanvasData();
      cropper.setCropBoxData({
        left: updatedCanvas.left,
        top: updatedCanvas.top,
        width: updatedCanvas.width,
        height: updatedCanvas.height,
      });
    } else {
      // Image is larger than container — fit crop box to the full visible canvas
      cropper.setCropBoxData({
        left: canvasData.left,
        top: canvasData.top,
        width: canvasData.width,
        height: canvasData.height,
      });
    }
  };

  handleResetCrop = () => {
    if (!this.cropperRef?.current?.cropper) return;
    const cropper = this.cropperRef.current.cropper;
    // Reset the crop box to its initial state
    cropper.reset();
    this.setState({ brightness: 100 }, () => {
      // After reset, re-fit crop box to full image
      this.handleReady();
    });
  };

  handleBrightnessChange = (e) => {
    this.setState({ brightness: parseInt(e.target.value) });
  };

  toggleBrightnessRange = () => {
    this.setState((prevState) => ({
      showBrightnessRange: !prevState.showBrightnessRange,
    }));
  };

  fieldUpdateValidationUsername = () => {
    let {
      signatory_name,
      signatory_company,
      signatory_title,
      signatory_email,
      signatory_phone,
      signatory_address,
      signatory_address2,
      signatory_city,
      signatory_zip,
      signatory_state,
      signatory_country,
      add_picture_name_update,
    } = this.state;

    if (signatory_company === "") {
      this.setState({
        signatorySettingErrorMessage: "Company name is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_name === "") {
      this.setState({
        signatorySettingErrorMessage: "Legal name is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_title === "") {
      this.setState({
        signatorySettingErrorMessage: "Title is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_email === "") {
      this.setState({
        signatorySettingErrorMessage: "Email is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (ValidateEmail(signatory_email) === false) {
      this.setState({
        signatorySettingErrorMessage: "Invalid email format.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_phone === "") {
      this.setState({
        signatorySettingErrorMessage: "Phone is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (!this.isPhoneValid(signatory_phone)) {
      this.setState({
        signatorySettingErrorMessage: "Invalid phone format.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_address === "") {
      this.setState({
        signatorySettingErrorMessage: "Address is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_city === "") {
      this.setState({
        signatorySettingErrorMessage: "City is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else if (signatory_state === "") {
      this.setState({
        signatorySettingErrorMessage: "State is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
      // } else if (signatory_zip === "") {
      //   this.setState({
      //     signatorySettingErrorMessage: "Zip is required.",
      //     signatorySettingErrorTitle: "Missing Fields",
      //     signatory_button: false,
      //   });
      //   setTimeout(() => {
      //     this.setState({
      //       signatorySettingErrorTitle: "",
      //       signatorySettingErrorMessage: "",
      //     });
      //   }, 4000);
      //   return false;
    } else if (signatory_country === "") {
      this.setState({
        signatorySettingErrorMessage: "Country is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
      //   this.setState({
        //     signatorySettingErrorMessage: "Invalid email format.",
        //     signatorySettingErrorTitle: "Missing Fields",
        //     signatory_button: false,
        //   }, () => {
        //     // Scroll modal to top to show error after state update
        //     const modal = document.getElementById("modalUpdateSignatory");
        //     if (modal) {
        //       modal.scrollTop = 0;
        //     }
        //   });
        //   setTimeout(() => {
        //     this.setState({
        //       signatorySettingErrorTitle: "",
        //       signatorySettingErrorMessage: "",
        //     });
        //   }, 4000);
        //   return false;
    } else if (add_picture_name_update === "") {
      this.setState({
        signatorySettingErrorMessage: "Signatory signature is required.",
        signatorySettingErrorTitle: "Missing Fields",
        signatory_button: false,
      }, () => {
        // Scroll modal to top to show error after state update
        const modal = document.getElementById("modalUpdateSignatory");
        if (modal) {
          modal.scrollTop = 0;
        }
      });
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
      return false;
    } else {
      this.setState({
        signatorySettingErrorMessage: "",
        signatorySettingErrorTitle: "",
        disabled: true,
      });
    }

    return true;
  };

  handleFileChangeUpdate = (e) => {
    const selectedFile = e.target.files[0];
    this.processSelectedSignatoryFile(selectedFile, true);
  };

  updateSignatory = async (signatory_id) => {
    this.setState({
      signatory_id: signatory_id,
      signatoryDeleteSuccessMessage: "",
      signatoryDeleteErrorMessage: "",
      signatoryDeleteErrorTitle: "",
      signatoryDeleteNotFound: "",
      signatory_button_delete: false,
      signatory_name: "",
      signatory_company: "",
      signatory_title: "",
      signatory_email: "",
      signatory_phone: "",
      signatory_address: "",
      signatory_address2: "",
      signatory_city: "",
      signatory_state: "",
      signatory_zip: "",
      signatory_country: "",
      add_picture: "",
      add_picture_name: "",
      isFileUploaded: false,
      add_picture_update: "",
      add_picture_name_update: "",
      add_picture_existing: "",
      brightness: 100,
      showBrightnessRange: false,
      signatorySettingSuccessMessage: "",
      signatorySettingErrorMessage: "",
      signatorySettingErrorTitle: "",
      signatory_button: false,
    });

    window.$("#modalUpdateSignatory").modal("show");

    const notesResponce = await getSignatorySettingsByID(
      auth.getAccount(),
      auth.getToken(),
      signatory_id,
    );

    //console.log("get_signatory_settings_by_id: ", notesResponce.data.data);

    if (
      notesResponce.data.status === 403 ||
      notesResponce.data.errors === "authentication missing" ||
      notesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (notesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      notesResponce.data.status === 200 &&
      notesResponce.data.message === "success" &&
      Array.isArray(notesResponce.data.data) &&
      notesResponce.data.data.length > 0
    ) {
      const signatoryData = notesResponce.data.data[0];
      this.setState({
        signatory_name: signatoryData.name,
        signatory_company: signatoryData.company,
        signatory_title: signatoryData.title,
        signatory_email: signatoryData.email || "",
        signatory_phone: signatoryData.phone || "",
        signatory_address: signatoryData.address || "",
        signatory_address2: signatoryData.addsignatory_address2 || "",
        signatory_city: signatoryData.city || "",
        signatory_state: signatoryData.state || "",
        signatory_zip: signatoryData.zip || "",
        signatory_country: signatoryData.country || "",
        // add_picture_update:
        //   APP_LIVE_URL +
        //   "files_data/nda_signatures/" +
        //   signatoryData.signature_image,
        add_picture_existing:
          APP_LIVE_URL +
          "files_data/nda_signatures/" +
          signatoryData.signature_image,
        add_picture_name_update: signatoryData.fileName,
        isEditorReady: true,
        tableLoader: false,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  submitUpdateSignatory = async () => {
    let {
      signatory_name,
      signatory_company,
      signatory_title,
      signatory_email,
      signatory_phone,
      signatory_address,
      signatory_address2,
      signatory_city,
      signatory_zip,
      signatory_state,
      signatory_country,
      signatory_id,
      add_picture_name_update,
      add_picture_existing,
      add_picture_update,
    } = this.state;
    this.setState({
      signatory_button: true,
    });
    // Scroll modal to top to show any errors
    const modal = document.getElementById("modalUpdateSignatory");
    if (modal) {
      modal.scrollTop = 0;
    }
    const croppedBlob = await this.getCroppedBlob();
    if (this.fieldUpdateValidationUsername() === true) {
      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
      formData.append("accountno", auth.getAccount());
      formData.append("signatory_name", signatory_name);
      formData.append("signatory_company", signatory_company);
      formData.append("signatory_title", signatory_title);
      formData.append("signatory_email", signatory_email);
      formData.append("signatory_phone", signatory_phone);
      formData.append("signatory_address", signatory_address);
      formData.append("signatory_address2", signatory_address2);
      formData.append("signatory_city", signatory_city);
      formData.append("signatory_state", signatory_state);
      formData.append("signatory_zip", signatory_zip);
      formData.append("signatory_country", signatory_country);
      formData.append("signatory_id", signatory_id);
      if (croppedBlob && add_picture_update) {
        // Append croppedBlob if available
        formData.append("file", croppedBlob, add_picture_name_update);
      } else {
        // Convert existing image URL to Blob and append
        try {
          const response = await fetch(add_picture_existing);
          const blob = await response.blob();
          formData.append("file", blob, add_picture_name_update);
        } catch (error) {
          console.error("Failed to fetch existing image:", error);
          this.setState({
            signatorySettingErrorTitle: "System Error",
            signatorySettingErrorMessage: "Failed to fetch existing image.",
            signatory_button: false,
          }, () => {
            // Scroll modal to top to show error after state update
            const modal = document.getElementById("modalUpdateSignatory");
            if (modal) {
              modal.scrollTop = 0;
            }
          });
          return; // Exit function if fetch fails
        }
      }
      formData.append("fileName", add_picture_name_update);
      try {
        axios
          .post(
            process.env.REACT_APP_API_URL + "resellers/submit_signatory_update",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Credentials": true,
              },
            },
            {},
          )
          .then((response) => {
            // console.log("submitSignatory response.data : ", response.data);
            if (
              response.data.status === 404 &&
              response.data.message === "no_record"
            ) {
              this.setState({
                signatorySettingErrorMessage: "Record not found.",
                signatorySettingErrorTitle: "System Error",
                signatory_button: false,
                signatorySettingSuccessMessage: "",
              }, () => {
                // Scroll modal to top to show error after state update
                const modal = document.getElementById("modalUpdateSignatory");
                if (modal) {
                  modal.scrollTop = 0;
                }
              });
            } else if (response.data.status === 403) {
              this.setState({
                signatorySettingErrorTitle: "System Error",
                signatorySettingErrorMessage: response.data.message,
                signatory_button: false,
                signatorySettingSuccessMessage: "",
              }, () => {
                // Scroll modal to top to show error after state update
                const modal = document.getElementById("modalUpdateSignatory");
                if (modal) {
                  modal.scrollTop = 0;
                }
              });
            } else if (
              response.data.status === 409 &&
              response.data.message === "Address validation failed"
            ) {
              const formattedErrorMessage = response.data.errors
                ? String(response.data.errors).replace(/,/g, "<br />")
                : "Address validation failed";

              this.setState({
                signatorySettingErrorTitle: "Error",
                signatorySettingErrorMessage: formattedErrorMessage,
                signatory_button: false,
                signatorySettingSuccessMessage: "",
              }, () => {
                // Scroll modal to top to show error after state update
                const modal = document.getElementById("modalUpdateSignatory");
                if (modal) {
                  modal.scrollTop = 0;
                }
              });
            } else if (
              response.data.status === 200 &&
              response.data.message === "success"
            ) {
              this.setState({
                signatorySettingSuccessMessage:
                  "Comapny profile updated successfully.",
                signatorySettingErrorMessage: "",
                signatorySettingErrorTitle: "",
                showLoginButton: true,
              });

              setTimeout(() => {
                this.get_signatory_settings();
                window.$("#modalUpdateSignatory").modal("hide");
              }, 3000);
            } else {
              this.setState({
                signatorySettingErrorTitle: "System Error",
                signatorySettingErrorMessage:
                  "There is some error while updating the company profile.",
                signatorySettingSuccessMessage: "",
                signatory_button: false,
              }, () => {
                // Scroll modal to top to show error after state update
                const modal = document.getElementById("modalUpdateSignatory");
                if (modal) {
                  modal.scrollTop = 0;
                }
              });
            }
          });
      } catch (error) {
        this.setState({
          signatorySettingErrorTitle: "System Error",
          signatorySettingErrorMessage:
            "There is some error while adding the company profile.",
          disabled: false,
          successMessage: "",
          signatory_button: false,
        }, () => {
          // Scroll modal to top to show error after state update
          const modal = document.getElementById("modalUpdateSignatory");
          if (modal) {
            modal.scrollTop = 0;
          }
        });

        // console.log("catch : ", error);
      }
      setTimeout(() => {
        this.setState({
          signatorySettingErrorTitle: "",
          signatorySettingErrorMessage: "",
        });
      }, 4000);
    }
  };

  onCropUpdate = () => {
    if (!this.cropperRef?.current?.cropper) return;
    const cropper = this.cropperRef.current.cropper;
    const data = cropper.getCropBoxData();
    const cropSizeElement = document.getElementById("cropSize");
    if (cropSizeElement) {
      cropSizeElement.textContent = `Current Crop Size: W: ${Math.round(data.width)} x H: ${Math.round(data.height)}`;
    }
  };

  togglePasswordVerify = () => {
    this.setState({
      passwordShownVerify: !this.state.passwordShownVerify,
    });
  };

  togglePassword = () => {
    const passwordVerifiedAt = localStorage.getItem("passwordVerifiedAt");
    const now = new Date();
    const verifiedTime = passwordVerifiedAt
      ? new Date(passwordVerifiedAt)
      : null;

    if (this.state.passwordShown) {
      this.setState({
        passwordShown: false,
        loginPasswordVerified: false,
      });
      //localStorage.removeItem("passwordVerifiedAt");
    } else {
      if (verifiedTime && (now - verifiedTime) / (1000 * 60) <= 30) {
        this.setState({
          passwordShown: true,
          loginPasswordVerified: true,
        });
      } else {
        this.setState({
          showPasswordVerificationModal: true,
          loginPassword: "",
          loginPasswordError: "",
          loginPasswordVerified: false,
        });
      }
    }
  };

  verifyLoginPassword = async () => {
    const { loginPassword } = this.state;

    this.setState({
      loginPasswordError: "",
      verifyingPassword: true,
    });

    if (loginPassword === "") {
      this.setState({
        loginPasswordError: "Password is required.",
        verifyingPassword: false,
      });
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "verify_password",
        {
          token: process.env.REACT_APP_API_TOKEN,
          api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
          accountno: auth.getAccount(),
          password: loginPassword,
        },
      );

      if (response.data.status === 200 && response.data.message === "success") {
        const now = new Date().toISOString();
        localStorage.setItem("passwordVerifiedAt", now);
        this.setState({
          loginPasswordVerified: true,
          passwordShown: true,
          showPasswordVerificationModal: false,
          loginPassword: "",
          verifyingPassword: false,
        });
      } else {
        this.setState({
          loginPasswordError: "Invalid password. Please try again.",
          verifyingPassword: false,
        });
      }
    } catch (error) {
      console.error("Password verification error:", error);
      this.setState({
        loginPasswordError: "Error verifying password. Please try again.",
        verifyingPassword: false,
      });
    }
  };

  // Function to close the modal
  closePasswordVerificationModal = () => {
    this.setState({
      showPasswordVerificationModal: false,
      loginPassword: "",
      loginPasswordError: "",
      verifyingPassword: false,
    });
  };

  // Function to handle login password input change
  handleLoginPasswordChange = (event) => {
    this.setState({
      loginPassword: event.target.value,
      loginPasswordError: "",
    });
  };

  // Function to handle Enter key press
  handleLoginPasswordKeyPress = (event) => {
    if (event.key === "Enter") {
      this.verifyLoginPassword();
    }
  };

  deleteDomainFun = (domain_id) => {
    this.setState({
      domain_id: domain_id,
      CustomErrorMessageDomainDel: "",
      CustomSuccessMessageDomainDel: "",
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  deleteOnboarding = (onboarding_id) => {
    this.setState({
      onboarding_id: onboarding_id,
      onboardingErrorMessageDelete: "",
      onboardingSuccessMessageDelete: "",
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  deleteOnboardingItem = async () => {
    this.setState({ isProcessing: true });
    const { onboarding_id, onboardingItems } = this.state;

    try {
      const updatedItems = onboardingItems.filter(
        (item) => item.id !== onboarding_id,
      );

      const saved = await this.saveOnboardingSettings({
        onboardingItemsOverride: updatedItems,
        shouldReload: false,
      });

      if (!saved) {
        this.setState({
          onboardingErrorMessageDelete:
            "Failed to delete onboarding item. Please try again.",
          isProcessing: false,
        });
        setTimeout(() => {
          this.setState({ onboardingErrorMessageDelete: "" });
        }, 3000);
        return;
      }

      this.setState({
        onboardingSuccessMessageDelete: "Onboarding item deleted successfully.",
        onboardingItems: updatedItems,
      });

      setTimeout(() => {
        window.$("#modalDeleteAlert").modal("hide");
        this.setState({
          onboardingSuccessMessageDelete: "",
          onboarding_id: "",
          isProcessing: false,
        });
      }, 2000);
    } catch (error) {
      this.setState({
        onboardingErrorMessageDelete: "Error failed to delete onboarding item.",
        isProcessing: false,
      });
      setTimeout(() => {
        this.setState({ onboardingErrorMessageDelete: "" });
      }, 3000);
    }
  };

  editOnboarding = (onboardingId) => {
    const { onboardingItems } = this.state;
    const itemToEdit = onboardingItems.find((item) => item.id === onboardingId);

    if (itemToEdit) {
      const normalizedAgreementSource = this.normalizeAgreementSource(
        itemToEdit.agreement_source,
        itemToEdit.sub_type,
      );

      this.setState({
        editOnboardingId: onboardingId,
        editOnboardingTitle: itemToEdit.title,
        editOnboardingForm: itemToEdit.form || "",
        editOnboardingAnswerType: itemToEdit.answerType || "",
        editOnboardingAllowSkip: itemToEdit.allowSkip || false,
        editOnboardingAllowEnable: itemToEdit.enable || false,
        editOnboardingIsEnabled:
          itemToEdit.isEnabled !== undefined && itemToEdit.isEnabled !== null
            ? itemToEdit.isEnabled
            : 1,
        editOnboardingAllowMultiple:
          itemToEdit.allow_multiple !== undefined
            ? itemToEdit.allow_multiple
            : 0,
        editOnboardingAllowAI: itemToEdit.allowAI || false,
        editOnboardingType:
          itemToEdit.type === "agreement" ? "agreement" : "form",
        editOnboardingAgreement: itemToEdit.agreement_accountno || "",
        editOnboardingAgreementTitle: itemToEdit.agreement_title || "",
        editOnboardingAgreementInstruction:
          itemToEdit.agreement_instruction || "",
        editOnboardingAgreementSource: normalizedAgreementSource,
        editOnboardingAgreementTab: normalizedAgreementSource || "Partner",
        questionErrorMessage: "",
        questionErrorMessageTitle: "",
        questionSuccessMessage: "",
        add_question_loader: false,
      });
      window.$("#modalEditOnboarding").modal("show");
    }
  };

  handleEditQuestionTextChange = (e) => {
    this.setState({
      editOnboardingTitle: e.target.value,
    });
  };

  handleEditQuestionDescriptionChange = (e) => {
    this.setState({
      editOnboardingDescription: e.target.value,
    });
  };

  submitEditOnboarding = () => {
    const {
      editOnboardingId,
      editOnboardingTitle,
      editOnboardingForm,
      editOnboardingAnswerType,
      editOnboardingAllowSkip,
      editOnboardingAllowEnable,
      editOnboardingIsEnabled,
      editOnboardingAllowMultiple,
      onboardingItems,
      addOnboardingType,
      editOnboardingType,
      editOnboardingAgreement,
      editOnboardingAgreementTitle,
      editOnboardingAgreementInstruction,
      editOnboardingAgreementSource,
    } = this.state;

    // Determine which tab is active: for add modal use addOnboardingType, for edit modal use editOnboardingType
    const itemExists = onboardingItems.some(
      (item) => item.id === editOnboardingId,
    );
    const activeType = itemExists ? editOnboardingType : addOnboardingType;

    // Validate title
    if (!editOnboardingTitle || editOnboardingTitle.trim() === "") {
      this.setState({
        questionErrorMessage: "Please enter an onboarding item title.",
        questionErrorMessageTitle: "Title Required",
        questionSuccessMessage: "",
        add_question_loader: false,
      });
      return;
    }

    if (activeType === "agreement") {
      // Validate agreement selection
      if (!editOnboardingAgreement || editOnboardingAgreement === "") {
        this.setState({
          questionErrorMessage: "Please select an agreement from the dropdown.",
          questionErrorMessageTitle: "Agreement Required",
          questionSuccessMessage: "",
          add_question_loader: false,
        });
        return;
      }

      const duplicateAgreement = onboardingItems.find(
        (item) =>
          item.type === "agreement" &&
          item.agreement_accountno === editOnboardingAgreement &&
          item.id !== editOnboardingId,
      );
      if (duplicateAgreement) {
        this.setState({
          questionErrorMessage:
            "This agreement is already added in another onboarding step.",
          questionErrorMessageTitle: "Duplicate Agreement",
          questionSuccessMessage: "",
          add_question_loader: false,
        });
        return;
      }
    } else {
      // Validate form selection
      if (!editOnboardingForm || editOnboardingForm === "") {
        this.setState({
          questionErrorMessage: "Please select a form from the dropdown.",
          questionErrorMessageTitle: "Form Required",
          questionSuccessMessage: "",
          add_question_loader: false,
        });
        return;
      }
    }

    this.setState({ add_question_loader: true });

    let updatedItems;
    let successMessage;

    if (itemExists) {
      // Update existing item
      updatedItems = onboardingItems.map((item) => {
        if (item.id !== editOnboardingId) return item;
        const base = {
          ...item,
          title: editOnboardingTitle,
          enable: editOnboardingAllowEnable,
          isEnabled: editOnboardingIsEnabled,
          allow_multiple: editOnboardingAllowMultiple,
        };
        if (activeType === "agreement") {
          return {
            ...base,
            type: "agreement",
            form: "",
            allowSkip: false,
            agreement_accountno: editOnboardingAgreement,
            agreement_title: editOnboardingAgreementTitle,
            agreement_instruction: editOnboardingAgreementInstruction,
            agreement_source: editOnboardingAgreementSource,
            sub_type: editOnboardingAgreementSource === "Client" ? "clients" : "partners",
          };
        }
        return {
          ...base,
          type: "form",
          form: editOnboardingForm,
          answerType: editOnboardingAnswerType,
          allowSkip: editOnboardingAllowSkip,
          agreement_accountno: "",
          agreement_title: "",
          agreement_instruction: "",
          agreement_source: "",
        };
      });
      successMessage = "Onboarding item updated successfully.";
    } else {
      // Add new item
      let newItem;
      if (activeType === "agreement") {
        newItem = {
          id: editOnboardingId,
          title: editOnboardingTitle,
          type: "agreement",
          form: "",
          answerType: "",
          allowSkip: false,
          enable: editOnboardingAllowEnable,
          isEnabled: editOnboardingIsEnabled,
          allow_multiple: 0,
          isLocked: false,
          agreement_accountno: editOnboardingAgreement,
          agreement_title: editOnboardingAgreementTitle,
          agreement_instruction: editOnboardingAgreementInstruction,
          agreement_source: editOnboardingAgreementSource,
          sub_type: editOnboardingAgreementSource === "Client" ? "clients" : "partners",
        };
      } else {
        newItem = {
          id: editOnboardingId,
          title: editOnboardingTitle,
          type: "form",
          form: editOnboardingForm,
          answerType: editOnboardingAnswerType,
          allowSkip: editOnboardingAllowSkip,
          enable: editOnboardingAllowEnable,
          isEnabled: editOnboardingIsEnabled,
          allow_multiple: editOnboardingAllowMultiple,
          isLocked: false,
          agreement_accountno: "",
          agreement_title: "",
          agreement_instruction: "",
        };
      }
      updatedItems = [...onboardingItems, newItem];
      successMessage = "Onboarding item added successfully.";
    }

    this.setState(
      {
        onboardingItems: updatedItems,
        questionErrorMessage: "",
        questionErrorMessageTitle: "",
        questionSuccessMessage: successMessage,
      },
      async () => {
        const saved = await this.saveOnboardingSettings({
          onboardingItemsOverride: updatedItems,
          shouldReload: false,
        });

        if (!saved) {
          this.setState({
            questionSuccessMessage: "",
            add_question_loader: false,
          });
          return;
        }

        setTimeout(() => {
          this.setState({
            questionErrorMessage: "",
            questionErrorMessageTitle: "",
            questionSuccessMessage: "",
            editOnboardingId: "",
            editOnboardingTitle: "",
            editOnboardingForm: "",
            editOnboardingAnswerType: "",
            editOnboardingAllowSkip: false,
            editOnboardingAllowEnable: false,
            editOnboardingIsEnabled: 1,
            editOnboardingAllowMultiple: 0,
            editOnboardingDescription: "",
            addOnboardingType: "form",
            editOnboardingType: "form",
            editOnboardingAgreement: "",
            editOnboardingAgreementTitle: "",
            editOnboardingAgreementInstruction: "",
            editOnboardingAgreementSource: "",
            addOnboardingAgreementTab: "Partner",
            editOnboardingAgreementTab: "Partner",
            add_question_loader: false,
          });
          window.$("#modalEditOnboarding").modal("hide");
          window.$("#modalAddOnboarding").modal("hide");
        }, 800);
      },
    );
  };

  closeModal = (modalId) => {
    this.setState({
      editQuestionErrorMessage: "",
      editQuestionSuccessMessage: "",
      editOnboardingId: "",
      editOnboardingTitle: "",
      editOnboardingForm: "",
      editOnboardingAnswerType: "",
      editOnboardingAllowSkip: false,
      editOnboardingAllowEnable: false,
      editOnboardingDescription: "",
      editOnboardingLoader: false,
      newQuestion: [],
      questionErrorMessage: "",
      questionErrorMessageTitle: "",
      questionSuccessMessage: "",
      add_question_loader: false,
      addOnboardingType: "form",
      editOnboardingType: "form",
      editOnboardingAgreement: "",
      editOnboardingAgreementTitle: "",
      editOnboardingAgreementInstruction: "",
      editOnboardingAgreementSource: "",
      addOnboardingAgreementTab: "Partner",
      editOnboardingAgreementTab: "Partner",
    });
    window.$("#" + modalId).modal("hide");
  };

  handleQuestionTextChange_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, questionText: e.target.value } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  handleAnswerTypeChange_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, answerType: e.target.value } : q,
    );
    this.setState({
      newQuestion: updatedQuestions,
      currentAnswerType: e.target.value,
    });
  };

  handleDynamicValue_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, dynamicValue: e.target.value } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  handleRequiredChange_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, required: e.target.value } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  handleAllowAIChange_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, allowAI: e.target.value } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  handleValidationValueChange_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, validationValue: e.target.value } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  handleMaxLengthChange_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, maxLength: e.target.value } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  handleInputFormatChange_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, inputFormat: e.target.value } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  handleOptionChange_new = (questionId, optionIndex, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) => {
      if (q.id === questionId) {
        const updatedOptions = [...q.options];
        updatedOptions[optionIndex] = e.target.value;
        return { ...q, options: updatedOptions };
      }
      return q;
    });
    this.setState({ newQuestion: updatedQuestions });
  };

  handleDeleteOption_new = (questionId, optionIndex) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) => {
      if (q.id === questionId) {
        const updatedOptions = q.options.filter((_, i) => i !== optionIndex);
        return { ...q, options: updatedOptions };
      }
      return q;
    });
    this.setState({ newQuestion: updatedQuestions });
  };

  handleAddOption_new = (questionId) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, options: [...q.options, ""] } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  handleFixedOption_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, answer: e.target.value } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  handleTextTypeChange_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, textType: e.target.value } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  handleTextOnlyChange_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, textOnly: e.target.value } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  handleTooltipChange_new = (questionId, e) => {
    const { newQuestion } = this.state;
    const updatedQuestions = newQuestion.map((q) =>
      q.id === questionId ? { ...q, tooltip: e.target.value } : q,
    );
    this.setState({ newQuestion: updatedQuestions });
  };

  submitNewQuestion = () => {
    const { newQuestion } = this.state;

    if (!newQuestion || newQuestion.length === 0) {
      this.setState({
        questionErrorMessage: "Please fill in the question details.",
        questionErrorMessageTitle: "Error",
        add_question_loader: false,
      });
      return;
    }

    const question = newQuestion[0];
    if (!question.questionText || question.questionText.trim() === "") {
      this.setState({
        questionErrorMessage: "Please enter the question text.",
        questionErrorMessageTitle: "Error",
        add_question_loader: false,
      });
      return;
    }

    this.setState({ add_question_loader: true });

    // API call placeholder
    setTimeout(() => {
      this.setState({
        questionSuccessMessage: "Question added successfully.",
        questionErrorMessage: "",
        questionErrorMessageTitle: "",
        add_question_loader: false,
      });

      setTimeout(() => {
        this.setState({
          newQuestion: [],
          questionSuccessMessage: "",
          questionErrorMessage: "",
        });
        window.$("#modalEditOnboarding").modal("hide");
      }, 2000);
    }, 1000);
  };

  // Onboarding Items Methods
  getOnboardingItems = async () => {
    try {
      const accountno = auth.getAccount();
      const token = localStorage.getItem("token");
      const response = await getOnboardingItems(accountno, token);

      // console.log("Get Onboarding Items Full Response:", response);
      // console.log("Response Status:", response?.status);
      // console.log("Response Data:", response?.data);

      if (response && response.status === 200) {
        const responseData = response.data;
        // console.log("Response Data Object:", responseData);

        let formattedItems = [];
        let onboardingTitle = "";
        let onboardingMessage = "";

        // Check if response status is success
        if (responseData.status === "success") {
          // The API returns: { status: "success", message: "...", data: [{ id, reseller_accountno, onboarding_template: { steps: [...], total_steps, progress, onboardingTitle, message } }] }
          let stepsData = null;

          // Check if data is an array with items
          if (
            responseData.data &&
            Array.isArray(responseData.data) &&
            responseData.data.length > 0
          ) {
            const templateContainer = responseData.data[0]?.onboarding_template;

            // Extract onboarding title and message - prioritize nested template, then fallback to top level
            // Check nested first since backend returns values there
            onboardingTitle =
              templateContainer?.onboardingTitle &&
              templateContainer.onboardingTitle !== null
                ? templateContainer.onboardingTitle
                : responseData.data[0]?.onboardingTitle &&
                    responseData.data[0].onboardingTitle !== null
                  ? responseData.data[0].onboardingTitle
                  : "";

            onboardingMessage =
              templateContainer?.message && templateContainer.message !== null
                ? templateContainer.message
                : responseData.data[0]?.message &&
                    responseData.data[0].message !== null
                  ? responseData.data[0].message
                  : "";

            // Get steps - check nested onboarding_template first (backend may return it nested)
            if (templateContainer) {
              if (templateContainer?.onboarding_template?.steps) {
                stepsData = templateContainer.onboarding_template.steps;
              } else {
                stepsData = templateContainer?.steps || null;
              }
            } else {
              // Fallback: try to get steps from top level
              stepsData = responseData.data[0]?.steps || null;
            }

            if (!stepsData) {
              // Additional fallback for old structure
              const stepsContainer = responseData.data[0]?.steps;
              if (
                stepsContainer &&
                stepsContainer.steps &&
                stepsContainer.steps.steps
              ) {
                stepsData = stepsContainer.steps.steps;
              } else if (stepsContainer && stepsContainer.steps) {
                stepsData = stepsContainer.steps;
              } else {
                stepsData = stepsContainer;
              }
            }
          }

          // console.log("Steps Data:", stepsData);

          // Handle array format (new - preserves exact order)
          if (stepsData && Array.isArray(stepsData)) {
            formattedItems = stepsData.map((stepData, index) => {
              const normalizedAgreementSource = this.normalizeAgreementSource(
                stepData.agreement_source,
                stepData.sub_type,
              );

              return {
                id: stepData.id || `step_${index + 1}`,
                title: stepData.title || "",
                form: stepData.form || "",
                allowSkip:
                  stepData.allowSkip === 1 || stepData.allowSkip === true
                    ? true
                    : false,
                enable:
                  stepData.enable === 1 ||
                  stepData.enable === true ||
                  stepData.isEnabled === 1 ||
                  stepData.isEnabled === true
                    ? true
                    : false,
                type: stepData.type || "",
                isFilled:
                  stepData.isFilled === 1 || stepData.isFilled === true
                    ? true
                    : false,
                isSkipped:
                  stepData.isSkipped === 1 || stepData.isSkipped === true
                    ? 1
                    : 0,
                isLocked: index < 1, // Only the first item is locked
                agreement_accountno: stepData.agreement_accountno || "",
                agreement_title: stepData.agreement_title || "",
                agreement_instruction: stepData.agreement_instruction || "",
                agreement_source: normalizedAgreementSource,
                sub_type:
                  normalizedAgreementSource === "Client"
                    ? "clients"
                    : normalizedAgreementSource === "Partner"
                      ? "partners"
                      : "",
              };
            });
          }
          // Handle object format with step titles as keys (legacy)
          else if (
            stepsData &&
            typeof stepsData === "object" &&
            !Array.isArray(stepsData)
          ) {
            formattedItems = Object.entries(stepsData).map(
              ([title, stepData], index) => {
                const normalizedAgreementSource = this.normalizeAgreementSource(
                  stepData.agreement_source,
                  stepData.sub_type,
                );

                return {
                  id: stepData.id || `step_${index + 1}`,
                  title: title.trim(),
                  form: stepData.form || "",
                  allowSkip:
                    stepData.allowSkip === 1 || stepData.allowSkip === true
                      ? true
                      : false,
                  enable:
                    stepData.enable === 1 ||
                    stepData.enable === true ||
                    stepData.isEnabled === 1 ||
                    stepData.isEnabled === true
                      ? true
                      : false,
                  type: stepData.type || "",
                  isFilled:
                    stepData.isFilled === 1 || stepData.isFilled === true
                      ? true
                      : false,
                  isSkipped:
                    stepData.isSkipped === 1 || stepData.isSkipped === true
                      ? 1
                      : 0,
                  isLocked: index < 1, // Only the first item is locked
                  agreement_accountno: stepData.agreement_accountno || "",
                  agreement_title: stepData.agreement_title || "",
                  agreement_instruction: stepData.agreement_instruction || "",
                  agreement_source: normalizedAgreementSource,
                  sub_type:
                    normalizedAgreementSource === "Client"
                      ? "clients"
                      : normalizedAgreementSource === "Partner"
                        ? "partners"
                        : "",
                };
              },
            );
          }
        }

        // console.log("Formatted Items:", formattedItems);

        if (formattedItems.length > 0) {
          this.setState({
            onboardingItems: formattedItems,
            newStepCounter: formattedItems.length,
            onboarding_title: onboardingTitle,
            onboarding_message: onboardingMessage,
          });
          // console.log("State Updated with items:", formattedItems);
        } else {
          console.warn("No items found in response");
          this.setState({
            onboardingItems: [],
            newStepCounter: 0,
            onboarding_title: onboardingTitle,
            onboarding_message: onboardingMessage,
          });
        }
      } else {
        console.warn(
          "Failed to fetch onboarding items - Invalid status:",
          response?.status,
        );
      }
    } catch (error) {
      console.error("Error fetching onboarding items:", error);
      console.error("Error Stack:", error.stack);
    }
  };

  addNewOnboardingStep = () => {
    const { newStepCounter } = this.state;
    const newId = uuid();

    // Set state for new onboarding item with empty values
    this.setState(
      {
        editOnboardingId: newId,
        editOnboardingTitle: "",
        editOnboardingForm: "",
        editOnboardingAnswerType: "",
        editOnboardingAllowSkip: false,
        editOnboardingAllowEnable: false,
        editOnboardingIsEnabled: 1,
        editOnboardingAllowMultiple: 0,
        editOnboardingAllowAI: false,
        addOnboardingType: "form",
        editOnboardingAgreement: "",
        editOnboardingAgreementTitle: "",
        editOnboardingAgreementInstruction: "",
        editOnboardingAgreementSource: "",
        addOnboardingAgreementTab: "Partner",
        editOnboardingAgreementTab: "Partner",
        questionErrorMessage: "",
        questionErrorMessageTitle: "",
        questionSuccessMessage: "",
        add_question_loader: false,
        newStepCounter: newStepCounter + 1,
      },
      () => {
        // Open modal after state is updated
        window.$("#modalAddOnboarding").modal("show");
      },
    );
  };

  updateOnboardingItemTitle = (itemId, newTitle) => {
    const { onboardingItems } = this.state;
    const updatedItems = onboardingItems.map((item) =>
      item.id === itemId ? { ...item, title: newTitle } : item,
    );
    this.setState({ onboardingItems: updatedItems });
  };

  deleteOnboardingStep = (itemId) => {
    const { onboardingItems } = this.state;
    const updatedItems = onboardingItems.filter((item) => item.id !== itemId);
    this.setState({ onboardingItems: updatedItems });
  };

  normalizeAgreementSource = (sourceValue, subTypeValue = "") => {
    const source = (sourceValue || "").toString().toLowerCase();
    const subType = (subTypeValue || "").toString().toLowerCase();

    if (
      source === "client" ||
      source === "clients" ||
      subType === "client" ||
      subType === "clients"
    ) {
      return "Client";
    }

    if (
      source === "partner" ||
      source === "partners" ||
      subType === "partner" ||
      subType === "partners"
    ) {
      return "Partner";
    }

    return "";
  };

  // Get available forms excluding forms already selected in other steps
  getAvailableFormsForStep = (currentStepId) => {
    const { onboardingItems, formsList } = this.state;

    // Get all form IDs already selected in other steps (excluding the current step)
    const selectedFormIds = onboardingItems
      .filter(
        (item) =>
          item.id !== currentStepId && item.form && item.form.trim() !== "",
      )
      .map((item) => item.form);

    // Filter formsList to exclude already selected forms
    const availableForms = formsList.filter(
      (form) => !selectedFormIds.includes(form.form_accountno),
    );

    return availableForms;
  };

  getAvailableAgreementsForStep = (currentStepId, sourceTab) => {
    const { onboardingItems, agreementsList } = this.state;
    const normalizedTab = this.normalizeAgreementSource(sourceTab);

    const selectedAgreementIds = onboardingItems
      .filter(
        (item) =>
          item.id !== currentStepId &&
          item.agreement_accountno &&
          item.agreement_accountno !== "",
      )
      .map((item) => item.agreement_accountno);

    return agreementsList.filter(
      (agreement) =>
        this.normalizeAgreementSource(agreement.source) === normalizedTab &&
        !selectedAgreementIds.includes(agreement.agreement_accountno),
    );
  };

  // Handle drag end for react-beautiful-dnd - preserves swap semantics
  handleOnboardingDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (source.index === destination.index) return;

    const { onboardingItems } = this.state;

    // Preserve current guard: never swap onto a locked item
    if (
      onboardingItems[destination.index] &&
      onboardingItems[destination.index].isLocked
    ) {
      return;
    }

    const swappedItems = this.swapItems(
      onboardingItems,
      source.index,
      destination.index,
    );
    this.setState({ onboardingItems: swappedItems }, () => {
      // Auto-save in the background; pass override since setState is async.
      // shouldReload: false keeps the UI in place (no page reload on drop) —
      // local state already reflects the new order.
      this.saveOnboardingSettings({
        onboardingItemsOverride: swappedItems,
        shouldReload: false,
      });
    });
  };

  // Swap two items in array - clean implementation
  swapItems = (array, index1, index2) => {
    const newArray = [...array];
    [newArray[index1], newArray[index2]] = [newArray[index2], newArray[index1]];
    return newArray;
  };

  saveOnboardingSettings = async (options = {}) => {
    const { onboardingItems: stateOnboardingItems, onboarding_title, onboarding_message } =
      this.state;
    const {
      onboardingItemsOverride = null,
      shouldReload = true,
    } = options;
    const onboardingItems = onboardingItemsOverride || stateOnboardingItems;
    const accountno = auth.getAccount();

    // Clear previous messages and errors
    this.setState({
      onboardingErrorMessage: "",
      onboardingErrorMessageTitle: "",
      onboardingSuccessMessage: "",
      onboardingItemsWithErrors: [],
      errorOnboardingTitle: "",
      errorOnboardingMessage: "",
      onboarding_save_loading: true,
    });

    // Validation 0: Check if title is empty
    if (!onboarding_title || onboarding_title.trim() === "") {
      this.setState({
        onboardingErrorMessageTitle: "Missing Title",
        onboardingErrorMessage: "Please enter an onboarding title.",
        errorOnboardingTitle: true,
        onboarding_save_loading: false,
      });
      return false;
    }

    // Validation 0b: Check if message is empty
    if (!onboarding_message || onboarding_message.trim() === "") {
      this.setState({
        onboardingErrorMessageTitle: "Missing Message",
        onboardingErrorMessage: "Please enter an onboarding message.",
        errorOnboardingMessage: true,
        onboarding_save_loading: false,
      });
      return false;
    }

    // Validation 1: Check for empty step titles
    const stepsWithoutTitle = onboardingItems.filter(
      (item) => !item.title || item.title.trim() === "",
    );

    if (stepsWithoutTitle.length > 0) {
      this.setState({
        onboardingErrorMessageTitle: "Empty Step Title",
        onboardingErrorMessage:
          "Some steps have empty titles. Please provide a title for each step before saving.",
        onboardingItemsWithErrors: stepsWithoutTitle.map((item) => item.id),
        onboarding_save_loading: false,
      });
      return false;
    }

    // Validation 2: Check for duplicate step names
    const stepNames = onboardingItems.map((item) =>
      item.title.trim().toLowerCase(),
    );
    const uniqueStepNames = new Set(stepNames);

    if (stepNames.length !== uniqueStepNames.size) {
      // Find all items that have duplicate names
      const itemsWithDuplicateNames = onboardingItems.filter((item) => {
        const count = stepNames.filter(
          (name) => name === item.title.trim().toLowerCase(),
        ).length;
        return count > 1;
      });

      this.setState({
        onboardingErrorMessageTitle: "Duplicate Steps",
        onboardingErrorMessage:
          "Duplicate step names found. Each step must have a unique name. Please rename the duplicate steps.",
        onboardingItemsWithErrors: itemsWithDuplicateNames.map(
          (item) => item.id,
        ),
        onboarding_save_loading: false,
      });
      return false;
    }

    // Validation 3: Check if any unlocked form-type step has an empty form field
    const unlockedItems = onboardingItems.filter((item) => !item.isLocked);
    const stepsWithoutForm = unlockedItems.filter(
      (item) =>
        item.type !== "agreement" && (!item.form || item.form.trim() === ""),
    );

    if (stepsWithoutForm.length > 0) {
      const stepNames = stepsWithoutForm
        .map((item) => `"${item.title}"`)
        .join(", ");
      this.setState({
        onboardingErrorMessageTitle: "Missing Form",
        onboardingErrorMessage: `The following steps are missing a form: ${stepNames}. Please select a form for each step before saving.`,
        onboardingItemsWithErrors: stepsWithoutForm.map((item) => item.id),
        onboarding_save_loading: false,
      });
      return false;
    }

    // Validation 4: Check if any unlocked agreement-type step has no agreement selected
    const stepsWithoutAgreement = unlockedItems.filter(
      (item) =>
        item.type === "agreement" &&
        (!item.agreement_accountno || item.agreement_accountno === ""),
    );

    if (stepsWithoutAgreement.length > 0) {
      const agreementStepNames = stepsWithoutAgreement
        .map((item) => `"${item.title}"`)
        .join(", ");
      this.setState({
        onboardingErrorMessageTitle: "Missing Agreement",
        onboardingErrorMessage: `The following steps are missing an agreement: ${agreementStepNames}. Please select an agreement for each step before saving.`,
        onboardingItemsWithErrors: stepsWithoutAgreement.map((item) => item.id),
        onboarding_save_loading: false,
      });
      return false;
    }

    // Convert onboarding items to JSON format as ordered array to preserve exact arrangement
    const stepsArray = [];
    let isFilled = 0;

    onboardingItems.forEach((item, index) => {
      let isEnabled =
        item.isEnabled !== undefined && item.isEnabled !== null
          ? item.isEnabled
          : item.enable
            ? 1
            : 0;

      // First step is always "basic" and locked
      if (index === 0) {
        stepsArray.push({
          id: item.id || uuid(),
          title: item.title,
          form: item.form || "",
          allowSkip: 0,
          isEnabled: 1,
          isFilled: 1,
          type: "basic",
          formToken: "",
          isSkipped: 0,
          allow_multiple: 0,
          form_desc: "",
          formFilledDate: "",
        });
        isFilled++;
        return;
      }

      // Agreement-type steps use the agreement JSON structure
      if (item.type === "agreement") {
        stepsArray.push({
          id: item.id || uuid(),
          title: item.title,
          type: "agreement",
          sub_type: item.sub_type || (item.agreement_source === "Client" ? "clients" : "partners"),
          agreement_title: item.agreement_title || "",
          agreement_instruction: item.agreement_instruction || "",
          agreement_accountno: item.agreement_accountno || "",
          is_signed: "No",
          allowSkip: 0,
          isEnabled: isEnabled,
          isFilled: 0,
          isSkipped: 0,
          form: "",
          formToken: "",
          allow_multiple: 0,
          form_desc: "",
          formFilledDate: "",
        });
        return;
      }

      // Form-type steps
      stepsArray.push({
        id: item.id || uuid(),
        title: item.title,
        form: item.form || "",
        allowSkip: item.allowSkip ? 1 : 0,
        isEnabled: isEnabled,
        isFilled: 0,
        type: "form",
        formToken: "",
        isSkipped: item.isSkipped || 0,
        allow_multiple:
          item.allow_multiple !== undefined ? item.allow_multiple : 0,
        form_desc: "",
        formFilledDate: "",
      });
    });

    // Send as ordered array to preserve exact arrangement
    // Title and message at top level, steps inside onboarding_template
    const onboardingData = {
      onboardingTitle: onboarding_title,
      message: onboarding_message,
      onboarding_template: {
        steps: stepsArray,
        total_steps: onboardingItems.length,
        progress: isFilled,
      },
    };

    try {
      // Send to database via API
      const token = localStorage.getItem("token"); // Retrieve token from localStorage
      const response = await OnboardingSaveSettings(
        accountno,
        token,
        onboardingData,
      );

      if (response && response.data && response.data.status === "success") {
        this.setState({
          onboardingSuccessMessage: "Onboarding settings saved successfully!",
          onboardingItemsWithErrors: [],
          onboarding_save_loading: false,
        });
        if (shouldReload) {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
        return true;
      } else {
        console.warn("Response did not match success criteria:", response);
        this.setState({
          onboardingErrorMessageTitle: "Save Failed",
          onboardingErrorMessage:
            "Failed to save onboarding settings. Please try again.",
          onboarding_save_loading: false,
        });
        return false;
      }
    } catch (error) {
      console.error("Error saving onboarding settings:", error);
      this.setState({
        onboardingErrorMessageTitle: "Error",
        onboardingErrorMessage:
          "An error occurred while saving settings: " + error.message,
        onboarding_save_loading: false,
      });
      return false;
    }
  };

  deleteDomain = async () => {
    this.setState({
      isProcessing: true,
      CustomErrorMessageDomainDel: "",
      CustomSuccessMessageDomainDel: "",
    });

    const { domain_id } = this.state;

    const servicesResponse = await deleteAllowedDomain(
      auth.getAccount(),
      auth.getToken(),
      domain_id,
    );

    const { status, message, errors } = servicesResponse.data;

    // Handle auth issues
    if (
      status === 403 ||
      errors === "authentication missing" ||
      errors === "jwt expired"
    ) {
      auth.logout();
      return;
    }

    // Handle domain not found
    if (status === 404 || message === "not_found") {
      this.setState({
        CustomErrorMessageDomainDel: "Domain not found or already deleted.",
        isProcessing: false,
      });
      setTimeout(() => {
        this.setState({ CustomErrorMessageDomainDel: "" });
      }, 4000);
      return;
    }

    // Handle success
    if (status === 200 && message === "success") {
      this.setState({
        CustomSuccessMessageDomainDel: "Domain deleted successfully.",
        isProcessing: false,
      });

      setTimeout(() => {
        window.$("#modalDeleteAlert").modal("hide");
        this.setState({ CustomSuccessMessageDomainDel: "" });
        this.get_allowed_domain(); // Refresh domain list
      }, 3000);
      return;
    }

    // Handle unexpected error
    this.setState({
      CustomErrorMessageDomainDel:
        "An unexpected error occurred while deleting the domain.",
      isProcessing: false,
    });
    setTimeout(() => {
      this.setState({ CustomErrorMessageDomainDel: "" });
    }, 4000);
  };

  saveEditedDomain = async (domain_id) => {
    const newDomain = (this.state.editingDomainValue || "").trim();
    const domainPattern = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;

    if (!domainPattern.test(newDomain)) {
      this.setState({
        CustomErrorMessageDomain: "Invalid domain format (e.g. example.com).",
      });
      setTimeout(() => {
        this.setState({ CustomErrorMessageDomain: "" });
      }, 3000);
      return;
    }

    const response = await updateAllowedDomain(
      auth.getAccount(),
      auth.getToken(),
      domain_id,
      newDomain,
    );

    if (response.data.status === 403) return auth.logout();

    if (response.data.status === 409) {
      this.setState({
        CustomErrorMessageDomain: "This domain already exists.",
      });
      setTimeout(() => this.setState({ CustomErrorMessageDomain: "" }), 3000);
      return;
    }

    if (response.data.status === 200 && response.data.message === "success") {
      this.setState({
        CustomSuccessMessageDomain: "Domain updated successfully.",
        editingDomainId: null,
        editingDomainValue: "",
      });
      this.get_allowed_domain();
      setTimeout(() => {
        this.setState({ CustomSuccessMessageDomain: "" });
      }, 3000);
    } else {
      this.setState({
        CustomErrorMessageDomain:
          "There was an error while updating the domain.",
      });
      setTimeout(() => {
        this.setState({ CustomErrorMessageDomain: "" });
      }, 3000);
    }
  };

  handleChangeCountry = (event) => {
    const country = event.label;
    this.setState({
      signatory_country: country,
    });
  };

  // Order Settings Methods
  openAddSummarySectionModal = () => {
    this.setState(
      {
        showAddSummarySectionModal: true,
        summarySection_title: "",
        summarySection_type: "ADD",
        summarySection_fields: {
          type: { label: "Type", visible: true },
          value: { label: "Value", visible: true },
          description: { label: "Description", visible: false },
        },
        summarySection_title_error: "",
        summarySection_type_error: "",
      },
      () => {
        // Open modal after state is updated
        window.$("#modalAddSummarySection").modal("show");
      },
    );
  };

  closeAddSummarySectionModal = () => {
    window.$("#modalAddSummarySection").modal("hide");
    this.setState({
      showAddSummarySectionModal: false,
      summarySection_title: "",
      summarySection_type: "SUBTRACT",
      summarySection_module_type: "DISCOUNT",
      summarySection_scope: "PERCENTAGE",
      summarySection_fields: {
        type: { label: "Type", visible: true },
        value: { label: "Value", visible: true },
        description: { label: "Description", visible: true },
      },
      summarySection_title_error: "",
      summarySection_type_error: "",
    });
  };

  handleSummarySectionTitleChange = (e) => {
    this.setState({
      summarySection_title: e.target.value,
      summarySection_title_error: "",
    });
  };

  handleSummarySectionTypeChange = (value) => {
    this.setState({
      summarySection_type: value,
      summarySection_type_error: "",
    });
  };

  handleSummarySectionModuleTypeChange = (e) => {
    this.setState({ summarySection_module_type: e.target.value });
  };

  handleSummarySectionScopeChange = (e) => {
    this.setState({ summarySection_scope: e.target.value });
  };

  handleFieldVisibilityToggle = (fieldName) => {
    this.setState((prevState) => ({
      summarySection_fields: {
        ...prevState.summarySection_fields,
        [fieldName]: {
          ...prevState.summarySection_fields[fieldName],
          visible: !prevState.summarySection_fields[fieldName].visible,
        },
      },
    }));
  };

  // Edit Summary Section Methods
  openEditSummarySectionModal = (section) => {
    const fields = section && section.fields ? section.fields : {};
    const descriptionField = fields.description || fields.reason || {};

    this.setState(
      {
        showEditSummarySectionModal: true,
        editSummarySection_id: section.id,
        editSummarySection_title: section.section_title,
        editSummarySection_type: section.section_type || "SUBTRACT",
        editSummarySection_module_type: section.section_module_type || "DISCOUNT",
        editSummarySection_scope: section.section_scope || "PERCENTAGE",
        editSummarySection_fields: {
          type: {
            label: (fields.type && fields.type.label) || "Type",
            visible:
              fields.type && typeof fields.type.visible === "boolean"
                ? fields.type.visible
                : true,
          },
          value: {
            label: (fields.value && fields.value.label) || "Value",
            visible:
              fields.value && typeof fields.value.visible === "boolean"
                ? fields.value.visible
                : true,
          },
          description: {
            label: descriptionField.label || "Description",
            visible:
              typeof descriptionField.visible === "boolean"
                ? descriptionField.visible
                : true,
          },
        },
        editSummarySection_title_error: "",
        editSummarySection_type_error: "",
      },
      () => {
        // Open modal after state is updated
        window.$("#modalEditSummarySection").modal("show");
      },
    );
  };

  closeEditSummarySectionModal = () => {
    window.$("#modalEditSummarySection").modal("hide");
    this.setState({
      showEditSummarySectionModal: false,
      editSummarySection_id: "",
      editSummarySection_title: "",
      editSummarySection_type: "SUBTRACT",
      editSummarySection_module_type: "DISCOUNT",
      editSummarySection_scope: "PERCENTAGE",
      editSummarySection_fields: {
        type: { label: "Type", visible: true },
        value: { label: "Value", visible: true },
        description: { label: "Description", visible: true },
      },
      editSummarySection_title_error: "",
      editSummarySection_type_error: "",
    });
  };

  handleEditSummarySectionTitleChange = (e) => {
    this.setState({
      editSummarySection_title: e.target.value,
      editSummarySection_title_error: "",
    });
  };

  handleEditSummarySectionTypeChange = (value) => {
    this.setState({
      editSummarySection_type: value,
      editSummarySection_type_error: "",
    });
  };

  handleEditSummarySectionModuleTypeChange = (e) => {
    this.setState({ editSummarySection_module_type: e.target.value });
  };

  handleEditSummarySectionScopeChange = (e) => {
    this.setState({ editSummarySection_scope: e.target.value });
  };

  handleEditFieldVisibilityToggle = (fieldName) => {
    this.setState((prevState) => ({
      editSummarySection_fields: {
        ...prevState.editSummarySection_fields,
        [fieldName]: {
          ...prevState.editSummarySection_fields[fieldName],
          visible: !prevState.editSummarySection_fields[fieldName].visible,
        },
      },
    }));
  };

  updateSummarySection = async () => {
    const {
      editSummarySection_id,
      editSummarySection_title,
      editSummarySection_type,
      editSummarySection_module_type,
      editSummarySection_scope,
      editSummarySection_fields,
      summarySections,
    } = this.state;

    // Validation
    let errors = false;
    const titleError = editSummarySection_title.trim() === "";
    if (titleError) {
      this.setState({ editSummarySection_title_error: "Module title is required" });
      errors = true;
    }

    if (errors) return;

    // Set loading state
    this.setState({ edit_summary_section_loader: true });

    // Update section
    const updatedSections = summarySections.map((section) =>
      section.id === editSummarySection_id
        ? {
            ...section,
            section_title: editSummarySection_title,
            section_type: editSummarySection_type,
            section_module_type: editSummarySection_module_type,
            section_scope: editSummarySection_scope,
            fields: {
              type: {
                label: editSummarySection_fields.type.label,
                visible: editSummarySection_fields.type.visible,
              },
              value: {
                label: editSummarySection_fields.value.label,
                visible: editSummarySection_fields.value.visible,
              },
              description: {
                label: editSummarySection_fields.description.label,
                visible: editSummarySection_fields.description.visible,
              },
            },
          }
        : section,
    );

    // Simulate API call delay
    setTimeout(() => {
      this.setState({
        summarySections: updatedSections,
        edit_summary_section_loader: false,
      }, () => {
        this.saveOrderSettings();
      });

      // Close modal using jQuery
      window.$("#modalEditSummarySection").modal("hide");

      // Reset form after modal closes
      setTimeout(() => {
        this.setState({
          showEditSummarySectionModal: false,
          editSummarySection_id: "",
          editSummarySection_title: "",
          editSummarySection_type: "SUBTRACT",
          editSummarySection_module_type: "DISCOUNT",
          editSummarySection_scope: "PERCENTAGE",
          editSummarySection_fields: {
            type: { label: "Type", visible: true },
            value: { label: "Value", visible: true },
            description: { label: "Description", visible: true },
          },
          editSummarySection_title_error: "",
          editSummarySection_type_error: "",
        });
      }, 500);
    }, 600);
  };

  addSummarySection = async () => {
    const {
      summarySection_title,
      summarySection_type,
      summarySection_module_type,
      summarySection_scope,
      summarySection_fields,
      summarySections,
    } = this.state;

    // Validation
    let errors = false;
    const titleError = summarySection_title.trim() === "";
    if (titleError) {
      this.setState({ summarySection_title_error: "Module title is required" });
      errors = true;
    }

    if (errors) return;

    // Set loading state
    this.setState({ add_summary_section_loader: true });

    // Create new section
    const newSection = {
      id: `section_${uuid()}`,
      section_title: summarySection_title,
      section_type: summarySection_type,
      section_module_type: summarySection_module_type,
      section_scope: summarySection_scope,
      section_is_active: true,
      fields: {
        type: {
          label: summarySection_fields.type.label,
          visible: summarySection_fields.type.visible,
        },
        value: {
          label: summarySection_fields.value.label,
          visible: summarySection_fields.value.visible,
        },
        description: {
          label: summarySection_fields.description.label,
          visible: summarySection_fields.description.visible,
        },
      },
    };

    const updatedSections = [...summarySections, newSection];

    // Simulate API call delay
    setTimeout(() => {
      this.setState({
        summarySections: updatedSections,
        add_summary_section_loader: false,
      }, () => {
        this.saveOrderSettings();
      });

      // Close modal using jQuery
      window.$("#modalAddSummarySection").modal("hide");

      // Reset form after modal closes
      setTimeout(() => {
        this.setState({
          showAddSummarySectionModal: false,
          summarySection_title: "",
          summarySection_type: "SUBTRACT",
          summarySection_module_type: "DISCOUNT",
          summarySection_scope: "PERCENTAGE",
          summarySection_fields: {
            type: { label: "Type", visible: true },
            value: { label: "Value", visible: true },
            description: { label: "Description", visible: true },
          },
          summarySection_title_error: "",
          summarySection_type_error: "",
        });
      }, 500);
    }, 600);
  };


  // Billing Section Delete Modal Logic
  openDeleteSummarySectionModal = (sectionId) => {
    this.setState({
      showDeleteSummarySectionModal: true,
      sectionIdToDelete: sectionId,
      billingSectionDeleteError: "",
      billingSectionDeleteProcessing: false,
    }, () => {
      window.$("#modalDeleteBillingSection").modal("show");
    });
  };

  closeDeleteSummarySectionModal = () => {
    this.setState({
      showDeleteSummarySectionModal: false,
      sectionIdToDelete: null,
      billingSectionDeleteError: "",
      billingSectionDeleteProcessing: false,
    }, () => {
      window.$("#modalDeleteBillingSection").modal("hide");
    });
  };

  submitDeleteSummarySection = () => {
    this.setState({ billingSectionDeleteProcessing: true, billingSectionDeleteError: "" });
    const { sectionIdToDelete } = this.state;
    this.setState(
      (prevState) => ({
        summarySections: prevState.summarySections.filter(
          (section) => section.id !== sectionIdToDelete,
        ),
      }),
      () => {
        this.saveOrderSettings();
        this.setState({ billingSectionDeleteProcessing: false, showDeleteSummarySectionModal: false, sectionIdToDelete: null });
        window.$("#modalDeleteBillingSection").modal("hide");
      },
    );
  };

  handleSummarySectionDragEnd = (result) => {
    const { source, destination } = result;

      // If dropped outside a valid area
      if (!destination) {
        return;
      }

      // If dropped in same position
      if (
        source.droppableId === destination.droppableId &&
        source.index === destination.index
      ) {
        return;
      }

      const newSummarySections = Array.from(this.state.summarySections);
      const [removed] = newSummarySections.splice(source.index, 1);
      newSummarySections.splice(destination.index, 0, removed);

    this.setState({ summarySections: newSummarySections }, () => {
      // Auto-save settings when drag-drop reordering is complete
      this.saveOrderSettings();
    });
  };

  _savingToggleSections = new Set();

  toggleSummarySectionActive = async (sectionId) => {
    if (this._savingToggleSections.has(sectionId)) return;
    this._savingToggleSections.add(sectionId);

    const originalSections = this.state.summarySections;
    const updatedSections = originalSections.map((section) =>
      section.id === sectionId
        ? {
            ...section,
            section_is_active:
              typeof section.section_is_active === "boolean"
                ? !section.section_is_active
                : false,
          }
        : section,
    );

    this.setState({ summarySections: updatedSections });

    try {
      const response = await saveOrdersSettings(
        auth.getAccount(),
        auth.getToken(),
        updatedSections,
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (response.data.status !== 200) {
        this.setState({
          summarySections: originalSections,
          orderSettingsErrorMessage:
            response.data.message || "Failed to update status.",
        });
        setTimeout(() => this.setState({ orderSettingsErrorMessage: "" }), 3000);
      }
    } catch (error) {
      this.setState({
        summarySections: originalSections,
        orderSettingsErrorMessage: "Failed to update status.",
      });
      setTimeout(() => this.setState({ orderSettingsErrorMessage: "" }), 3000);
    } finally {
      this._savingToggleSections.delete(sectionId);
    }
  };

  saveOrderSettings = async () => {
    const { summarySections } = this.state;

    this.setState({ orderSettingsButton: true });

    try {
      const response = await saveOrdersSettings(
        auth.getAccount(),
        auth.getToken(),
        summarySections,
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (response.data.status !== 200) {
        this.setState({
          orderSettingsErrorMessage:
            response.data.message || "Failed to save Billing settings.",
          orderSettingsButton: false,
        });

        setTimeout(() => {
          this.setState({ orderSettingsErrorMessage: "" });
        }, 3000);
        return;
      }

      try {
        const latestSettingsResponse = await getOrdersSettings(
          auth.getAccount(),
          auth.getToken(),
        );
        if (
          latestSettingsResponse.data &&
          latestSettingsResponse.data.status === 200 &&
          Array.isArray(latestSettingsResponse.data.order_settings)
        ) {
          const normalizedSections = latestSettingsResponse.data.order_settings.map(
            (section) => {
              const fields = section && section.fields ? section.fields : {};
              const descriptionField = fields.description || fields.reason || {};

              return {
                ...section,
                section_is_active:
                  typeof section.section_is_active === "boolean"
                    ? section.section_is_active
                    : true,
                fields: {
                  type: fields.type || { label: "Type", visible: true },
                  value: fields.value || { label: "Value", visible: true },
                  description: {
                    label: descriptionField.label || "Description",
                    visible:
                      typeof descriptionField.visible === "boolean"
                        ? descriptionField.visible
                        : true,
                  },
                },
              };
            },
          );

          this.setState({
            summarySections: normalizedSections,
          });
        }
      } catch (refreshError) {}

      this.setState({
        orderSettingsSuccessMessage: "Billing settings saved successfully",
        orderSettingsButton: false,
      });

      setTimeout(() => {
        this.setState({ orderSettingsSuccessMessage: "" });
      }, 3000);
    } catch (error) {
      this.setState({
        orderSettingsErrorMessage: "Failed to save Billing settings.",
        orderSettingsButton: false,
      });

      setTimeout(() => {
        this.setState({ orderSettingsErrorMessage: "" });
      }, 3000);
    }
  };

  render() {
    const { showBrightnessRange, brightness } = this.state;
    const filteredSignatoryDetails = this.getFilteredSignatoryDetails();
    const filteredSharelinkData = this.getFilteredSharelinkData();
    const totalProfiles = (this.state.signatoryDetails || []).length;
    const withSignatureProfiles = (this.state.signatoryDetails || []).filter(
      (item) => item?.signature_image,
    ).length;
    const latestProfileDate = totalProfiles
      ? this.format_date(
          this.state.signatoryDetails[totalProfiles - 1]?.dateAdded ||
            this.state.signatoryDetails[totalProfiles - 1]?.created_at,
        )
      : "---";
    const fetchToken = async () => {
      try {
        const response = await fetch(
          AGENT_SERVER_URL + "agents/editor_token_url",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              request_type: "ckeditor-tokenUrl",
              user: auth.getAccount(),
            }),
          },
        );
        const data = await response.json();
        return data.token;
      } catch (error) {
        console.error("Failed to fetch token:", error);
        return null;
      }
    };
    return (
      <div className="nk-content ">
        <NotificationToast
          message={this.state.toastMessage}
          type={this.state.toastType}
          title={this.state.toastTitle}
          onDismiss={() => this.setState({ toastMessage: "" })}
        />
        <div className="container-fluid">
          {/* MSA WARNING  START*/}
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MSA WARNING END */}
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      {" "}
                      <em className="icon ni ni-setting"></em> Settings
                    </h3>
                  </div>
                </div>
              </div>

              <div className="row g-gs">
                <div className="col-xxl-12">
                  <div className="card card-bordered">
                    <div className="card-inner">
                      <ul className="nav nav-tabs">
                        {this.isTabVisible("general_settings") && (
                          <li className="nav-item">
                            <a
                              className={
                                this.state.settings_type ===
                                  "general_settings" ||
                                this.state.settings_type === ""
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              href="#tabItem5"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  settings_type: "general_settings",
                                });
                              }}
                            >
                              <em className="icon ni ni-setting"></em>
                              <span>General Settings</span>
                            </a>
                          </li>
                        )}
                        {this.isTabVisible("smtp_settings") && (
                          <li className="nav-item">
                            <a
                              className={
                                this.state.settings_type === "smtp_settings"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              href="#tabItem6"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({ settings_type: "smtp_settings" });
                                this.get_smtp_settings();
                              }}
                            >
                              <em className="icon ni ni-emails"></em>
                              <span>SMTP Settings</span>
                            </a>
                          </li>
                        )}
                        {this.isTabVisible("onboarding_settings") && (
                          <li className="nav-item">
                            <a
                              className={
                                this.state.settings_type ===
                                "onboarding_settings"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              href="#tabItemOnboarding"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  settings_type: "onboarding_settings",
                                });
                                this.get_onboarding_settings();
                              }}
                            >
                              <em className="icon ni ni-setting"></em>
                              <span>Onboarding Process</span>
                            </a>
                          </li>
                        )}
                        {this.isTabVisible("custom_settings") && (
                          <li className="nav-item">
                            <a
                              className={
                                this.state.settings_type === "custom_settings"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              href="#tabItem8"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  settings_type: "custom_settings",
                                });
                                this.get_custom_settings();
                              }}
                            >
                              <em className="icon ni ni-setting"></em>
                              <span>Custom Settings</span>
                            </a>
                          </li>
                        )}
                        {this.isTabVisible("payment_settings") && (
                          <li className="nav-item">
                            <a
                              className={
                                this.state.settings_type === "payment_settings"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              href="#tabItem7"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  settings_type: "payment_settings",
                                });
                                this.get_payment_settings();
                              }}
                            >
                              <em className="icon ni ni-cc-alt"></em>
                              <span>Payment Settings</span>
                            </a>
                          </li>
                        )}
                        {this.isTabVisible("quotation_settings") && (
                          <li className="nav-item">
                            <a
                              className={
                                this.state.settings_type ===
                                "quotation_settings"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              href="#tabItemQuotation"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  settings_type: "quotation_settings",
                                });
                                this.get_quotation_settings();
                              }}
                            >
                              <em className="icon ni ni-note-add"></em>
                              <span>Quotation Settings</span>
                            </a>
                          </li>
                        )}
                        {this.isTabVisible("commission_settings") && (
                          <li className="nav-item">
                            <a
                              className={
                                this.state.settings_type ===
                                "commission_settings"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              href="#tabItemCommission"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  settings_type: "commission_settings",
                                });
                                this.get_commission_settings();
                              }}
                            >
                              <em className="icon ni ni-reports"></em>
                              <span>Commission Settings</span>
                            </a>
                          </li>
                        )}
                        {this.isTabVisible("other_settings") && (
                          <li className="nav-item">
                            <a
                              className={
                                this.state.settings_type === "other_settings"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              href="#other_settings"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  settings_type: "other_settings",
                                });
                                this.get_other_settings();
                              }}
                            >
                              <em className="icon ni ni-setting"></em>
                              <span>Other Settings</span>
                            </a>
                          </li>
                        )}
                        {this.isTabVisible("signatory_settings") && (
                          <li className="nav-item">
                            <a
                              className={
                                this.state.settings_type ===
                                "signatory_settings"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              href="#signatory_settings"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  settings_type: "signatory_settings",
                                });
                                this.get_signatory_settings();
                              }}
                            >
                              <em className="icon ni ni-contact"></em>
                              <span>Company Profile Settings</span>
                            </a>
                          </li>
                        )}
                        {this.isTabVisible("registration_settings") && (
                          <li className="nav-item">
                            <a
                              className={
                                this.state.settings_type ===
                                "registration_settings"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              href="#registration_settings"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  settings_type: "registration_settings",
                                });
                                this.get_registration_settings();
                              }}
                            >
                              <em className="icon ni ni-user-add"></em>
                              <span>Client Registration Settings</span>
                            </a>
                          </li>
                        )}
                          <li className="nav-item">
                            <a
                              className={
                                this.state.settings_type ===
                                "sharelink_settings"
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              href="#sharelink_settings"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                  settings_type: "sharelink_settings",
                                });
                                this.get_sharelink_settings();
                              }}
                            >
                              <em className="icon ni ni-share"></em>
                              <span>Sharelink Settings</span>
                            </a>
                          </li>
                        
                        <li className="nav-item">
                          <a
                            className={
                              this.state.settings_type ===
                              "order_settings"
                                ? "nav-link active"
                                : "nav-link"
                            }
                            href="#order_settings"
                            onClick={(e) => {
                              e.preventDefault();
                              this.setState({ settings_type: "order_settings" });
                            }}
                          >
                            <em className="icon ni ni-package"></em>
                            <span>Billing Settings</span>
                          </a>
                        </li>
                        
                        {((this.isTabVisible("rfq_settings") &&
                          this.state.rfqInSettings) ||
                          this.isTabVisible("CannedEmails") ||
                          this.isTabVisible("cms") ||
                          this.isTabVisible("metaBaseSettings") ||
                          this.isTabVisible("agent_permissions") ||
                          this.isTabVisible("client_permissions") ||
                          this.isTabVisible("admin_roles")) && (
                          <li>
                            <div className="dropdown mt-3">
                              <a
                                className="btn btn-xs btn-outline-light btn-icon dropdown-toggle"
                                data-toggle="dropdown"
                                data-offset="0,5"
                              >
                                <em className="icon ni ni-more-h"></em>
                              </a>
                              <div className="dropdown-menu dropdown-menu-right dropdown-menu-s">
                                <ul className="link-list-plain">
                                  {this.isTabVisible("rfq_settings") &&
                                    this.state.rfqInSettings && (
                                      <li>
                                        <a
                                          data-placement="left"
                                          href="#rfq_settings"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({
                                              settings_type: "rfq_settings",
                                            });
                                            this.get_rfq_settings();
                                          }}
                                          title="RFQ Settings"
                                          style={{ cursor: "pointer" }}
                                        >
                                          <em
                                            className="icon ni ni-files"
                                            style={{ marginRight: "7px" }}
                                          ></em>
                                          <span>RFQ Settings</span>
                                        </a>
                                      </li>
                                    )}
                                  {this.isTabVisible("CannedEmails") && (
                                    <li>
                                      <a
                                        href="/CannedEmails"
                                        title="Canned Emails"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <em
                                          className="icon ni ni-mail"
                                          style={{ marginRight: "7px" }}
                                        ></em>
                                        <span>Canned Emails</span>
                                      </a>
                                    </li>
                                  )}
                                  <li>
                                    <a
                                      href="/cms"
                                      title="Manage CMS"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <em
                                        className="icon ni ni-file-text"
                                        style={{ marginRight: "7px" }}
                                      ></em>
                                      <span>Manage CMS</span>
                                    </a>
                                  </li>
                                  {this.isTabVisible("metaBaseSettings") && (
                                    <li>
                                      <a
                                        href="/metaBaseSettings"
                                        title="Metabase Settings"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <em
                                          className="icon ni ni-bar-chart"
                                          style={{ marginRight: "7px" }}
                                        ></em>
                                        <span>Metabase Settings</span>
                                      </a>
                                    </li>
                                  )}
                                  {this.isTabVisible("agent_permissions") && (
                                    <li>
                                      <a
                                        href="/agent_permissions"
                                        title="Partner Permissions"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <em
                                          className="icon ni ni-shield"
                                          style={{ marginRight: "7px" }}
                                        ></em>
                                        <span>Partner Permissions</span>
                                      </a>
                                    </li>
                                  )}
                                  {this.isTabVisible("client_permissions") && (
                                    <li>
                                      <a
                                        href="/client_permissions"
                                        title="Client Permissions"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <em
                                          className="icon ni ni-users"
                                          style={{ marginRight: "7px" }}
                                        ></em>
                                        <span>Client Permissions</span>
                                      </a>
                                    </li>
                                  )}
                                  {this.isTabVisible("admin_roles") && (
                                    <li>
                                      <a
                                        href="/admin_roles"
                                        title="Admin Default Menu/Roles"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <em
                                          className="icon ni ni-account-setting"
                                          style={{ marginRight: "7px" }}
                                        ></em>
                                        <span>Admin Default Menu/Roles</span>
                                      </a>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </li>
                        )}
                      </ul>
                      <div className="tab-content">
                        <div
                          className={
                            this.state.settings_type === "general_settings" ||
                            this.state.settings_type === ""
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItem5"
                        >
                          <div className="row g-gs">
                            <div className="col-xxl-6">
                              <div className="nk-block">
                                <div className="card card-bordered">
                                  <div className="card-inner">
                                    <h5 className="card-title">
                                      <em className="icon ni ni-user"></em>{" "}
                                      {`${localization.specificPortals.agentLabel} Signup Link`}
                                    </h5>
                                    <h6 className="card-subtitle mb-2">
                                      &nbsp;
                                    </h6>

                                    {this.state.tableLoader === true ? (
                                      tableLoader()
                                    ) : (
                                      <>
                                        <div className="example-alert">
                                          <div className="alert alert-light alert-icon">
                                            <em className="icon ni ni-alert-circle"></em>{" "}
                                            <strong>NOTE: </strong>
                                            {`Use this link to invite ${localization.specificPortals.agentsLabel} to join.`}
                                          </div>
                                        </div>

                                        <div
                                          className="caption-text"
                                          style={{ marginTop: "15px" }}
                                        >
                                          <div
                                            className="example-alert"
                                            style={{ marginBottom: "15px" }}
                                          >
                                            <div className="alert alert-light">
                                              <em className="icon ni ni-link"></em>{" "}
                                              {this.state.signup_link &&
                                              this.state.signup_link !== "" ? (
                                                <>{this.state.signup_link}</>
                                              ) : (
                                                <>
                                                  {`${localization.specificPortals.agentText} signup link is not available. Please create a new one by clicking on "Regenerate" button.`}
                                                </>
                                              )}
                                            </div>
                                          </div>
                                          {this.state.reg_button === false ? (
                                            <>
                                              {this.state.permissionsState &&
                                              this.state.permissionsState
                                                .length > 0 &&
                                              this.state
                                                .permission_link_regenare ===
                                                1 ? (
                                                <button
                                                  className="btn btn-primary"
                                                  style={{
                                                    marginRight: "15px",
                                                  }}
                                                  onClick={() =>
                                                    this.regenerate_link()
                                                  }
                                                >
                                                  <em className="icon ni ni-swap"></em>{" "}
                                                  Regenerate
                                                </button>
                                              ) : null}
                                            </>
                                          ) : (
                                            <button
                                              className="btn btn-primary"
                                              style={{ marginRight: "15px" }}
                                              disabled
                                            >
                                              <em className="icon ni ni-swap"></em>{" "}
                                              Regenerate
                                              <div
                                                className="spinner-grow spinner-grow-sm"
                                                role="status"
                                              >
                                                <span className="sr-only">
                                                  Loading...
                                                </span>
                                              </div>
                                            </button>
                                          )}

                                          {this.state.cancel_button ===
                                          false ? (
                                            <>
                                              {this.state.permissionsState &&
                                              this.state.permissionsState
                                                .length > 0 &&
                                              this.state
                                                .permission_link_cancel ===
                                                1 ? (
                                                <button
                                                  className="btn btn-danger"
                                                  style={{
                                                    marginRight: "15px",
                                                  }}
                                                  onClick={() =>
                                                    this.cancel_link()
                                                  }
                                                >
                                                  <em className="icon ni ni-cross-round"></em>{" "}
                                                  Cancel
                                                </button>
                                              ) : null}
                                            </>
                                          ) : (
                                            <button
                                              className="btn btn-danger"
                                              style={{ marginRight: "15px" }}
                                              disabled
                                            >
                                              <em className="icon ni ni-cross-round"></em>{" "}
                                              Cancel
                                              <div
                                                className="spinner-grow spinner-grow-sm"
                                                role="status"
                                              >
                                                <span className="sr-only">
                                                  Loading...
                                                </span>
                                              </div>
                                            </button>
                                          )}
                                          {this.state.signup_link &&
                                          this.state.signup_link !== "" ? (
                                            <CopyToClipboard
                                              text={this.state.signup_link}
                                              onCopy={() =>
                                                this.setState({ copied: true })
                                              }
                                            >
                                              <button className="btn btn-success">
                                                <em className="icon ni ni-copy"></em>{" "}
                                                Copy to clipboard{" "}
                                                {this.state.copied ? (
                                                  <span
                                                    style={{ color: "white" }}
                                                  >
                                                    <em className="icon ni ni-done"></em>
                                                  </span>
                                                ) : null}
                                              </button>
                                            </CopyToClipboard>
                                          ) : null}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="nk-block">
                                <div className="card card-bordered">
                                  <div className="card-inner">
                                    <h5 className="card-title">
                                      <em className="icon ni ni-signin"></em>{" "}
                                      {`${localization.specificPortals.agentLabel} Login URL`}
                                    </h5>
                                    <h6 className="card-subtitle mb-2">
                                      &nbsp;
                                    </h6>

                                    <div className="example-alert">
                                      <div
                                        className="alert alert-light alert-icon"
                                        style={{
                                          fontSize: "16px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        <em className="icon ni ni-link"></em>{" "}
                                        {this.state.login_url &&
                                        this.state.login_url !== "" ? (
                                          <>{`${this.state.login_url}/agent/login`}</>
                                        ) : (
                                          <>
                                            {`${localization.specificPortals.agentText} login link is not available. Please create a new one by clicking on "Regenerate" button.`}
                                          </>
                                        )}
                                      </div>

                                      {this.state.login_url &&
                                      this.state.login_url !== "" ? (
                                        <CopyToClipboard
                                          text={`${this.state.login_url}/agent/login`}
                                          onCopy={() =>
                                            this.setState({ copied2: true })
                                          }
                                        >
                                          <button className="btn btn-success">
                                            <em className="icon ni ni-copy"></em>{" "}
                                            Copy to clipboard{" "}
                                            {this.state.copied2 ? (
                                              <span style={{ color: "white" }}>
                                                <em className="icon ni ni-done"></em>
                                              </span>
                                            ) : null}
                                          </button>
                                        </CopyToClipboard>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="nk-block">
                                <div className="card card-bordered">
                                  <div className="card-inner">
                                    <h5 className="card-title">
                                      <em className="icon ni ni-signin"></em>{" "}
                                      {`Client Login URL`}
                                    </h5>
                                    <h6 className="card-subtitle mb-2">
                                      &nbsp;
                                    </h6>

                                    <div className="example-alert">
                                      <div
                                        className="alert alert-light alert-icon"
                                        style={{
                                          fontSize: "16px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        <em className="icon ni ni-link"></em>{" "}
                                        {this.state.login_url &&
                                        this.state.login_url !== "" ? (
                                          <>{this.state.login_url}</>
                                        ) : (
                                          <>
                                            {`Client login link is not available. Please create a new one by clicking on "Regenerate" button.`}
                                          </>
                                        )}
                                      </div>

                                      {this.state.login_url &&
                                      this.state.login_url !== "" ? (
                                        <CopyToClipboard
                                          text={this.state.login_url}
                                          onCopy={() =>
                                            this.setState({ copied3: true })
                                          }
                                        >
                                          <button className="btn btn-success">
                                            <em className="icon ni ni-copy"></em>{" "}
                                            Copy to clipboard{" "}
                                            {this.state.copied3 ? (
                                              <span style={{ color: "white" }}>
                                                <em className="icon ni ni-done"></em>
                                              </span>
                                            ) : null}
                                          </button>
                                        </CopyToClipboard>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-xxl-6">
                              <div className="nk-block">
                                <div className="card card-bordered">
                                  <div className="card-inner">
                                    <h5 className="card-title">
                                      <em className="icon ni ni-camera"></em>{" "}
                                      Upload Logo and Signature
                                    </h5>
                                    <h6 className="card-subtitle mb-2">
                                      &nbsp;
                                    </h6>

                                    {this.state.tableLoader === true ? (
                                      tableLoader()
                                    ) : (
                                      <>
                                        <div className="nk-block">
                                          <div className="card card-bordered">
                                            <div className="card-inner">
                                              <h5 className="card-title">
                                                <em className="icon ni ni-camera"></em>{" "}
                                                Upload Logo
                                              </h5>
                                              <h6 className="card-subtitle mb-2">
                                                &nbsp;
                                              </h6>
                                              {this.state.permissionsState &&
                                              this.state.permissionsState
                                                .length > 0 &&
                                              this.state
                                                .permission_upload_logo ===
                                                1 ? (
                                                <Fileupload
                                                  image_type="logo"
                                                  logo_image={this.state.logo}
                                                  reseller_accountno={auth.getAccount()}
                                                ></Fileupload>
                                              ) : (
                                                <div className="col-xxl-12  col-lg-3 col-md-12">
                                                  {this.state.logo !== "" ? (
                                                    <img
                                                      style={{ height: "60px" }}
                                                      src={this.state.logo}
                                                    ></img>
                                                  ) : null}
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="nk-block">
                                          <div className="card card-bordered">
                                            <div className="card-inner">
                                              <h5 className="card-title">
                                                <em className="icon ni ni-camera"></em>{" "}
                                                Upload Signature
                                              </h5>
                                              <h6 className="card-subtitle mb-2">
                                                &nbsp;
                                              </h6>
                                              {this.state.permissionsState &&
                                              this.state.permissionsState
                                                .length > 0 &&
                                              this.state
                                                .permission_upload_signature ===
                                                1 ? (
                                                <Fileupload
                                                  image_type="signature"
                                                  logo_image={
                                                    this.state.signature_image
                                                  }
                                                  reseller_accountno={auth.getAccount()}
                                                ></Fileupload>
                                              ) : (
                                                <div className="col-xxl-12  col-lg-3 col-md-12">
                                                  {this.state
                                                    .signature_image !== "" ? (
                                                    <img
                                                      style={{ height: "60px" }}
                                                      src={
                                                        this.state
                                                          .signature_image
                                                      }
                                                    ></img>
                                                  ) : null}
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.settings_type === "smtp_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItem6"
                        >
                          <div className="row g-gs">
                            <div
                              aria-hidden="true"
                              style={{
                                position: "absolute",
                                opacity: 0,
                                pointerEvents: "none",
                                height: 0,
                                overflow: "hidden",
                              }}
                            >
                              <input
                                type="text"
                                tabIndex="-1"
                                name="smtp_decoy_username"
                                autoComplete="username"
                                defaultValue=""
                              />
                              <input
                                type="password"
                                tabIndex="-1"
                                name="smtp_decoy_password"
                                autoComplete="current-password"
                                defaultValue=""
                              />
                            </div>
                            {this.state.is_working === "no" ? (
                              <div className="col-md-12">
                                <div
                                  className="example-alert"
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-warning">
                                    <div className="alert-text">
                                      <h4>Warning</h4>
                                      <p>
                                        Your SMTP details are not verified.
                                        Please click "Test SMTP Settings" to
                                        verify the details.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            <div className="col-md-6 mt-2 mt-sm-3">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    required
                                    id="smtp_host"
                                    name="smtp_host"
                                    type="text"
                                    label="SMTP Host"
                                    value={this.state.smtp_host}
                                    onChange={this.handleChange}
                                    error={this.state.errorHostName}
                                    inputProps={{
                                      maxLength: 100, // Set the maximum length to 10 characters
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Host or ip address of your smtp server (example: smtp.company.com)"
                                  autoComplete="new-password"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6 mt-sm-3">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="smtp_method"
                                    name="smtp_method"
                                    select
                                    label="Security Type *"
                                    value={this.state.smtp_method}
                                    onChange={this.handleChange}
                                    SelectProps={{
                                      native: true,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Very important: What kind of encryption to use on the SMTP connection."
                                  autoComplete="new-password"
                                  >
                                    <option key="setstls1" value="tls">
                                      TLS
                                    </option>
                                    <option key="setssl1" value="ssl">
                                      SSL
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    required
                                    id="smtp_auth_user_value"
                                    name="smtp_auth_user_value"
                                    type="text"
                                    label="SMTP User"
                                    value={this.state.smtp_user}
                                    onChange={this.handleMappedInputChange(
                                      "smtp_user",
                                    )}
                                    onFocus={this.unlockSmtpCredentialInputs}
                                    error={this.state.errorUser}
                                    inputProps={{
                                      maxLength: 100,
                                      autoCapitalize: "none",
                                      autoCorrect: "off",
                                      spellCheck: "false",
                                      readOnly:
                                        !this.state.smtpCredentialInputsReady,
                                      "data-lpignore": true,
                                      "data-1p-ignore": "true",
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Username for authentication."
                                    autoComplete="section-smtp new-password"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    required
                                    id="smtp_auth_secret_value"
                                    name="smtp_auth_secret_value"
                                    type={
                                      this.state.passwordShown
                                        ? "text"
                                        : "password"
                                    }
                                    label="SMTP Password"
                                    value={this.state.smtp_password}
                                    error={this.state.errorPassword}
                                    onChange={this.handleMappedInputChange(
                                      "smtp_password",
                                    )}
                                    onFocus={this.unlockSmtpCredentialInputs}
                                    inputProps={{
                                      maxLength: 80,
                                      readOnly:
                                        !this.state.smtpCredentialInputsReady,
                                      "data-lpignore": true,
                                      "data-1p-ignore": "true",
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Password for authentication."
                                    autoComplete="section-smtp new-password"
                                  />
                                  <a
                                    style={{
                                      left: "auto",
                                      right: "2px",
                                      top: "29px",
                                      position: "absolute",
                                      cursor: "pointer",
                                    }}
                                    tabIndex="-1"
                                    onClick={this.togglePassword}
                                    className="form-icon form-icon-right passcode-switch"
                                    data-target="password"
                                  >
                                    {this.state.passwordShown ? (
                                      <em className="icon ni ni-eye-off"></em>
                                    ) : (
                                      <em className="icon ni ni-eye"></em>
                                    )}
                                  </a>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="smtp_port"
                                    name="smtp_port"
                                    select
                                    label="Port *"
                                    value={this.state.smtp_port}
                                    onChange={this.handleChange}
                                    SelectProps={{
                                      native: true,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="The default port is 25, but some SMTP servers use a custom port (example: 587,465)."
                                  autoComplete="new-password"
                                  >
                                    <option key="port25" value="25">
                                      25
                                    </option>
                                    <option key="port465" value="465">
                                      465
                                    </option>
                                    <option key="port587" value="587">
                                      587
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="from_email"
                                    name="from_email"
                                    type="text"
                                    label="Email From"
                                    value={this.state.from_email}
                                    onChange={this.handleChange}
                                    error={this.state.errorFromEmail}
                                    inputProps={{
                                      maxLength: 100, // Set the maximum length to 10 characters
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="The sender email address (example: account@example.com)."
                                  autoComplete="new-password"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="notifications_email"
                                    name="notifications_email"
                                    type="text"
                                    label="Notifications Email"
                                    value={this.state.notifications_email}
                                    onChange={this.handleChange}
                                    error={this.state.errorFromEmail}
                                    inputProps={{
                                      maxLength: 100, // Set the maximum length to 10 characters
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="The email address to receive the notifications (example: account@example.com)."
                                  autoComplete="new-password"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 text-right">
                              <div className="form-group">
                                <>
                                  {this.state.permissionsState &&
                                  this.state.permissionsState.length > 0 &&
                                  this.state.permission_smtp_verify === 1 ? (
                                    <>
                                      {this.state.smtp_test_button === false ? (
                                        <button
                                          type="button"
                                          className={
                                            this.state.is_working === "yes"
                                              ? "btn btn-lg btn-success"
                                              : "btn btn-lg btn-primary"
                                          }
                                          onClick={() =>
                                            this.verify_smtp_settings()
                                          }
                                          style={{ marginRight: "15px" }}
                                          disabled={this.state.disabled}
                                        >
                                          {this.state.is_working === "yes" ? (
                                            <>
                                              <em className="icon ni ni-done"></em>
                                              SMTP Settings Verified
                                            </>
                                          ) : (
                                            "Test SMTP Settings"
                                          )}
                                        </button>
                                      ) : (
                                        <button
                                          className="btn btn-lg btn-primary"
                                          style={{ marginRight: "15px" }}
                                          disabled
                                        >
                                          <em className="icon ni ni-swap"></em>{" "}
                                          Test SMTP Settings
                                          <div
                                            className="spinner-grow spinner-grow-sm"
                                            role="status"
                                          >
                                            <span className="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        </button>
                                      )}
                                    </>
                                  ) : null}
                                </>

                                {this.state.smtp_reg_button === false ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state.permission_smtp_edit === 1 ? (
                                      <button
                                        type="button"
                                        className="btn btn-lg btn-primary"
                                        onClick={() => this.add_smtp_settings()}
                                        disabled={this.state.disabled}
                                      >
                                        <em className="icon ni ni-save"></em>{" "}
                                        &nbsp; Save Settings
                                      </button>
                                    ) : null}
                                  </>
                                ) : (
                                  <button
                                    className="btn btn-lg btn-primary"
                                    style={{ marginRight: "15px" }}
                                    disabled
                                  >
                                    Save Settings
                                    <div
                                      className="spinner-grow spinner-grow-sm"
                                      role="status"
                                    >
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </div>
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.settings_type === "onboarding_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemOnboarding"
                        >
                          <div className="col-md-12 mb-4">
                            <div className="form-group">
                              <div className="form-control-group">
                                <MutextField
                                  id="onboarding_title"
                                  name="onboarding_title"
                                  type="text"
                                  label="Title"
                                  value={this.state.onboarding_title}
                                  onChange={this.handleChange}
                                  error={this.state.errorOnboardingTitle}
                                  inputProps={{
                                    maxLength: 100, // Set the maximum length to 10 characters
                                  }}
                                  variant="outlined"
                                  fullWidth
                                autoComplete="new-password"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <div className="form-control-group">
                                <MutextField
                                  id="onboarding_message"
                                  name="onboarding_message"
                                  type="text"
                                  label="Message"
                                  value={this.state.onboarding_message}
                                  onChange={this.handleChange}
                                  error={this.state.errorOnboardingMessage}
                                  inputProps={{
                                    maxLength: 1000, // Set the maximum length to 10 characters
                                  }}
                                  variant="outlined"
                                  fullWidth
                                autoComplete="new-password"
                                />
                              </div>
                            </div>
                          </div>
                          <h5 className="nk-block-title pt-4">
                            {" "}
                            <em className="icon ni ni-setting"></em> Onboarding
                            Steps
                          </h5>
                          <div
                            id="dragHandleLeft"
                            className="card card-bordered p-4 h-100"
                          >
                            <DragDropContext
                              onDragEnd={this.handleOnboardingDragEnd}
                            >
                              <Droppable droppableId="onboarding-steps-droppable">
                                {(droppableProvided) => (
                                  <div
                                    ref={droppableProvided.innerRef}
                                    {...droppableProvided.droppableProps}
                                  >
                                    {this.state.onboardingItems.map(
                                      (item, index) => (
                                        <Draggable
                                          key={item.id}
                                          draggableId={String(item.id)}
                                          index={index}
                                          isDragDisabled={item.isLocked}
                                        >
                                          {(dragProvided, dragSnapshot) => (
                              <div
                                ref={dragProvided.innerRef}
                                {...dragProvided.draggableProps}
                                className="p-3 bg-white border border-light round-lg"
                                style={{
                                  marginBottom: "10px",
                                  cursor: "default",
                                  borderColor:
                                    this.state.onboardingItemsWithErrors.includes(
                                      item.id,
                                    )
                                      ? "#dc3545"
                                      : dragSnapshot.isDragging
                                        ? "#007bff"
                                        : "#e3e6f0",
                                  borderWidth:
                                    this.state.onboardingItemsWithErrors.includes(
                                      item.id,
                                    ) || dragSnapshot.isDragging
                                      ? "2px"
                                      : "1px",
                                  transition: "all 0.2s ease",
                                  backgroundColor: dragSnapshot.isDragging
                                    ? "#e3f2fd"
                                    : "#fff",
                                  boxShadow: dragSnapshot.isDragging
                                    ? "0 4px 12px rgba(0, 123, 255, 0.2)"
                                    : "0 1px 3px rgba(0, 0, 0, 0.05)",
                                  ...dragProvided.draggableProps.style,
                                }}
                              >
                                <div className="col-md-12">
                                  <div className="form-group">
                                    <div
                                      className="form-control-group"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 12,
                                      }}
                                    >
                                      {!item.isLocked && (
                                        <span
                                          className="dragHandle"
                                          {...dragProvided.dragHandleProps}
                                          style={{
                                            cursor: "grab",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "6px 10px",
                                            borderRadius: "4px",
                                            marginRight: "4px",
                                            userSelect: "none",

                                            fontSize: "16px",
                                            flexShrink: 0,
                                          }}
                                        >
                                          <em
                                            className="icon ni ni-move"
                                            style={{ color: "#666" }}
                                          ></em>
                                        </span>
                                      )}
                                      {item.isLocked && (
                                        <span
                                          style={{
                                            cursor: "default",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "6px 10px",
                                            marginRight: "4px",
                                            flexShrink: 0,
                                          }}
                                        >
                                          <em
                                            className="far fa-heart"
                                            style={{
                                              color: "#dc3545",
                                              fontSize: "16px",
                                            }}
                                          ></em>
                                        </span>
                                      )}
                                      <div
                                        style={{
                                          flex: 1,
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: 8,
                                        }}
                                      >
                                        <div
                                          style={{
                                            border: this.state.onboardingItemsWithErrors.includes(
                                              item.id,
                                            )
                                              ? "2px solid #dc3545"
                                              : "1px solid #d0d0d0",
                                            borderRadius: "4px",
                                            padding: "14px 12px",
                                            minHeight: "56px",
                                            display: "flex",
                                            alignItems: "center",
                                            color: "#526484",
                                            backgroundColor: "#fff",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {item.title}
                                        </div>
                                      </div>

                                      {!item.isLocked && (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8,
                                            flexShrink: 0,
                                          }}
                                        >
                                          {/* Edit */}
                                          <Tooltip
                                            title="Edit Onboarding Item"
                                            placement="top"
                                          >
                                            <a
                                              onClick={() =>
                                                this.editOnboarding(item.id)
                                              }
                                              style={{
                                                cursor: "pointer",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <em
                                                className="icon ni ni-edit text-primary"
                                                style={{
                                                  fontSize: 20,
                                                }}
                                              />
                                            </a>
                                          </Tooltip>

                                          {/* Delete */}
                                          <Tooltip
                                            title="Delete Onboarding Item"
                                            placement="top"
                                          >
                                            <a
                                              onClick={() =>
                                                this.deleteOnboarding(item.id)
                                              }
                                              style={{
                                                cursor: "pointer",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderLeft:
                                                  "1px solid rgb(0 0 0 / 87%)",
                                                paddingLeft: 8,
                                              }}
                                            >
                                              <em
                                                className="icon ni ni-trash text-danger"
                                                style={{
                                                  fontSize: 20,
                                                }}
                                              />
                                            </a>
                                          </Tooltip>
                                        </div>
                                      )}
                                    </div>
                                    {!item.isLocked && (
                                      <label style={{ fontSize: 14, paddingTop: 8, paddingLeft: 45 }}>
                                        {item.type === "agreement" ? (
                                          <>
                                            Attached Agreement:{" "}
                                            {item.agreement_title || "—"}
                                            {" "}
                                            <span
                                              className={`badge badge-dim ${
                                                item.sub_type === "clients" || item.agreement_source === "Client"
                                                  ? "badge-outline-info"
                                                  : "badge-outline-primary"
                                              }`}
                                              style={{ fontSize: 11, fontWeight: 500, verticalAlign: "middle" }}
                                            >
                                              {item.sub_type === "clients" || item.agreement_source === "Client"
                                                ? "Client Agreement"
                                                : "Partner Agreement"}
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            Attached Form:{" "}
                                            {this.state.formsList.find(
                                              (f) =>
                                                f.form_accountno ===
                                                item.form,
                                            )?.form_title || "—"}
                                          </>
                                        )}
                                      </label>
                                    )}
                                  </div>
                                </div>
                              </div>
                                          )}
                                        </Draggable>
                                      ),
                                    )}
                                    {droppableProvided.placeholder}
                                  </div>
                                )}
                              </Droppable>
                            </DragDropContext>

                            <button
                              type="button"
                              style={{
                                cursor: "pointer",
                                color: "#fff",
                                marginTop: "15px",
                                paddingTop: "10px",
                                width: "170px",
                              }}
                              onClick={this.addNewOnboardingStep}
                              className="btn btn-primary"
                            >
                              <em className="icon ni ni-plus-round"></em>
                              &nbsp; Add New Step
                            </button>
                          </div>{" "}
                          {/*
                          {this.state.onboarding_save_loading === false ? (
                            <button
                              type="button"
                              className="btn btn-lg btn-primary mt-3 float-right"
                              style={{ marginRight: "15px" }}
                              onClick={this.saveOnboardingSettings}
                            >
                              <em className="icon ni ni-save"></em> &nbsp; Save
                              Settings
                            </button>
                          ) : (
                            <button
                              className="btn btn-lg btn-primary mt-3 float-right"
                              style={{ marginRight: "15px" }}
                              disabled
                            >
                              <em className="icon ni ni-save"></em> Save
                              Settings
                              <div
                                className="spinner-grow spinner-grow-sm"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </button>
                          )}
                          */}
                        </div>
                        <div
                          className={
                            this.state.settings_type === "custom_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItem8"
                        >
                          <div className="row g-gs">
                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="notification_sidebar"
                                    name="notification_sidebar"
                                    select
                                    label="Notification Sidebar *"
                                    value={this.state.notification_sidebar}
                                    onChange={this.handleChange}
                                    SelectProps={{ native: true }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Enable or disable the notification sidebar on user login."
                                  autoComplete="new-password"
                                  >
                                    <option
                                      key="notification_sidebar_enable"
                                      value="Yes"
                                    >
                                      Enable
                                    </option>
                                    <option
                                      key="notification_sidebar_disable"
                                      value="No"
                                    >
                                      Disable
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="show_tutorial"
                                    name="show_tutorial"
                                    select
                                    label="Show Tutorial *"
                                    value={this.state.show_tutorial}
                                    onChange={this.handleChange}
                                    SelectProps={{ native: true }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Choose whether to show tutorial guidance in the portal."
                                  autoComplete="new-password"
                                  >
                                    <option
                                      key="show_tutorial_enable"
                                      value="Yes"
                                    >
                                      Enable
                                    </option>
                                    <option
                                      key="show_tutorial_disable"
                                      value="No"
                                    >
                                      Disable
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="address_autocomplete"
                                    name="address_autocomplete"
                                    select
                                    label="Google Places Autocomplete *"
                                    value={this.state.address_autocomplete}
                                    onChange={this.handleChange}
                                    SelectProps={{ native: true }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Choose whether to show tutorial guidance in the portal."
                                  autoComplete="new-password"
                                  >
                                    <option
                                      key="address_autocomplete_enable"
                                      value="Yes"
                                    >
                                      Enable
                                    </option>
                                    <option
                                      key="address_autocomplete_disable"
                                      value="No"
                                    >
                                      Disable
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="address_validation"
                                    name="address_validation"
                                    select
                                    label="Address Validation *"
                                    value={this.state.address_validation}
                                    onChange={this.handleChange}
                                    SelectProps={{ native: true }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Choose whether to show tutorial guidance in the portal."
                                  autoComplete="new-password"
                                  >
                                    <option
                                      key="address_validation_enable"
                                      value="Yes"
                                    >
                                      Enable
                                    </option>
                                    <option
                                      key="address_validation_disable"
                                      value="No"
                                    >
                                      Disable
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="required_sub_user_type"
                                    name="required_sub_user_type"
                                    select
                                    label="Require Sub User Type *"
                                    value={this.state.required_sub_user_type}
                                    onChange={this.handleChange}
                                    SelectProps={{ native: true }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Allow users to log in with Google. Optionally restrict access by domains."
                                  autoComplete="new-password"
                                  >
                                    <option
                                      key="required_sub_user_type_enable"
                                      value="Yes"
                                    >
                                      Enable
                                    </option>
                                    <option
                                      key="required_sub_user_type_disable"
                                      value="No"
                                    >
                                      Disable
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="sales_order_sequence_no"
                                    name="sales_order_sequence_no"
                                    label="Sales Order Sequence No"
                                    value={this.state.sales_order_sequence_no}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Sales order sequence number used in order numbering."
                                  autoComplete="new-password"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="google_login"
                                    name="google_login"
                                    select
                                    label="Google SSO *"
                                    value={this.state.google_login}
                                    onChange={this.handleChange}
                                    SelectProps={{ native: true }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Allow users to log in with Google. Optionally restrict access by domains."
                                  autoComplete="new-password"
                                  >
                                    <option
                                      key="google_login_enable"
                                      value="Yes"
                                    >
                                      Enable
                                    </option>
                                    <option
                                      key="google_login_disable"
                                      value="No"
                                    >
                                      Disable
                                    </option>
                                  </MutextField>
                                  {this.state.google_login === "Yes" &&
                                    (this.state.allowed_domain === "No" ||
                                      this.state.allowed_domain_list.length ===
                                        0) && (
                                      <div
                                        style={{
                                          marginTop: "6px",
                                          fontSize: "13px",
                                          color: "#364152",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        <em
                                          className="icon ni ni-alert-fill"
                                          style={{
                                            color: "#f4c542",
                                            fontSize: "16px",
                                          }}
                                        ></em>
                                        <span>
                                          The{" "}
                                          <span style={{ fontWeight: 600 }}>
                                            Google Login button
                                          </span>{" "}
                                          is only visible when{" "}
                                          <span style={{ fontWeight: 600 }}>
                                            Allowed Domain
                                          </span>{" "}
                                          is enabled and at least one{" "}
                                          <span style={{ fontWeight: 600 }}>
                                            domain
                                          </span>{" "}
                                          is added.
                                        </span>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>

                            {this.state.google_login === "Yes" && (
                              <>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <div className="form-control-group">
                                      <MutextField
                                        id="google_direct_registration"
                                        name="google_direct_registration"
                                        select
                                        label="Google SSO - Registration Page *"
                                        value={
                                          this.state.google_direct_registration
                                        }
                                        onChange={this.handleChange}
                                        SelectProps={{ native: true }}
                                        variant="outlined"
                                        fullWidth
                                        helperText="If enabled, sub-users logging in via Google SSO are registered automatically without showing the registration page."
                                      autoComplete="new-password"
                                      >
                                        <option
                                          key="google_direct_registration_enable"
                                          value="Yes"
                                        >
                                          Enable
                                        </option>
                                        <option
                                          key="google_direct_registration_disable"
                                          value="No"
                                        >
                                          Disable
                                        </option>
                                      </MutextField>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}

                            {this.state.google_login === "Yes" && (
                              <>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <div className="form-control-group">
                                      <MutextField
                                        id="allowed_domain"
                                        name="allowed_domain"
                                        select
                                        label="Google SSO - Allowed Domain *"
                                        value={this.state.allowed_domain}
                                        onChange={this.handleChange}
                                        SelectProps={{ native: true }}
                                        variant="outlined"
                                        fullWidth
                                        helperText="Restrict Google login access to only specific domains."
                                      autoComplete="new-password"
                                      >
                                        <option
                                          key="allowed_domain_enable"
                                          value="Yes"
                                        >
                                          Enable
                                        </option>
                                        <option
                                          key="allowed_domain_disable"
                                          value="No"
                                        >
                                          Disable
                                        </option>
                                      </MutextField>
                                    </div>
                                  </div>
                                </div>

                                {this.state.allowed_domain === "Yes" && (
                                  <div className="col-md-12">
                                    <label
                                      className="form-label d-flex align-items-center"
                                      style={{ gap: "6px" }}
                                    >
                                      <Tooltip
                                        title="List of domains allowed for Google login."
                                        placement="top"
                                      >
                                        <em
                                          className="icon ni ni-info"
                                          style={{
                                            color: "#6576ff",
                                            cursor: "pointer",
                                          }}
                                        ></em>
                                      </Tooltip>
                                      Domains
                                    </label>

                                    {(this.state.CustomErrorMessageDomain ||
                                      this.state
                                        .CustomSuccessMessageDomain) && (
                                      <div
                                        className="col-md-6"
                                        style={{
                                          paddingLeft: "0",
                                          marginBottom: "12px",
                                        }}
                                      >
                                        <div
                                          className="example-alert"
                                          style={{
                                            marginBottom: "10px",
                                            paddingLeft: "0px",
                                          }}
                                        >
                                          {this.state
                                            .CustomErrorMessageDomain && (
                                            <div
                                              className="alert alert-pro alert-danger"
                                              style={{
                                                padding: "20px 15px",
                                                fontSize: "13px",
                                              }}
                                            >
                                              <div className="alert-text">
                                                <div>
                                                  <strong
                                                    style={{
                                                      fontWeight: 600,
                                                      fontSize: "0.9rem",
                                                    }}
                                                  >
                                                    Error
                                                  </strong>
                                                </div>
                                                <div>
                                                  {
                                                    this.state
                                                      .CustomErrorMessageDomain
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                          {this.state
                                            .CustomSuccessMessageDomain && (
                                            <div
                                              className="alert alert-pro alert-success"
                                              style={{
                                                padding: "20px 15px",
                                                fontSize: "13px",
                                              }}
                                            >
                                              <div className="alert-text">
                                                <div>
                                                  <strong
                                                    style={{
                                                      fontWeight: 600,
                                                      fontSize: "0.9rem",
                                                    }}
                                                  >
                                                    Success
                                                  </strong>
                                                </div>
                                                <div>
                                                  {
                                                    this.state
                                                      .CustomSuccessMessageDomain
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    {/* Domain list */}
                                    {this.state.allowed_domain_list.length ===
                                    0 ? (
                                      <p>No domains found.</p>
                                    ) : (
                                      this.state.allowed_domain_list.map(
                                        (item) => (
                                          <div
                                            key={item.id}
                                            className="d-flex align-items-center mb-2"
                                            style={{ gap: "7px" }}
                                          >
                                            {/* Delete Button */}
                                            <a
                                              type="button"
                                              className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                              style={{
                                                borderRadius: "50%",
                                                width: "24px",
                                                height: "24px",
                                                padding: 0,
                                                color: "white",
                                              }}
                                              onClick={() =>
                                                this.deleteDomainFun(item.id)
                                              }
                                            >
                                              <em
                                                className="icon ni ni-trash"
                                                style={{ fontSize: "12px" }}
                                              ></em>
                                            </a>

                                            {/* Edit / Save Button */}
                                            <a
                                              type="button"
                                              className="btn btn-sm btn-secondary d-flex align-items-center justify-content-center"
                                              style={{
                                                borderRadius: "50%",
                                                width: "24px",
                                                height: "24px",
                                                padding: 0,
                                                color: "white",
                                              }}
                                              onClick={() => {
                                                if (
                                                  this.state.editingDomainId ===
                                                  item.id
                                                ) {
                                                  if (
                                                    (
                                                      this.state
                                                        .editingDomainValue ||
                                                      ""
                                                    ).trim() ===
                                                    (item.domain || "").trim()
                                                  ) {
                                                    // No change: cancel edit mode silently
                                                    this.setState({
                                                      editingDomainId: null,
                                                      editingDomainValue: "",
                                                    });
                                                  } else {
                                                    // Only save if changed
                                                    this.saveEditedDomain(
                                                      item.id,
                                                    );
                                                  }
                                                } else {
                                                  // Enter edit mode
                                                  this.setState({
                                                    editingDomainId: item.id,
                                                    editingDomainValue:
                                                      item.domain,
                                                  });
                                                }
                                              }}
                                            >
                                              <em
                                                className={`icon ni ${
                                                  this.state.editingDomainId ===
                                                  item.id
                                                    ? "ni-check"
                                                    : "ni-pen"
                                                }`}
                                                style={{ fontSize: "12px" }}
                                              ></em>
                                            </a>

                                            {/* Cancel Button (only during edit) */}
                                            {this.state.editingDomainId ===
                                              item.id && (
                                              <a
                                                type="button"
                                                className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                                                style={{
                                                  borderRadius: "50%",
                                                  width: "24px",
                                                  height: "24px",
                                                  padding: 0,
                                                  color: "#6e7a86",
                                                }}
                                                onClick={() =>
                                                  this.setState({
                                                    editingDomainId: null,
                                                    editingDomainValue: "",
                                                  })
                                                }
                                              >
                                                <em
                                                  className="icon ni ni-cross"
                                                  style={{ fontSize: "12px" }}
                                                ></em>
                                              </a>
                                            )}

                                            {/* Domain Display / Input */}
                                            {this.state.editingDomainId ===
                                            item.id ? (
                                              <input
                                                type="text"
                                                value={
                                                  this.state.editingDomainValue
                                                }
                                                onChange={(e) =>
                                                  this.setState({
                                                    editingDomainValue:
                                                      e.target.value,
                                                  })
                                                }
                                                style={{
                                                  border: "none",
                                                  borderBottom:
                                                    "1px solid #ccc",
                                                  outline: "none",
                                                  backgroundColor:
                                                    "transparent",
                                                  fontSize: "14px",
                                                  padding: "2px 4px",
                                                  minWidth: "160px",
                                                }}
                                              />
                                            ) : (
                                              <strong>{item.domain}</strong>
                                            )}
                                          </div>
                                        ),
                                      )
                                    )}

                                    {/* Input + Add */}
                                    <div
                                      className="d-flex align-items-center"
                                      style={{ gap: "10px" }}
                                    >
                                      <input
                                        type="text"
                                        className="form-control"
                                        style={{
                                          height: "56px",
                                          outline: "none",
                                          boxShadow: "none",
                                          borderColor: "#c1c4cc",
                                        }}
                                        placeholder="Add a domain, e.g. example.com"
                                        value={this.state.new_domain || ""}
                                        onChange={(e) =>
                                          this.setState({
                                            new_domain: e.target.value,
                                            CustomErrorMessageDomain: "",
                                            CustomSuccessMessageDomain: "",
                                          })
                                        }
                                      />
                                      <a
                                        type="button"
                                        className="btn btn-primary d-flex align-items-center justify-content-center"
                                        style={{
                                          height: "56px",
                                          width: "56px",
                                          padding: 0,
                                          color: "white",
                                        }}
                                        onClick={() =>
                                          this.add_allowed_domains()
                                        }
                                        disabled={this.state.domain_reg_button}
                                      >
                                        {this.state.domain_reg_button ? (
                                          <div
                                            className="spinner-grow spinner-grow-sm text-light"
                                            role="status"
                                            style={{
                                              width: "1.25rem",
                                              height: "1.25rem",
                                            }}
                                          >
                                            <span className="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        ) : (
                                          <em
                                            className="icon ni ni-plus-sm"
                                            style={{ fontSize: "20px" }}
                                          ></em>
                                        )}
                                      </a>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            <div className="col-md-12 text-right">
                              <div className="form-group">
                                {this.state.custom_reg_button === false ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state.permission_custom_edit === 1 ? (
                                      <button
                                        type="button"
                                        className="btn btn-lg btn-primary"
                                        onClick={() =>
                                          this.add_custom_settings()
                                        }
                                        disabled={this.state.disabled}
                                      >
                                        <em className="icon ni ni-save"></em>{" "}
                                        &nbsp; Save Settings
                                      </button>
                                    ) : null}
                                  </>
                                ) : (
                                  <button
                                    className="btn btn-lg btn-primary"
                                    style={{ marginRight: "15px" }}
                                    disabled
                                  >
                                    <em className="icon ni ni-save"></em> Save
                                    Settings
                                    <div
                                      className="spinner-grow spinner-grow-sm"
                                      role="status"
                                    >
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </div>
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.settings_type === "payment_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItem7"
                        >
                          <div className="row g-gs">
                            {this.state.tableLoaderPayment === true ? (
                              tableLoader()
                            ) : (
                              <>
                                <div className="col-lg-12">
                                  <h6>Payment Details</h6>
                                </div>

                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <RichTextEditorComponent
                                      agreementContent={
                                        this.state.bank_account_details
                                      }
                                      onContentChange={this.handleEditorBank}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-12 text-right">
                                  <div className="form-group">
                                    {this.state.payment_reg_button === false ? (
                                      <>
                                        {this.state.permissionsState &&
                                        this.state.permissionsState.length >
                                          0 &&
                                        this.state.permission_payment_edit ===
                                          1 ? (
                                          <button
                                            type="button"
                                            className="btn btn-lg btn-primary"
                                            onClick={() =>
                                              this.add_payment_settings()
                                            }
                                            disabled={this.state.disabled}
                                          >
                                            <em className="icon ni ni-save"></em>{" "}
                                            &nbsp; Save Settings
                                          </button>
                                        ) : null}
                                      </>
                                    ) : (
                                      <button
                                        className="btn btn-lg btn-primary"
                                        style={{ marginRight: "15px" }}
                                        disabled
                                      >
                                        <em className="icon ni ni-save"></em>{" "}
                                        &nbsp; Save Settings
                                        <div
                                          className="spinner-grow spinner-grow-sm"
                                          role="status"
                                        >
                                          <span className="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        {/**** Quotation Settings ****/}
                        <div
                          className={
                            this.state.settings_type === "quotation_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemQuotation"
                        >
                          <div className="row g-gs">
                            {this.state.tableLoaderQuote === true ? (
                              tableLoader()
                            ) : (
                              <>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <div className="form-control-group">
                                      <Autocomplete
                                        options={this.getTermOptions()}
                                        getOptionLabel={(option) => option?.label || ""}
                                        value={this.state.selected_payment_terms}
                                        onChange={(event, newValue) =>
                                          this.handleChangeSearchTerms(newValue)
                                        }
                                        clearOnEscape
                                        renderInput={(params) => (
                                          <MutextField
                                            {...params}
                                            label="Terms of payment *"
                                            placeholder="Please select the preferred currency"
                                            variant="outlined"
                                            fullWidth
                                            helperText="Preferred terms of payment (Net 30, Net 60, 50% Deposit, COD (Cash on Delivery))."
                                          autoComplete="new-password"
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <div className="form-control-group">
                                      <Autocomplete
                                        options={this.getOption()}
                                        getOptionLabel={(option) => option?.label || ""}
                                        value={this.state.selected_currency}
                                        onChange={(event, newValue) =>
                                          this.handleChangeSearch(newValue)
                                        }
                                        clearOnEscape
                                        renderInput={(params) => (
                                          <MutextField
                                            {...params}
                                            label="Currency *"
                                            placeholder="Please select the preferred currency"
                                            variant="outlined"
                                            fullWidth
                                            helperText="The currency in which you would like to receive the payment."
                                          autoComplete="new-password"
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <div className="form-control-group">
                                      <MutextField
                                        id="contact_person"
                                        name="contact_person"
                                        type="text"
                                        label="Contact Person"
                                        helperText="Provide the full name"
                                        value={this.state.contact_person}
                                        onChange={this.handleChange}
                                        error={this.state.errorcontact_person}
                                        inputProps={{
                                          maxLength: 50, // Set the maximum length to 10 characters
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <div className="form-control-group">
                                      <MutextField
                                        id="contact_email"
                                        name="contact_email"
                                        type="text"
                                        label="Contact Email"
                                        helperText="Provide the email"
                                        value={this.state.contact_email}
                                        onChange={this.handleChange}
                                        error={this.state.errorcontact_email}
                                        inputProps={{
                                          maxLength: 50, // Set the maximum length to 10 characters
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <div className="form-control-group">
                                      <MutextField
                                        id="validity"
                                        name="validity"
                                        type="text"
                                        label="Quotation Validity (Days) *"
                                        value={this.state.validity}
                                        onChange={this.handleChange}
                                        error={this.state.errorvalidity}
                                        inputProps={{
                                          maxLength: 4, // Set the maximum length to 10 characters
                                        }}
                                        variant="outlined"
                                        fullWidth
                                        helperText="Specify the number of days for which this quotation will remain valid."
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <div className="form-control-group">
                                      <MutextField
                                        id="decimalPoint"
                                        name="decimalPoint"
                                        type="number"
                                        label="Decimal Points *"
                                        value={this.state.decimalPoint}
                                        onChange={this.handleChange}
                                        error={this.state.errordecimalPoint}
                                        inputProps={{
                                          max: 6,
                                          min: 2,
                                        }}
                                        variant="outlined"
                                        fullWidth
                                        helperText="Specify the number of decimal points to be displayed for service rates. Enter a number between 2 and 6."
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <div className="form-control-group">
                                      <MutextField
                                        id="billing_decimalPoint"
                                        name="billing_decimalPoint"
                                        type="number"
                                        label="Billing Decimal Points *"
                                        value={this.state.billing_decimalPoint}
                                        onChange={this.handleChange}
                                        error={
                                          this.state.errorbilling_decimalPoint
                                        }
                                        inputProps={{
                                          max: 6,
                                          min: 2,
                                        }}
                                        variant="outlined"
                                        fullWidth
                                        helperText="Specify the number of decimal points for billing to be displayed. Enter a number between 2 and 6."
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <h6>Quotation Notes</h6>
                                </div>

                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <RichTextEditorComponent
                                      agreementContent={
                                        this.state.quotation_notes
                                      }
                                      onContentChange={
                                        this.handleEditorQuotationNotes
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-12">
                                  <div className="form-group"></div>
                                </div>
                                <div className="col-md-12 text-right">
                                  <div className="form-group">
                                    {this.state.quotation_button === false ? (
                                      <>
                                        {this.state.permissionsState &&
                                        this.state.permissionsState.length >
                                          0 &&
                                        this.state.permission_quotation_edit ===
                                          1 ? (
                                          <button
                                            type="button"
                                            className="btn btn-lg btn-primary"
                                            onClick={() =>
                                              this.add_quotation_settings()
                                            }
                                            disabled={this.state.disabled}
                                          >
                                            <em className="icon ni ni-save"></em>{" "}
                                            &nbsp; Save Settings
                                          </button>
                                        ) : null}
                                      </>
                                    ) : (
                                      <button
                                        className="btn btn-lg btn-primary"
                                        style={{ marginRight: "15px" }}
                                        disabled
                                      >
                                        <em className="icon ni ni-save"></em>{" "}
                                        &nbsp; &nbsp; Save Settings
                                        <div
                                          className="spinner-grow spinner-grow-sm"
                                          role="status"
                                        >
                                          <span className="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        {/**** Quotation Settings ****/}
                        {/**** Commission Settings ****/}
                        <div
                          className={
                            this.state.settings_type === "commission_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemCommission"
                        >
                          <div className="row g-gs">
                            <div className="col-md-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="apply_commission"
                                    name="apply_commission"
                                    select
                                    label="Apply Commission *"
                                    value={this.state.apply_commission}
                                    onChange={this.handleChange}
                                    SelectProps={{
                                      native: true,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Set the default value of how the commission will be applied."
                                  autoComplete="new-password"
                                  >
                                    <option key="setst1" value="agent_account">
                                      {`${localization.specificPortals.agentLabel} Account`}
                                    </option>
                                    <option
                                      key="setst2"
                                      value="product_services"
                                    >
                                      Product & Services
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="commission_type"
                                    name="commission_type"
                                    select
                                    label="Commission Payment Terms *"
                                    value={this.state.commission_type}
                                    onChange={this.handleChange}
                                    SelectProps={{
                                      native: true,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    helperText="Billed Commission: Paid when the sale is invoiced or billed to the customer, regardless of whether the payment has been received. Collected Commission: Paid only when the payment from the customer is collected. This can be more common in industries where payment collection might be a prolonged process."
                                  autoComplete="new-password"
                                  >
                                    <option key="setst1" value="paid_on_billed">
                                      Paid On Billed
                                    </option>
                                    <option
                                      key="setst2"
                                      value="paid_on_collected"
                                    >
                                      Paid On Collected
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="commission_value_type"
                                    name="commission_value_type"
                                    select
                                    label="Commission Type *"
                                    value={this.state.commission_value_type}
                                    onChange={this.handleChange}
                                    SelectProps={{
                                      native: true,
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    helperText={`${localization.specificPortals.agentsLabel} receive a fixed or percentage based on the profit margin.`}
                                  autoComplete="new-password"
                                  >
                                    <option key="setst33" value="fixed">
                                      Fixed
                                    </option>
                                    <option key="setst23" value="percentage">
                                      Percentage
                                    </option>
                                  </MutextField>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="commission_value"
                                    name="commission_value"
                                    type="text"
                                    label={`Commission Value ${ this.state.commission_value_type === "percentage" ? "(%)" : "" } *`}
                                    value={this.state.commission_value}
                                    onChange={this.handleChange}
                                    onKeyPress={() => {
                                      this.checkNumber();
                                    }}
                                    inputProps={{
                                      maxLength: 9, // Set the maximum length to 10 characters
                                    }}
                                    variant="outlined"
                                    fullWidth
                                  autoComplete="new-password"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <div className="form-group">
                                <div className="form-control-group">
                                  <MutextField
                                    id="draw_threshold"
                                    name="draw_threshold"
                                    type="text"
                                    label="Withdraw Threshold *"
                                    value={this.state.draw_threshold}
                                    onChange={this.handleChange}
                                    onKeyPress={() => {
                                      this.checkNumber();
                                    }}
                                    inputProps={{
                                      maxLength: 9, // Set the maximum length to 10 characters
                                    }}
                                    variant="outlined"
                                    fullWidth
                                  autoComplete="new-password"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <div className="form-group"></div>
                            </div>
                            <div className="col-md-12 text-right">
                              <div className="form-group">
                                {this.state.commission_button === false ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state.permission_commission_edit ===
                                      1 ? (
                                      <button
                                        type="button"
                                        className="btn btn-lg btn-primary"
                                        onClick={() =>
                                          this.add_commission_settings()
                                        }
                                        disabled={this.state.disabled}
                                      >
                                        <em className="icon ni ni-save"></em>{" "}
                                        &nbsp; Save Settings
                                      </button>
                                    ) : null}
                                  </>
                                ) : (
                                  <button
                                    className="btn btn-lg btn-primary"
                                    style={{ marginRight: "15px" }}
                                    disabled
                                  >
                                    <em className="icon ni ni-save"></em> Save
                                    &nbsp; Settings
                                    <div
                                      className="spinner-grow spinner-grow-sm"
                                      role="status"
                                    >
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </div>
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/**** Commission Settings ****/}
                        {/**** Other Settings ****/}
                        <div
                          className={
                            this.state.settings_type === "other_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="other_settings"
                        >
                          <div className="row g-gs">
                            <div className="col-lg-12">
                              <h6>Client Notes </h6>
                            </div>
                            {this.state.tableLoaderNotes === true ? (
                              tableLoader()
                            ) : (
                              <>
                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <RichTextEditorComponent
                                      agreementContent={this.state.clientNotes}
                                      onContentChange={
                                        this.handleEditorClientNotes
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-12 text-right">
                                  <div className="form-group">
                                    {this.state.client_setting_button ===
                                    false ? (
                                      <>
                                        {this.state.permissionsState &&
                                        this.state.permissionsState.length >
                                          0 &&
                                        this.state.permission_other_edit ===
                                          1 ? (
                                          <button
                                            type="button"
                                            className="btn btn-lg btn-primary"
                                            onClick={() =>
                                              this.saveClientNotes()
                                            }
                                            disabled={this.state.disabled}
                                          >
                                            <em className="icon ni ni-save"></em>{" "}
                                            &nbsp; Save Other Settings
                                          </button>
                                        ) : null}
                                      </>
                                    ) : (
                                      <button
                                        className="btn btn-lg btn-primary"
                                        style={{ marginRight: "15px" }}
                                        disabled
                                      >
                                        <em className="icon ni ni-save"></em>{" "}
                                        &nbsp; Save Other Settings
                                        <div
                                          className="spinner-grow spinner-grow-sm"
                                          role="status"
                                        >
                                          <span className="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        {/**** Other Settings ****/}
                        {/**** Other Settings ****/}
                        <div
                          className={
                            this.state.settings_type === "signatory_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="signatory_settings"
                        >
                          <div className="row g-gs">
                            <div className="col-lg-12">
                              <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between align-items-start">
                                  <div className="nk-block-head-content">
                                    <h3 className="nk-block-title page-title">
                                      Company Profiles
                                    </h3>
                                    <div className="nk-block-des text-soft">
                                      <p>
                                        Manage signatory profiles used across agreements and documents
                                      </p>
                                    </div>
                                  </div>
                                  {this.state.permissionsState &&
                                  this.state.permissionsState.length > 0 &&
                                  this.state.permission_profile_add === 1 ? (
                                    <div className="nk-block-head-content">
                                      <Link
                                        color="inherit"
                                        onClick={() => this.addSignatoryForm()}
                                        className="btn btn-primary"
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          cursor: "pointer",
                                          color: "#fff",
                                        }}
                                      >
                                        <em className="icon ni ni-plus-round"></em>
                                        &nbsp;Add New Profile
                                      </Link>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <div className="row g-gs">
                                <div className="col-md-4">
                                  <div className="card card-bordered h-100">
                                    <div className="card-inner">
                                      <div className="d-flex align-items-center" style={{ gap: 16 }}>
                                        <div style={{
                                          background: "#e5f8f2",
                                          borderRadius: 10,
                                          width: 52,
                                          height: 52,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          flexShrink: 0,
                                        }}>
                                          <em className="icon ni ni-building" style={{ fontSize: 26, color: "#1ee0ac" }}></em>
                                        </div>
                                        <div>
                                          <h4 className="mb-0" style={{ fontWeight: 700 }}>{totalProfiles}</h4>
                                          <div className="text-soft" style={{ fontSize: 13 }}>Total Profiles</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="card card-bordered h-100">
                                    <div className="card-inner">
                                      <div className="d-flex align-items-center" style={{ gap: 16 }}>
                                        <div style={{
                                          background: "#e8f0fe",
                                          borderRadius: 10,
                                          width: 52,
                                          height: 52,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          flexShrink: 0,
                                        }}>
                                          <em className="icon ni ni-check-circle-fill" style={{ fontSize: 26, color: "#2c3782" }}></em>
                                        </div>
                                        <div>
                                          <h4 className="mb-0" style={{ fontWeight: 700 }}>{withSignatureProfiles}</h4>
                                          <div className="text-soft" style={{ fontSize: 13 }}>With Signature</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="card card-bordered h-100">
                                    <div className="card-inner">
                                      <div className="d-flex align-items-center" style={{ gap: 16 }}>
                                        <div style={{
                                          background: "#e8f0fe",
                                          borderRadius: 10,
                                          width: 52,
                                          height: 52,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          flexShrink: 0,
                                        }}>
                                          <em className="icon ni ni-calendar" style={{ fontSize: 26, color: "#6576ff" }}></em>
                                        </div>
                                        <div>
                                          <h4 className="mb-0" style={{ fontWeight: 700 }}>{latestProfileDate}</h4>
                                          <div className="text-soft" style={{ fontSize: 13 }}>Last Added</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <div className="card card-bordered">
                                <div className="card-inner border-bottom d-flex justify-content-between align-items-center" style={{ gap: 10 }}>
                                  <div className="form-control-wrap" style={{ maxWidth: 360, width: "100%" }}>
                                    <div className="form-icon form-icon-left">
                                      <em className="icon ni ni-search"></em>
                                    </div>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search by name, company, email..."
                                      value={this.state.signatory_search}
                                      onChange={(e) =>
                                        this.setState({ signatory_search: e.target.value })
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="card-inner p-0">
                                  {this.state.tableLoader === true ? (
                                    tableLoader()
                                  ) : (
                                    <>
                                      {this.state.signatorySettingNotFound !== "" ? (
                                        <div className="p-3">
                                          <div className="alert alert-pro alert-danger mb-0">
                                            <div className="alert-text">
                                              <p>{this.state.signatorySettingNotFound}</p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                      {filteredSignatoryDetails && filteredSignatoryDetails.length > 0 ? (
                                        <ThemeProvider theme={createTheme({
                                          shadows: Array(5).fill("none"),
                                          overrides: {
                                            MUIDataTableHeadCell: { root: { zIndex: 0 }, fixedHeader: { zIndex: 0 } },
                                          },
                                          palette: { primary: { main: THEME_COLOR } },
                                        })}>
                                          <MUIDataTable
                                            columns={this.state.columnsignatoryDetails}
                                            data={filteredSignatoryDetails}
                                            title=""
                                            options={{
                                              filter: false,
                                              search: false,
                                              print: false,
                                              download: false,
                                              viewColumns: false,
                                              selectableRows: "none",
                                              rowsPerPage: 50,
                                              rowsPerPageOptions: [25, 50, 100],
                                              jumpToPage: true,
                                              rowHover: true,
                                              responsive: "vertical",
                                              tableBodyHeight: "100%",
                                              tableBodyMinHeight: "200px",
                                            }}
                                          />
                                        </ThemeProvider>
                                      ) : (
                                        <div className="text-center py-5">
                                          <h6 className="mb-1">No company profiles yet</h6>
                                          <p className="text-soft mb-0">
                                            Click "Add New Profile" to create your first signatory profile.
                                          </p>
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/**** Signatory Settings ****/}
                        {/**** RFQ Settings ****/}
                        <div
                          className={
                            this.state.settings_type === "rfq_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="rfq_settings"
                        >
                          <div className="row g-gs">
                            <div className="col-lg-12">
                              <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                  <div className="nk-block-head-content">
                                    <h3 className="nk-block-title page-title">
                                      <PageTitle
                                        name="RFQ Settings"
                                        icon="icon ni ni-setting"
                                      />
                                    </h3>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {this.state.tableLoaderRfq === true ? (
                              tableLoader()
                            ) : (
                              <>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        RFQ Title{" "}
                                        <span className="text-danger"></span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        id="rfqSettingTitle"
                                        name="rfqSettingTitle"
                                        type="text"
                                        label=""
                                        value={this.state.rfqSettingTitle}
                                        onChange={this.handleChange}
                                        inputProps={{
                                          maxLength: 100, // Set the maximum length to 10 characters
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        RFQ Heading{" "}
                                        <span className="text-danger"></span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <MutextField
                                        id="rfqSettingHeading"
                                        name="rfqSettingHeading"
                                        type="text"
                                        label=""
                                        value={this.state.rfqSettingHeading}
                                        onChange={this.handleChange}
                                        inputProps={{
                                          maxLength: 100, // Set the maximum length to 10 characters
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        RFQ Short Description{" "}
                                        <span className="text-danger"></span>
                                      </label>
                                    </div>
                                    <div className="form-control-group">
                                      <textarea
                                        className="form-control"
                                        id="rfqSettingDesc"
                                        name="rfqSettingDesc"
                                        onChange={this.handleChange}
                                      >
                                        {this.state.rfqSettingDesc}
                                      </textarea>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12 text-right">
                                  <div className="form-group">
                                    {this.state.client_rfq_button === false ? (
                                      <>
                                        {this.state.permissionsState &&
                                        this.state.permissionsState.length >
                                          0 &&
                                        this.state.permission_rfq_edit === 1 ? (
                                          <button
                                            type="button"
                                            className="btn btn-lg btn-primary"
                                            onClick={() =>
                                              this.saveRfqSettings()
                                            }
                                            disabled={this.state.disabled}
                                          >
                                            <em className="icon ni ni-save"></em>{" "}
                                            &nbsp; Save RFQ Settings
                                          </button>
                                        ) : null}
                                      </>
                                    ) : (
                                      <button
                                        className="btn btn-lg btn-primary"
                                        style={{ marginRight: "15px" }}
                                        disabled
                                      >
                                        <em className="icon ni ni-save"></em>{" "}
                                        &nbsp; Save RFQ Settings
                                        <div
                                          className="spinner-grow spinner-grow-sm"
                                          role="status"
                                        >
                                          <span className="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        {/**** RFQ Settings ****/}

                        {/**** Client Registration Settings ****/}
                        <div
                          className={
                            this.state.settings_type === "registration_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="registration_settings"
                        >
                          <div className="row g-gs">
                            <div className="col-lg-12">
                              <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                  <div className="nk-block-head-content">
                                    <h3 className="nk-block-title page-title">
                                      <PageTitle
                                        name="Client Registration Settings"
                                        icon="icon ni ni-user-add"
                                      />
                                    </h3>
                                    <p>
                                      Configure which fields are required or
                                      optional in the client registration form.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {this.state.registrationSettingsLoading === true ? (
                              tableLoader()
                            ) : (
                              <>
                                <div className="col-lg-12">
                                  <div className="card card-bordered">
                                    <div className="card-inner">
                                      <h5 className="card-title mb-4">
                                        Client Registration Field Settings
                                      </h5>

                                      {/* Locked Fields Section */}
                                      <div className="mb-5">
                                        <h6
                                          className="mb-3"
                                          style={{
                                            color: "#8094ae",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.5px",
                                          }}
                                        >
                                          <em
                                            className="icon ni ni-lock-alt"
                                            style={{ marginRight: "5px" }}
                                          ></em>
                                          Always Required Fields
                                        </h6>
                                        <div
                                          style={{
                                            background: "#f5f6fa",
                                            borderRadius: "4px",
                                            padding: "20px",
                                          }}
                                        >
                                          <div className="row g-3">
                                            <div className="col-md-4">
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  padding: "8px 0",
                                                }}
                                              >
                                                <em
                                                  className="icon ni ni-lock-fill"
                                                  style={{
                                                    color: "#8094ae",
                                                    marginRight: "10px",
                                                    fontSize: "16px",
                                                  }}
                                                ></em>
                                                <span
                                                  style={{
                                                    fontWeight: "500",
                                                    color: "#364a63",
                                                  }}
                                                >
                                                  Email Address
                                                </span>
                                                <span
                                                  style={{
                                                    marginLeft: "auto",
                                                    color: "#8094ae",
                                                    fontSize: "13px",
                                                  }}
                                                >
                                                  Required
                                                </span>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  padding: "8px 0",
                                                }}
                                              >
                                                <em
                                                  className="icon ni ni-lock-fill"
                                                  style={{
                                                    color: "#8094ae",
                                                    marginRight: "10px",
                                                    fontSize: "16px",
                                                  }}
                                                ></em>
                                                <span
                                                  style={{
                                                    fontWeight: "500",
                                                    color: "#364a63",
                                                  }}
                                                >
                                                  Password
                                                </span>
                                                <span
                                                  style={{
                                                    marginLeft: "auto",
                                                    color: "#8094ae",
                                                    fontSize: "13px",
                                                  }}
                                                >
                                                  Required
                                                </span>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  padding: "8px 0",
                                                }}
                                              >
                                                <em
                                                  className="icon ni ni-lock-fill"
                                                  style={{
                                                    color: "#8094ae",
                                                    marginRight: "10px",
                                                    fontSize: "16px",
                                                  }}
                                                ></em>
                                                <span
                                                  style={{
                                                    fontWeight: "500",
                                                    color: "#364a63",
                                                  }}
                                                >
                                                  Confirm Password
                                                </span>
                                                <span
                                                  style={{
                                                    marginLeft: "auto",
                                                    color: "#8094ae",
                                                    fontSize: "13px",
                                                  }}
                                                >
                                                  Required
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <p
                                            style={{
                                              margin: "15px 0 0 0",
                                              fontSize: "12px",
                                              color: "#8094ae",
                                            }}
                                          >
                                            <em
                                              className="icon ni ni-info"
                                              style={{ marginRight: "5px" }}
                                            ></em>
                                            These fields cannot be changed and
                                            are always required for security
                                            purposes.
                                          </p>
                                        </div>
                                      </div>

                                      {/* Configurable Fields Section */}
                                      <div>
                                        <h6
                                          className="mb-3"
                                          style={{
                                            color: "#8094ae",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.5px",
                                          }}
                                        >
                                          <em
                                            className="icon ni ni-setting"
                                            style={{ marginRight: "5px" }}
                                          ></em>
                                          Configurable Fields
                                        </h6>
                                        <div
                                          style={{
                                            border: "1px solid #e5e9f2",
                                            borderRadius: "4px",
                                            overflow: "hidden",
                                          }}
                                        >
                                          {[
                                            {
                                              key: "name",
                                              label: "Client Name",
                                            },
                                            {
                                              key: "title",
                                              label: "Client Title",
                                            },
                                            {
                                              key: "client_company",
                                              label: "Company Name",
                                            },
                                            {
                                              key: "client_phone",
                                              label: "Phone Number",
                                            },
                                            {
                                              key: "client_address",
                                              label: "Address",
                                            },
                                            {
                                              key: "client_address2",
                                              label: "Address 2",
                                            },
                                            {
                                              key: "client_city",
                                              label: "City",
                                            },
                                            {
                                              key: "client_state",
                                              label: "State",
                                            },
                                            {
                                              key: "client_zip",
                                              label: "Zip / Postal Code",
                                            },
                                            {
                                              key: "client_country",
                                              label: "Country",
                                            },
                                          ].map((field, index) => (
                                            <div
                                              key={field.key}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "18px 24px",
                                                borderBottom:
                                                  index < 9
                                                    ? "1px solid #e5e9f2"
                                                    : "none",
                                                background:
                                                  index % 2 === 0
                                                    ? "#fff"
                                                    : "#fafbfd",
                                              }}
                                            >
                                              <label
                                                htmlFor={`toggle_${field.key}`}
                                                style={{
                                                  fontWeight: "500",
                                                  color: "#364a63",
                                                  margin: 0,
                                                  flex: "1",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                {field.label}
                                              </label>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "15px",
                                                }}
                                              >
                                                <div
                                                  className="custom-control custom-switch"
                                                  style={{ paddingLeft: "0" }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id={`toggle_${field.key}`}
                                                    checked={
                                                      this.state
                                                        .registrationFields[
                                                        field.key
                                                      ] === "required"
                                                    }
                                                    onChange={() =>
                                                      this.handleRegistrationFieldChange(
                                                        field.key,
                                                        this.state
                                                          .registrationFields[
                                                          field.key
                                                        ] === "required"
                                                          ? "optional"
                                                          : "required",
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor={`toggle_${field.key}`}
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  ></label>
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                        <p
                                          style={{
                                            margin: "15px 0 0 0",
                                            fontSize: "12px",
                                            color: "#8094ae",
                                          }}
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{ marginRight: "5px" }}
                                          ></em>
                                          Toggle ON = Required field | Toggle
                                          OFF = Optional field
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12 text-right">
                                  <div className="form-group">
                                    {this.state.registration_save_button ===
                                    false ? (
                                      <button
                                        type="button"
                                        className="btn btn-lg btn-primary"
                                        onClick={() =>
                                          this.save_registration_settings()
                                        }
                                        // disabled={
                                        //   this.state.disabled ||
                                        //   this.state.permission_registration_edit !== 1
                                        // }
                                      >
                                        <em className="icon ni ni-save"></em>{" "}
                                        &nbsp; Save Settings
                                      </button>
                                    ) : (
                                      <button
                                        className="btn btn-lg btn-primary"
                                        style={{ marginRight: "15px" }}
                                        disabled
                                      >
                                        <em className="icon ni ni-save"></em>{" "}
                                        &nbsp; Save Settings
                                        <div
                                          className="spinner-grow spinner-grow-sm"
                                          role="status"
                                        >
                                          <span className="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        {/**** Client Registration Settings ****/}

                        {/**** Sharelink Settings ****/}
                        <div
                          className={
                            this.state.settings_type === "sharelink_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="sharelink_settings"
                        >
                          <div className="row g-gs">
                            <div className="col-lg-12">
                              <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                  <div className="nk-block-head-content">
                                    <h3 className="nk-block-title page-title">
                                      <PageTitle
                                        name="Sharelink Settings"
                                        icon="icon ni ni-share"
                                      />
                                    </h3>
                                    <p>View all sharelinks for this reseller.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="card card-bordered">
                                <div className="card-inner border-bottom d-flex justify-content-between align-items-center" style={{ gap: 10 }}>
                                  <div className="form-control-wrap" style={{ maxWidth: 360, width: "100%" }}>
                                    <div className="form-icon form-icon-left">
                                      <em className="icon ni ni-search"></em>
                                    </div>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Search by title, agent name, email..."
                                      value={this.state.sharelink_search_input}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        this.setState({ sharelink_search_input: val });
                                        clearTimeout(this._sharelinkSearchTimer);
                                        this._sharelinkSearchTimer = setTimeout(() => {
                                          this.setState({ sharelink_search: val });
                                        }, 300);
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="card-inner p-0">
                                  {this.state.sharelinkTableLoader === true ? (
                                    tableLoader()
                                  ) : (
                                    <>
                                      {filteredSharelinkData && filteredSharelinkData.length > 0 ? (
                                        <ThemeProvider theme={createTheme({
                                          shadows: Array(5).fill("none"),
                                          overrides: {
                                            MUIDataTableHeadCell: { root: { zIndex: 0 }, fixedHeader: { zIndex: 0 } },
                                          },
                                          palette: { primary: { main: THEME_COLOR } },
                                        })}>
                                          <MUIDataTable
                                            title=""
                                            columns={this.state.sharelinkColumns}
                                            data={filteredSharelinkData}
                                            options={{
                                              filter: false,
                                              search: false,
                                              print: false,
                                              download: false,
                                              viewColumns: false,
                                              selectableRows: "none",
                                              rowsPerPage: 50,
                                              rowsPerPageOptions: [25, 50, 100],
                                              jumpToPage: true,
                                              rowHover: true,
                                              responsive: "vertical",
                                              tableBodyHeight: "100%",
                                              tableBodyMinHeight: "200px",
                                            }}
                                          />
                                        </ThemeProvider>
                                      ) : (
                                        <div className="text-center py-5">
                                          <h6 className="mb-1">No sharelinks found</h6>
                                          <p className="text-soft mb-0">
                                            {this.state.sharelink_search
                                              ? "No results match your search."
                                              : "No sharelinks have been created yet."}
                                          </p>
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/**** Sharelink Settings ****/}

                        {/***** Sharelink View Modal *****/}
                        <div className="modal fade zoom" tabIndex="-1" id="modalSharelinkView">
                          <div className="modal-dialog modal-xl" role="document">
                            <div className="modal-content">
                              <div className="modal-header">
                                <div
                                  className="modal-title"
                                  style={{ textAlign: "center", fontSize: "20px" }}
                                >
                                  <strong>
                                    <em className="icon ni ni-link-alt"></em>{" "}
                                    {this.state.sharelinkModalTitle}
                                  </strong>
                                </div>
                                <a
                                  href="#"
                                  className="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <em className="icon ni ni-cross"></em>
                                </a>
                              </div>
                              <div className="modal-body modal-body-lg">
                                <div className="nk-modal">
                                  <div className="nk-modal-text">

                                    <div className="example-alert">
                                      <div className="alert alert-light alert-icon">
                                        <em className="icon ni ni-alert-circle"></em>{" "}
                                        <strong>NOTE: </strong> Share this link with
                                        your clients to showcase services and assist
                                        them with signing up.
                                      </div>
                                    </div>

                                    <div className="row g-3 mb-3 mt-3">
                                      <div className="col-12 col-md-8">
                                        <div className="example-alert mb-3">
                                          <div
                                            className="alert alert-light column"
                                            style={{ wordWrap: "break-word" }}
                                          >
                                            {this.state.sharelinkModalLink}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-12 col-md-4">
                                        {this.state.sharelinkModalLink !== "" ? (
                                          <div className="example-alert mb-3">
                                            <div className="alert alert-light d-flex justify-content-center p-2">
                                              <QRCodeSVG
                                                value={this.state.sharelinkModalLink}
                                                size={200}
                                              />
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>

                                    <div className="row g-2">
                                      <div className="col-12 col-md-auto">
                                        <CopyToClipboard
                                          text={this.state.sharelinkModalLink}
                                          onCopy={() => this.setState({ sharelinkModalCopied: true })}
                                        >
                                          <button className="btn btn-success w-100 w-md-auto">
                                            <em className="icon ni ni-copy"></em> Copy to
                                            clipboard{" "}
                                            {this.state.sharelinkModalCopied ? (
                                              <span style={{ color: "white" }}>
                                                <em className="icon ni ni-done"></em>
                                              </span>
                                            ) : null}
                                          </button>
                                        </CopyToClipboard>
                                      </div>
                                      {/* <div className="col-12 col-md-auto">
                                        <button
                                          className="btn btn-warning w-100 w-md-auto"
                                          onClick={() => this.sharelinkModal_showEmail()}
                                        >
                                          <em className="icon ni ni-emails"></em> Email Link
                                        </button>
                                      </div> */}
                                      <div className="col-12 col-md-auto">
                                        <a
                                          href={this.state.sharelinkModalLink}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="btn btn-secondary w-100 w-md-auto"
                                        >
                                          <em className="icon ni ni-external-alt"></em>{" "}
                                          Preview Sharelink
                                        </a>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/***** Sharelink View Modal *****/}

                        {/***** Sharelink Action Modal *****/}
                        <div className="modal fade zoom" tabIndex="-1" id="modalSharelinkAction">
                          <div className="modal-dialog" role="document">
                            <div className="modal-content">
                              <div className="modal-header">
                                <div
                                  className="modal-title"
                                  style={{ textAlign: "center", fontSize: "20px" }}
                                >
                                  <strong>
                                    <em className="icon ni ni-setting"></em> Sharelink
                                    Settings
                                  </strong>
                                </div>
                                <a
                                  href="#"
                                  className="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <em className="icon ni ni-cross"></em>
                                </a>
                              </div>
                              <div className="modal-body modal-body-lg">
                                <div className="nk-modal">
                                  <div className="nk-modal-text">
                                    <div className="form-group">
                                      <div className="custom-control custom-checkbox">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="sharelinkActionMakeDefault"
                                          checked={this.state.sharelinkActionMakeDefault}
                                          onChange={(e) =>
                                            this.setState({
                                              sharelinkActionMakeDefault: e.target.checked,
                                            })
                                          }
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="sharelinkActionMakeDefault"
                                        >
                                          Make it Default Sharelink
                                        </label>
                                      </div>
                                    </div>

                                    <div className="form-group">
                                      <div className="custom-control custom-checkbox">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="sharelinkActionMakeMain"
                                          checked={this.state.sharelinkActionMakeMain}
                                          onChange={(e) =>
                                            this.setState({
                                              sharelinkActionMakeMain: e.target.checked,
                                            })
                                          }
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="sharelinkActionMakeMain"
                                        >
                                          Make it Main Sharelink
                                        </label>
                                      </div>
                                    </div>

                                    <div style={{ marginTop: "20px" }}>
                                      <button
                                        className="btn btn-primary"
                                        onClick={() =>
                                          this.sharelinkActionModalSaveSettings()
                                        }
                                        disabled={this.state.sharelinkActionSaveLoading}
                                      >
                                        {this.state.sharelinkActionSaveLoading ? (
                                          <>
                                            <em
                                              className="icon ni ni-spinner-alt"
                                              style={{
                                                animation: "spin 1s linear infinite",
                                                marginRight: "5px",
                                              }}
                                            ></em>
                                            Saving...
                                          </>
                                        ) : (
                                          <>
                                            <em className="icon ni ni-check"></em> Save
                                            Settings
                                          </>
                                        )}
                                      </button>
                                    </div>


                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/***** Sharelink View Modal *****/}

                        {/***** Order Settings ****/}
                        <div
                          className={
                            this.state.settings_type === "order_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="order_settings"
                        >
                          <div className="row g-gs">
                            <div className="col-lg-12">
                              <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                  <div className="nk-block-head-content">
                                    <h3 className="nk-block-title page-title">
                                      <PageTitle
                                        name="Billing Settings"
                                        icon="icon ni ni-package"
                                      />
                                    </h3>
                                    <p>
                                      Manage billing summary sections including
                                      discounts, taxes, and additional charges.
                                    </p>
                                  </div>
                                  <div className="nk-block-head-content" style={{ textAlign: "right" }}>
                                    <button
                                      className="btn btn-primary"
                                      onClick={() =>
                                        this.openAddSummarySectionModal()
                                      }
                                    >
                                      <em className="icon ni ni-plus"></em> Add
                                      Billing Module
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <div className="card card-bordered">
                                <div className="card-inner">
                                  <h5 className="card-title mb-4">
                                    Billing Modules
                                  </h5>

                                  {this.state.summarySections.length === 0 ? (
                                    <div
                                      style={{
                                        textAlign: "center",
                                        padding: "40px 20px",
                                        backgroundColor: "#fafbfd",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      <em
                                        className="icon ni ni-inbox"
                                        style={{
                                          fontSize: "48px",
                                          color: "#8094ae",
                                          marginBottom: "10px",
                                          display: "block",
                                        }}
                                      ></em>
                                      <p
                                        style={{
                                          color: "#8094ae",
                                          marginBottom: "0",
                                        }}
                                      >
                                        No billing modules yet. Click "Add
                                        Billing Module" to create one.
                                      </p>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        border: "1px solid #e5e9f2",
                                        borderRadius: "6px",
                                        overflowX: "auto",
                                      }}
                                    >
                                      <DragDropContext
                                        onDragEnd={
                                          this.handleSummarySectionDragEnd
                                        }
                                      >
                                        <table className="table table-ulogs mb-0">
                                          <thead>
                                            <tr>
                                              <th style={{ width: "56px" }}></th>
                                              <th>Module Name</th>
                                              <th>Type</th>
                                              <th>Operation</th>
                                              <th>Scope</th>
                                              <th>View</th>
                                              <th>Active</th>
                                              <th style={{ width: "120px" }}>
                                                Actions
                                              </th>
                                            </tr>
                                          </thead>
                                          <Droppable
                                            droppableId="summary-sections-droppable"
                                          >
                                            {(provided) => (
                                              <tbody
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                              >
                                                {this.state.summarySections.map(
                                                  (section, index) => {
                                                    const fields =
                                                      section.fields || {};
                                                    const typeVisible =
                                                      fields.type &&
                                                      fields.type.visible;
                                                    const valueVisible =
                                                      fields.value &&
                                                      fields.value.visible;
                                                    const descriptionVisible =
                                                      fields.description &&
                                                      fields.description.visible;

                                                    return (
                                                      <Draggable
                                                        key={section.id}
                                                        draggableId={section.id}
                                                        index={index}
                                                      >
                                                        {(provided) => (
                                                          <tr
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            style={{
                                                              backgroundColor:
                                                                index % 2 === 0
                                                                  ? "#fff"
                                                                  : "#fafbfd",
                                                              ...provided
                                                                .draggableProps
                                                                .style,
                                                            }}
                                                          >
                                                            <td>
                                                              <span
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                  cursor: "grab",
                                                                  color:
                                                                    "#8094ae",
                                                                }}
                                                              >
                                                                <em className="icon ni ni-move"></em>
                                                              </span>
                                                            </td>
                                                            <td>
                                                              <span
                                                                style={{
                                                                  fontWeight:
                                                                    "600",
                                                                  color:
                                                                    "#364a63",
                                                                }}
                                                              >
                                                                {
                                                                  section.section_title
                                                                }
                                                              </span>
                                                            </td>
                                                            <td>
                                                              <span className="badge badge-outline-info">
                                                                {section.section_module_type ||
                                                                  "DISCOUNT"}
                                                              </span>
                                                            </td>
                                                            <td>
                                                              <span className={`badge badge-outline-${section.section_type === "ADD" ? "success" : "danger"}`}>
                                                                <em className={`icon ni ${section.section_type === "ADD" ? "ni-plus" : "ni-minus"}`}></em>{" "}
                                                                {section.section_type === "ADD" ? "Adds to subtotal" : "Deducts from subtotal"}
                                                              </span>
                                                            </td>
                                                            <td>
                                                              <span className="badge badge-outline-primary">
                                                                {section.section_scope ===
                                                                "FIXED"
                                                                  ? "Fixed Amount"
                                                                  : "Percentage %"}
                                                              </span>
                                                            </td>
                                                            <td>
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",
                                                                  gap: "8px",
                                                                  flexWrap:
                                                                    "wrap",
                                                                }}
                                                              >
                                                                <span
                                                                  className={`badge ${
                                                                    typeVisible
                                                                      ? "badge-outline-success"
                                                                      : "badge-outline-light"
                                                                  }`}
                                                                >
                                                                  Type
                                                                </span>
                                                                <span
                                                                  className={`badge ${
                                                                    valueVisible
                                                                      ? "badge-outline-success"
                                                                      : "badge-outline-light"
                                                                  }`}
                                                                >
                                                                  Value
                                                                </span>
                                                                <span
                                                                  className={`badge ${
                                                                    descriptionVisible
                                                                      ? "badge-outline-success"
                                                                      : "badge-outline-light"
                                                                  }`}
                                                                >
                                                                  Description
                                                                </span>
                                                              </div>
                                                            </td>
                                                            <td>
                                                              <div className="custom-control custom-switch">
                                                                <input
                                                                  type="checkbox"
                                                                  className="custom-control-input"
                                                                  id={`summary_module_active_${section.id}`}
                                                                  checked={
                                                                    section.section_is_active !== false
                                                                  }
                                                                  onChange={() =>
                                                                    this.toggleSummarySectionActive(
                                                                      section.id,
                                                                    )
                                                                  }
                                                                />
                                                                <label
                                                                  className="custom-control-label"
                                                                  htmlFor={`summary_module_active_${section.id}`}
                                                                ></label>
                                                              </div>
                                                            </td>
                                                            <td>
                                                              <div
                                                                style={{
                                                                  display:
                                                                    "flex",

                                                                }}
                                                              >
                                                                <button
                                                                  className="btn btn-sm btn-icon btn-trigger"
                                                                  onClick={() =>
                                                                    this.openEditSummarySectionModal(
                                                                      section,
                                                                    )
                                                                  }
                                                                >
                                                                  <em className="icon ni ni-edit" style={{ fontSize: "20px" }}></em>
                                                                </button>
                                                                <button
                                                                  className="btn btn-sm btn-icon btn-trigger text-danger"
                                                                  onClick={() =>
                                                                    this.openDeleteSummarySectionModal(section.id)
                                                                  }
                                                                >
                                                                  <em className="icon ni ni-trash" style={{ borderLeft: "1px solid rgba(0,0,0,0.87)", fontSize: "20px" }}></em>
                                                                </button>
                                                                {/* START DELETE BILLING SECTION MODAL  */}
                                                                <div
                                                                  className="modal fade"
                                                                  tabIndex="-1"
                                                                  id="modalDeleteBillingSection"
                                                                >
                                                                  <div className="modal-dialog" role="document">
                                                                    <div className="modal-content">
                                                                      <a
                                                                        style={{ cursor: "pointer" }}
                                                                        className="close"
                                                                        onClick={() => {
                                                                          this.closeDeleteSummarySectionModal();
                                                                        }}
                                                                      >
                                                                        <em className="icon ni ni-cross"></em>
                                                                      </a>
                                                                      <div className="modal-body modal-body-lg text-center">
                                                                        <div className="nk-modal">
                                                                          <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-danger"></em>
                                                                          <h4 className="nk-modal-title">Delete Billing Section</h4>
                                                                          <div className="nk-modal-text">
                                                                            {this.state.billingSectionDeleteError && (
                                                                              <div className="example-alert" style={{ marginBottom: "15px" }}>
                                                                                <div className="alert alert-pro alert-danger">
                                                                                  <div className="alert-text">
                                                                                    <h4>Error</h4>
                                                                                    <p>{this.state.billingSectionDeleteError}</p>
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            )}
                                                                            <div className="caption-text">
                                                                              Are you sure you want to delete this billing section
                                                                            </div>
                                                                          </div>
                                                                          <div className="nk-modal-action">
                                                                            <a
                                                                              style={{ cursor: "pointer" }}
                                                                              className="btn btn-lg btn-mw btn-primary"
                                                                              onClick={() => {
                                                                                this.closeDeleteSummarySectionModal();
                                                                              }}
                                                                              disabled={this.state.billingSectionDeleteProcessing}
                                                                            >
                                                                              CANCEL
                                                                            </a>
                                                                            {"  "}
                                                                            {this.state.billingSectionDeleteProcessing ? (
                                                                              <button
                                                                                className="btn btn-lg btn-mw btn-danger"
                                                                                disabled
                                                                              >
                                                                                <em className="icon ni ni-trash"></em>
                                                                                <span>DELETING</span>
                                                                                <div
                                                                                  className="spinner-grow spinner-grow-sm"
                                                                                  role="status"
                                                                                  style={{ marginLeft: "8px" }}
                                                                                >
                                                                                  <span className="sr-only">Loading...</span>
                                                                                </div>
                                                                              </button>
                                                                            ) : (
                                                                              <button
                                                                                style={{ cursor: "pointer" }}
                                                                                className="btn btn-lg btn-mw btn-danger"
                                                                                onClick={this.submitDeleteSummarySection}
                                                                                disabled={this.state.billingSectionDeleteProcessing}
                                                                              >
                                                                                <span>DELETE</span>
                                                                              </button>
                                                                            )}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                {/* END DELETE BILLING SECTION MODAL  */}
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </Draggable>
                                                    );
                                                  },
                                                )}
                                                {provided.placeholder}
                                              </tbody>
                                            )}
                                          </Droppable>
                                        </table>
                                      </DragDropContext>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                        {/***** Order Settings ****/}

                        {/***** Add Signatory Form *****/}
                        <div
                          className="modal fade flexibleModal"
                          tabIndex="-1"
                          id="modalAddSignatory"
                        >
                          <div
                            className="modal-dialog modal-xl modal-dialog-top"
                            role="document"
                          >
                            <div className="modal-content">
                              <a
                                href="#"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <em className="icon ni ni-cross"></em>
                              </a>
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  Add New Company Profile
                                </h5>
                              </div>
                              <div className="modal-body">
                                <div className="row g-gs">
                                  <div className="col-md-12">
                                    <h6 className="mb-2">
                                      <em className="icon ni ni-building text-primary"></em> Company Information
                                    </h6>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_company"
                                          name="signatory_company"
                                          type="text"
                                          label="Company name *"
                                          value={this.state.signatory_company}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 100, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-12">
                                    <h6 className="mb-2 mt-1">
                                      <em className="icon ni ni-user-list text-primary"></em> Signatory Details
                                    </h6>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_name"
                                          name="signatory_name"
                                          type="text"
                                          label="Legal Name *"
                                          value={this.state.signatory_name}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 50, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_title"
                                          name="signatory_title"
                                          type="text"
                                          label="Title *"
                                          value={this.state.signatory_title}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 32, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_email"
                                          name="signatory_email"
                                          type="text"
                                          label="Email *"
                                          value={this.state.signatory_email}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 50, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <ReactPhoneInput
                                          country="us"
                                          value={(this.state.signatory_phone || "").replace(/^\+/, "")}
                                          onChange={(value) =>
                                            this.handleChange({
                                              target: {
                                                name: "signatory_phone",
                                                value: value ? `+${value}` : "",
                                              },
                                            })
                                          }
                                          inputProps={{
                                            name: "signatory_phone",
                                            id: "signatory_phone",
                                            required: true,
                                            maxLength: 20,
                                          }}
                                          specialLabel="Phone *"
                                          containerStyle={{ width: "100%" }}
                                          inputStyle={{
                                            width: "100%",
                                            height: "56px",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-12">
                                    <h6 className="mb-2 mt-1">
                                      <em className="icon ni ni-map-pin text-primary"></em> Address
                                    </h6>
                                  </div>
                                  <div className="col-lg-4" style={{ position: "relative" }}>
                                    <a
                                      onClick={this.handleToggle}
                                      className="text-primary"
                                      style={{ cursor: "pointer", fontSize: "11px", position: "absolute", top: "0", right: "12px", zIndex: 1 }}
                                    >
                                      {this.state.toggleButtonText}
                                    </a>
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        {this.state.useGooglePlaces ? (
                                          <GooglePlacesAutocomplete
                                            apiKey={
                                              process.env
                                                .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                            }
                                            apiOptions={{ loading: 'async' }}
                                            selectProps={{
                                              value: this.state
                                                .signatory_address
                                                ? {
                                                    label:
                                                      this.state
                                                        .signatory_address,
                                                    value:
                                                      this.state
                                                        .signatory_address,
                                                  }
                                                : null,
                                              onChange:
                                                this.handleAddressSelect,
                                              placeholder: this.state
                                                .signatory_address
                                                ? null
                                                : "Enter your address *",
                                              styles: {
                                                input: (provided) => ({
                                                  ...provided,
                                                  color: "black",
                                                  minHeight: "56px",
                                                }),
                                                option: (provided) => ({
                                                  ...provided,
                                                  color: "black",
                                                }),
                                                singleValue: (provided) => ({
                                                  ...provided,
                                                  color: "black",
                                                }),
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 9,
                                                }),
                                              },
                                            }}
                                            className="googleLocation-autocomplete"
                                          />
                                        ) : (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="signatory_address"
                                            name="signatory_address"
                                            value={this.state.signatory_address}
                                            placeholder="Enter your address"
                                            onChange={this.handleChange}
                                            style={{
                                              borderColor: this.state
                                                .errorAddress
                                                ? "red"
                                                : "initial",
                                              height: "56px",
                                              border: "1px solid #dbdfea",
                                              fontSize: "0.9375rem",
                                            }}
                                          autoComplete="new-password" />
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_address2"
                                          name="signatory_address2"
                                          type="text"
                                          label="Apartment, Suite, Etc. *"
                                          value={this.state.signatory_address2}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 32, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_city"
                                          name="signatory_city"
                                          type="text"
                                          label="City *"
                                          value={this.state.signatory_city}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 32, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_state"
                                          name="signatory_state"
                                          type="text"
                                          label="State *"
                                          value={this.state.signatory_state}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 32, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_zip"
                                          name="signatory_zip"
                                          type="text"
                                          label="Zip *"
                                          value={this.state.signatory_zip}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 32, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <div className="form-group">
                                          <Autocomplete
                                            id="signatory_country"
                                            options={this.countryOptions}
                                            getOptionLabel={(option) => option.label}
                                            value={
                                              this.state.agent_country
                                                ? this.countryOptions.find(opt => opt.label === this.state.agent_country)
                                                : null
                                            }
                                            onChange={(event, newValue) =>
                                              this.handleChangeCountry(newValue)
                                            }
                                            renderInput={(params) => (
                                              <MutextField
                                                {...params}
                                                label="Country *"
                                                variant="outlined"
                                                fullWidth
                                              autoComplete="new-password"
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-12">
                                    <h6 className="mb-2 mt-1">
                                      <em className="icon ni ni-edit-alt text-primary"></em> Signature Image
                                    </h6>
                                  </div>
                                  <div className="col-md-12">
                                    <div
                                      onDragOver={(e) => this.handleSignatoryDragOver(e)}
                                      onDragLeave={(e) => this.handleSignatoryDragLeave(e)}
                                      onDrop={(e) => this.handleSignatoryDrop(e)}
                                      style={{
                                        border: `2px dashed ${this.state.signatory_drag_over ? "#6576ff" : "#dbdfea"}`,
                                        borderRadius: 8,
                                        padding: "24px 20px",
                                        textAlign: "center",
                                        position: "relative",
                                        background: this.state.signatory_drag_over ? "#f5f6ff" : "#f9fafb",
                                        transition: "all .2s",
                                      }}
                                    >
                                      <input
                                        ref={this.signatoryFileInputRef}
                                        type="file"
                                        id="add_picture"
                                        name="add_picture"
                                        accept=".png, .jpg, .jpeg"
                                        onChange={this.handleFileChange}
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          opacity: 0,
                                          cursor: "pointer",
                                          width: "100%",
                                          height: "100%",
                                        }}
                                      />
                                      <div style={{ fontSize: 24, marginBottom: 8 }}>
                                        <em className="icon ni ni-upload-cloud"></em>
                                      </div>
                                      <div style={{ fontWeight: 600, marginBottom: 3 }}>
                                        Drop signature image here or <span style={{ color: "#6576ff", textDecoration: "underline" }}>browse files</span>
                                      </div>
                                      <div className="text-soft" style={{ fontSize: 12 }}>
                                        Signature image of the signatory
                                      </div>
                                      <div className="d-flex justify-content-center mt-2" style={{ gap: 6, flexWrap: "wrap" }}>
                                        <span className="badge badge-dim badge-outline-light">PNG</span>
                                        <span className="badge badge-dim badge-outline-light">JPEG</span>
                                        <span className="badge badge-dim badge-outline-light">JPG</span>
                                        <span className="badge badge-dim badge-outline-light">Max 10MB</span>
                                      </div>
                                      <div className="text-soft mt-2" style={{ fontSize: 12 }}>
                                        Recommended: W:300×H:66px · Minimum: W:200×H:44px
                                      </div>
                                    </div>
                                    <div className="d-flex mt-2" style={{ gap: 8 }}>
                                      <button
                                        type="button"
                                        className="btn btn-dim btn-outline-light btn-sm"
                                        onClick={() => this.clearSignatoryUpload(false)}
                                      >
                                        <em className="icon ni ni-cross"></em>
                                        <span>Remove</span>
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-dim btn-outline-light btn-sm"
                                        onClick={this.downloadCroppedSignature}
                                      >
                                        <em className="icon ni ni-download"></em>
                                        <span>Download resized PNG</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div className="col-md-12">
                                    {this.state.add_picture && (
                                      <div style={{ margin: "15px 0 0 0" }}>
                                        <Cropper
                                          src={this.state.add_picture}
                                          style={{
                                            height: 400,
                                            width: "100%",
                                            filter: `brightness(${this.state.brightness}%)`,
                                          }}
                                          viewMode={1}
                                          autoCropArea={1}
                                          dragMode="move"
                                          background={false}
                                          guides={true}
                                          zoomable={true}
                                          crop={this.onCrop}
                                          ref={this.cropperRef}
                                          rotatable={true}
                                          ready={this.handleReady}
                                        />
                                        <div
                                          style={{ margin: "10px 0 10px 0" }}
                                        >
                                          <p id="cropSize">No crop selected</p>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                          }}
                                        >
                                          <Tooltip
                                            title="Zoom In"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.handleZoomIn()
                                              }
                                            >
                                              <em
                                                className="icon ni ni-zoom-in"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>
                                          <Tooltip
                                            title="Zoom Out"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.handleZoomOut()
                                              }
                                            >
                                              <em
                                                className="icon ni ni-zoom-out"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>
                                          <Tooltip
                                            title="Rotate Left"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.rotateImage(-15)
                                              }
                                            >
                                              <em
                                                className="icon ni ni-curve-up-left"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>
                                          <Tooltip
                                            title="Rotate Right"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.rotateImage(15)
                                              }
                                            >
                                              <em
                                                className="icon ni ni-curve-up-right"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>

                                          <Tooltip
                                            title="Flip Horizontal"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.flipHorizontal()
                                              }
                                            >
                                              <em
                                                className="icon ni ni-swap"
                                                style={{ color: "white" }}
                                              ></em>{" "}
                                            </a>
                                          </Tooltip>

                                          <Tooltip
                                            title="Flip Vertical"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.flipVertical()
                                              }
                                            >
                                              <em
                                                className="icon ni ni-swap-v"
                                                style={{ color: "white" }}
                                              ></em>{" "}
                                            </a>
                                          </Tooltip>
                                          <Tooltip
                                            title="Adjust Brightness"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={
                                                this.toggleBrightnessRange
                                              }
                                            >
                                              <em
                                                className="icon ni ni-sun-fill"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>
                                          {showBrightnessRange && (
                                            <input
                                              type="range"
                                              min="0"
                                              max="200"
                                              value={brightness}
                                              onChange={
                                                this.handleBrightnessChange
                                              }
                                              style={{
                                                width: "15%",
                                                cursor: "pointer",
                                              }}
                                            autoComplete="new-password" />
                                          )}
                                          <Tooltip
                                            title="Reset Crop"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-danger"
                                              onClick={() =>
                                                this.handleResetCrop(15)
                                              }
                                            >
                                              <em
                                                className="icon ni ni-reload-alt"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>
                                        </div>
                                        <div className="col-md-12 mt-3 p-0">
                                          <div className="example-alert">
                                            <div className="alert alert-light">
                                              <ul className="list">
                                                <li>
                                                  Double-click on the image to
                                                  drag it.
                                                </li>
                                                <li>
                                                  Use the{" "}
                                                  <b>
                                                    <em className="icon ni ni-zoom-in"></em>
                                                  </b>{" "}
                                                  button to zoom in and the{" "}
                                                  <b>
                                                    <em className="icon ni ni-zoom-out"></em>
                                                  </b>{" "}
                                                  button to zoom out.
                                                </li>
                                                <li>
                                                  Use the{" "}
                                                  <b>
                                                    <em className="icon ni ni-curve-up-left"></em>
                                                  </b>{" "}
                                                  icon to rotate left and the{" "}
                                                  <b>
                                                    <em className="icon ni ni-curve-up-right"></em>{" "}
                                                  </b>
                                                  icon to rotate right.
                                                </li>
                                                <li>
                                                  Use the{" "}
                                                  <b>
                                                    <em className="icon ni ni-swap-v"></em>
                                                  </b>{" "}
                                                  icon to flip vertical and the{" "}
                                                  <b>
                                                    <em className="icon ni ni-swap"></em>{" "}
                                                  </b>
                                                  icon to flip horizontal.
                                                </li>
                                                <li>
                                                  Use the{" "}
                                                  <b>
                                                    <em className="icon ni ni-reload-alt"></em>
                                                  </b>{" "}
                                                  button to reset the image and
                                                  crop box.
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-12 mt-2">
                                    <div className="example-alert">
                                      <div className="alert alert-light">
                                        <ul className="list">
                                          <li>
                                            Accepted Formats: PNG, JPEG, JPG
                                          </li>
                                          <li>Recommended Size: 5MB</li>
                                          <li>
                                            <b>Recommended Dimensions:</b>
                                            <br /> Maximum (W:300 x H:66)
                                            <br /> Minimum (W:200 x H:44)
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="modal-footer"
                                style={{ justifyContent: "right" }}
                              >
                                <div className="d-flex justify-content-end">
                                  {this.state.signatory_button === true ? (
                                    <button
                                      className="btn btn-lg btn-primary"
                                      disabled
                                    >
                                      <em className="icon ni ni-save"></em>{" "}
                                      Saving
                                      <div
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                      >
                                        <span className="sr-only">
                                          Loading...
                                        </span>
                                      </div>
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-lg btn-primary"
                                      onClick={() => this.submitSignatory()}
                                    >
                                      <em className="icon ni ni-save"></em>{" "}
                                      &nbsp; Save Signatory
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/***** Add Signatory Form *****/}
                        <div className="modal fade" tabIndex="-1" id="modalViewSignatory">
                          <div className="modal-dialog modal-lg modal-dialog-top" role="document">
                            <div className="modal-content">
                              <a
                                href="#"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => this.closeViewSignatory()}
                              >
                                <em className="icon ni ni-cross"></em>
                              </a>
                              <div className="modal-header">
                                <h5 className="modal-title">Company Profile Details</h5>
                              </div>
                              <div className="modal-body">
                                {this.state.signatory_view_data ? (
                                  <div className="row g-3">
                                    <div className="col-md-6">
                                      <strong>Company Name</strong>
                                      <p className="mb-0">{this.state.signatory_view_data.company || "---"}</p>
                                    </div>
                                    <div className="col-md-6">
                                      <strong>Legal Name</strong>
                                      <p className="mb-0">{this.state.signatory_view_data.name || "---"}</p>
                                    </div>
                                    <div className="col-md-6">
                                      <strong>Profile Title</strong>
                                      <p className="mb-0">{this.state.signatory_view_data.title || "---"}</p>
                                    </div>
                                    <div className="col-md-6">
                                      <strong>Email</strong>
                                      <p className="mb-0">{this.state.signatory_view_data.email || "---"}</p>
                                    </div>
                                    <div className="col-md-6">
                                      <strong>Phone</strong>
                                      <p className="mb-0">{this.state.signatory_view_data.phone || "---"}</p>
                                    </div>
                                    <div className="col-md-6">
                                      <strong>Address</strong>
                                      <p className="mb-0">
                                        {this.state.signatory_view_data.address || "---"}
                                        {this.state.signatory_view_data.addsignatory_address2
                                          ? `, ${this.state.signatory_view_data.addsignatory_address2}`
                                          : ""}
                                      </p>
                                    </div>
                                    <div className="col-md-6">
                                      <strong>City / State / ZIP</strong>
                                      <p className="mb-0">
                                        {[
                                          this.state.signatory_view_data.city,
                                          this.state.signatory_view_data.state,
                                          this.state.signatory_view_data.zip,
                                        ]
                                          .filter(Boolean)
                                          .join(", ") || "---"}
                                      </p>
                                    </div>
                                    <div className="col-md-6">
                                      <strong>Country</strong>
                                      <p className="mb-0">{this.state.signatory_view_data.country || "---"}</p>
                                    </div>
                                    <div className="col-md-12">
                                      <strong>Signature</strong>
                                      <div className="mt-2">
                                        {this.state.signatory_view_data.signature_image ? (
                                          <img
                                            src={this.getSignatorySignatureUrl(this.state.signatory_view_data.signature_image)}
                                            alt="Signature"
                                            style={{ maxWidth: 260, maxHeight: 70 }}
                                          />
                                        ) : (
                                          <p className="mb-0">Not uploaded</p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <p className="mb-0">Profile details unavailable.</p>
                                )}
                              </div>
                              <div className="modal-footer" style={{ justifyContent: "right" }}>
                                <button type="button" className="btn btn-lg btn-light" onClick={() => this.closeViewSignatory()}>
                                  Close
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/***** Delete Signatory Alert *****/}
                        <div
                          className="modal fade"
                          tabIndex="-1"
                          id="modalDeleteSignatory"
                        >
                          <div
                            className="modal-dialog modal-dialog-top"
                            role="document"
                          >
                            <div className="modal-content">
                              <a
                                href="#"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <em className="icon ni ni-cross"></em>
                              </a>
                              <div className="modal-header">
                                <h5 className="modal-title">Confirmation</h5>
                              </div>
                              <div className="modal-body">
                                {this.state.signatoryDeleteSuccessMessage ===
                                "" ? (
                                  <p>
                                    Are you certain you wish to delete the
                                    profile? This action will result in the
                                    removal of the profile from all associated
                                    agreements.
                                  </p>
                                ) : null}
                              </div>
                              <div
                                className="modal-footer"
                                style={{ justifyContent: "right" }}
                              >
                                <div className="d-flex justify-content-end">
                                  {this.state.signatoryDeleteSuccessMessage !==
                                  "" ? (
                                    <button
                                      type="button"
                                      className="btn btn-lg btn-light"
                                      onClick={() => this.closeDeleteSignatory()}
                                    >
                                      Close
                                    </button>
                                  ) : (
                                    <>
                                      <button
                                        type="button"
                                        className="btn btn-lg btn-light"
                                        style={{ marginRight: "15px" }}
                                        onClick={() => this.closeDeleteSignatory()}
                                      >
                                        No
                                      </button>
                                      {this.state.signatory_button_delete ===
                                      true ? (
                                        <button
                                          className="btn btn-lg btn-primary"
                                          disabled
                                        >
                                          <em className="icon ni ni-swap"></em>{" "}
                                          Deleting
                                          <div
                                            className="spinner-grow spinner-grow-sm"
                                            role="status"
                                          >
                                            <span className="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          className="btn btn-lg btn-primary"
                                          onClick={() =>
                                            this.submitDeleteSignatory()
                                          }
                                        >
                                          Yes
                                        </button>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/***** Delete Signatory Alert *****/}
                        <div
                          className="modal fade flexibleModal"
                          tabIndex="-1"
                          id="modalUpdateSignatory"
                        >
                          <div
                            className="modal-dialog modal-xl modal-dialog-top"
                            role="document"
                          >
                            <div className="modal-content">
                              <a
                                href="#"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <em className="icon ni ni-cross"></em>
                              </a>
                              <div className="modal-header">
                                <h5 className="modal-title">Update Profile</h5>
                              </div>
                              <div className="modal-body">
                                <div className="row g-gs">
                                  <div className="col-md-12">
                                    <h6 className="mb-2">
                                      <em className="icon ni ni-building text-primary"></em> Company Information
                                    </h6>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_company"
                                          name="signatory_company"
                                          type="text"
                                          label="Company Name *"
                                          value={this.state.signatory_company}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 100, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-12">
                                    <h6 className="mb-2 mt-1">
                                      <em className="icon ni ni-user-list text-primary"></em> Signatory Details
                                    </h6>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_name"
                                          name="signatory_name"
                                          type="text"
                                          label=" Legal Name *"
                                          value={this.state.signatory_name}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 50, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_title"
                                          name="signatory_title"
                                          type="text"
                                          label="Profile Title *"
                                          value={this.state.signatory_title}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 32, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_email"
                                          name="signatory_email"
                                          type="text"
                                          label="Email *"
                                          value={this.state.signatory_email}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 50, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <ReactPhoneInput
                                          country="us"
                                          value={(this.state.signatory_phone || "").replace(/^\+/, "")}
                                          onChange={(value) =>
                                            this.handleChange({
                                              target: {
                                                name: "signatory_phone",
                                                value: value ? `+${value}` : "",
                                              },
                                            })
                                          }
                                          inputProps={{
                                            name: "signatory_phone",
                                            id: "signatory_phone",
                                            required: true,
                                            maxLength: 20,
                                          }}
                                          specialLabel="Phone Number *"
                                          containerStyle={{ width: "100%" }}
                                          inputStyle={{
                                            width: "100%",
                                            height: "56px",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-12">
                                    <h6 className="mb-2 mt-1">
                                      <em className="icon ni ni-map-pin text-primary"></em> Address
                                    </h6>
                                  </div>
                                  <div className="col-lg-4" style={{ position: "relative" }}>
                                    <a
                                      onClick={this.handleToggle}
                                      className="text-primary"
                                      style={{ cursor: "pointer", fontSize: "11px", position: "absolute", top: "0", right: "12px", zIndex: 1 }}
                                    >
                                      {this.state.toggleButtonText}
                                    </a>
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        {this.state.useGooglePlaces ? (
                                          <GooglePlacesAutocomplete
                                            apiKey={
                                              process.env
                                                .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                            }
                                            apiOptions={{ loading: 'async' }}
                                            selectProps={{
                                              value: this.state
                                                .signatory_address
                                                ? {
                                                    label:
                                                      this.state
                                                        .signatory_address,
                                                    value:
                                                      this.state
                                                        .signatory_address,
                                                  }
                                                : null,
                                              onChange:
                                                this.handleAddressSelect,
                                              placeholder: this.state
                                                .signatory_address
                                                ? null
                                                : "Enter your address *",
                                              styles: {
                                                input: (provided) => ({
                                                  ...provided,
                                                  color: "black",
                                                  minHeight: "56px",
                                                }),
                                                option: (provided) => ({
                                                  ...provided,
                                                  color: "black",
                                                }),
                                                singleValue: (provided) => ({
                                                  ...provided,
                                                  color: "black",
                                                }),
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 9,
                                                }),
                                              },
                                            }}
                                            className="googleLocation-autocomplete"
                                          />
                                        ) : (
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="signatory_address"
                                            name="signatory_address"
                                            value={this.state.signatory_address}
                                            placeholder="Enter your address"
                                            onChange={this.handleChange}
                                            style={{
                                              borderColor: this.state
                                                .errorAddress
                                                ? "red"
                                                : "initial",
                                              height: "56px",
                                              border: "1px solid #dbdfea",
                                              fontSize: "0.9375rem",
                                            }}
                                          autoComplete="new-password" />
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_address2"
                                          name="signatory_address2"
                                          type="text"
                                          label="Apartment, Suite, Etc. *"
                                          value={this.state.signatory_address2}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 100, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_city"
                                          name="signatory_city"
                                          type="text"
                                          label="City *"
                                          value={this.state.signatory_city}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 32, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_state"
                                          name="signatory_state"
                                          type="text"
                                          label="State *"
                                          value={this.state.signatory_state}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 32, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <MutextField
                                          id="signatory_zip"
                                          name="signatory_zip"
                                          type="text"
                                          label="Zip *"
                                          value={this.state.signatory_zip}
                                          onChange={this.handleChange}
                                          error={this.state.errorvalidity}
                                          inputProps={{
                                            maxLength: 32, // Set the maximum length to 10 characters
                                          }}
                                          variant="outlined"
                                          fullWidth
                                        autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <div className="form-control-group">
                                        <div className="form-group">
                                          <Autocomplete
                                            id="signatory_country"
                                            options={this.countryOptions}
                                            getOptionLabel={(option) => option.label}
                                            value={
                                              this.state.agent_country
                                                ? this.countryOptions.find(opt => opt.label === this.state.agent_country)
                                                : null
                                            }
                                            onChange={(event, newValue) =>
                                              this.handleChangeCountry(newValue)
                                            }
                                            renderInput={(params) => (
                                              <MutextField
                                                {...params}
                                                label="Country *"
                                                variant="outlined"
                                                fullWidth
                                              autoComplete="new-password"
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-12">
                                    <h6 className="mb-2 mt-1">
                                      <em className="icon ni ni-edit-alt text-primary"></em> Signature Image
                                    </h6>
                                  </div>
                                  <div className="col-md-12">
                                    <div
                                      onDragOver={(e) => this.handleSignatoryDragOver(e, true)}
                                      onDragLeave={(e) => this.handleSignatoryDragLeave(e, true)}
                                      onDrop={(e) => this.handleSignatoryDrop(e, true)}
                                      style={{
                                        border: `2px dashed ${this.state.signatory_drag_over_update ? "#6576ff" : "#dbdfea"}`,
                                        borderRadius: 8,
                                        padding: "24px 20px",
                                        textAlign: "center",
                                        position: "relative",
                                        background: this.state.signatory_drag_over_update ? "#f5f6ff" : "#f9fafb",
                                        transition: "all .2s",
                                      }}
                                    >
                                      <input
                                        ref={this.signatoryFileInputUpdateRef}
                                        type="file"
                                        id="add_picture_update"
                                        name="add_picture_update"
                                        accept=".png, .jpg, .jpeg"
                                        onChange={this.handleFileChangeUpdate}
                                        style={{
                                          position: "absolute",
                                          inset: 0,
                                          opacity: 0,
                                          cursor: "pointer",
                                          width: "100%",
                                          height: "100%",
                                        }}
                                      />
                                      <div style={{ fontSize: 24, marginBottom: 8 }}>
                                        <em className="icon ni ni-upload-cloud"></em>
                                      </div>
                                      <div style={{ fontWeight: 600, marginBottom: 3 }}>
                                        Drop signature image here or <span style={{ color: "#6576ff", textDecoration: "underline" }}>browse files</span>
                                      </div>
                                      <div className="text-soft" style={{ fontSize: 12 }}>
                                        Signature image of the signatory
                                      </div>
                                      <div className="d-flex justify-content-center mt-2" style={{ gap: 6, flexWrap: "wrap" }}>
                                        <span className="badge badge-dim badge-outline-light">PNG</span>
                                        <span className="badge badge-dim badge-outline-light">JPEG</span>
                                        <span className="badge badge-dim badge-outline-light">JPG</span>
                                        <span className="badge badge-dim badge-outline-light">Max 10MB</span>
                                      </div>
                                      <div className="text-soft mt-2" style={{ fontSize: 12 }}>
                                        Recommended: W:300×H:66px · Minimum: W:200×H:44px
                                      </div>
                                    </div>
                                    <div className="d-flex mt-2" style={{ gap: 8 }}>
                                      <button
                                        type="button"
                                        className="btn btn-dim btn-outline-light btn-sm"
                                        onClick={() => this.clearSignatoryUpload(true)}
                                      >
                                        <em className="icon ni ni-cross"></em>
                                        <span>Remove</span>
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-dim btn-outline-light btn-sm"
                                        onClick={this.downloadCroppedSignature}
                                      >
                                        <em className="icon ni ni-download"></em>
                                        <span>Download resized PNG</span>
                                      </button>
                                    </div>
                                  </div>
                                  {this.state.add_picture_existing &&
                                    !this.state.add_picture_update && (
                                      <div className="col-lg-6">
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                              }}
                                            >
                                              <label className="form-label">
                                                <Tooltip
                                                  title="Previous Signature."
                                                  placement="right"
                                                >
                                                  <em
                                                    className="icon ni ni-info"
                                                    style={{ color: "#6576ff" }}
                                                  ></em>
                                                </Tooltip>{" "}
                                                Previous Signature
                                                <span className="text-danger"></span>
                                              </label>
                                              {this.state.loading ? (
                                                <div
                                                  className="text-center"
                                                  style={{
                                                    color: "#6576ff",

                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 0.7)",
                                                    borderRadius: "5px",
                                                    padding: "5px",
                                                    marginBottom: "2px",
                                                  }}
                                                >
                                                  <div
                                                    className="spinner-border spinner-border-sm text-primary"
                                                    role="status"
                                                  >
                                                    <span className="sr-only">
                                                      Loading...
                                                    </span>
                                                  </div>
                                                </div>
                                              ) : (
                                                <a
                                                  href="#"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    this.setState({
                                                      loading: true,
                                                    });
                                                    setTimeout(() => {
                                                      fetch(
                                                        this.state
                                                          .add_picture_existing,
                                                      )
                                                        .then((response) =>
                                                          response.blob(),
                                                        )
                                                        .then((blob) => {
                                                          const url =
                                                            window.URL.createObjectURL(
                                                              blob,
                                                            );
                                                          const a =
                                                            document.createElement(
                                                              "a",
                                                            );
                                                          a.href = url;
                                                          a.download =
                                                            "image.png";
                                                          document.body.appendChild(
                                                            a,
                                                          );
                                                          a.click();
                                                          document.body.removeChild(
                                                            a,
                                                          );
                                                          window.URL.revokeObjectURL(
                                                            url,
                                                          );
                                                          this.setState({
                                                            loading: false,
                                                          });
                                                        })
                                                        .catch((error) => {
                                                          console.error(
                                                            "Download error:",
                                                            error,
                                                          );
                                                          this.setState({
                                                            loading: false,
                                                          });
                                                        });
                                                    }, 500);
                                                  }}
                                                  style={{
                                                    color: "#6576ff",
                                                    backgroundColor:
                                                      "rgba(255, 255, 255, 0.7)",
                                                    borderRadius: "5px",
                                                    padding: "5px",
                                                    marginBottom: "2px",
                                                  }}
                                                  title="Download Image"
                                                >
                                                  <em
                                                    className="icon ni ni-download"
                                                    style={{ fontSize: "18px" }}
                                                  ></em>
                                                </a>
                                              )}
                                            </div>
                                          </div>
                                          <div className="form-control-group signatory_upload">
                                            <div
                                              style={{
                                                position: "relative",
                                                maxWidth: "60%",
                                                margin: "0 auto",
                                                display: "block",
                                              }}
                                            >
                                              <img
                                                src={
                                                  this.state
                                                    .add_picture_existing
                                                }
                                                alt="Previous Signature"
                                                style={{
                                                  maxWidth: "80%",
                                                  height: "auto",
                                                  display: "block",
                                                  margin: "0 auto",
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                  <div className="col-md-12">
                                    {this.state.add_picture_update && (
                                      <div style={{ margin: "15px 0 0 0" }}>
                                        <Cropper
                                          src={this.state.add_picture_update}
                                          style={{
                                            height: 400,
                                            width: "100%",
                                            filter: `brightness(${this.state.brightness}%)`,
                                          }}
                                          viewMode={1}
                                          autoCropArea={1}
                                          dragMode="move"
                                          background={false}
                                          guides={true}
                                          zoomable={true}
                                          crop={this.onCropUpdate}
                                          ref={this.cropperRef}
                                          rotatable={true}
                                          ready={this.handleReady}
                                        />
                                        <div
                                          style={{ margin: "10px 0 10px 0" }}
                                        >
                                          <p id="cropSize">No crop selected</p>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                          }}
                                        >
                                          <Tooltip
                                            title="Zoom In"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.handleZoomIn()
                                              }
                                            >
                                              <em
                                                className="icon ni ni-zoom-in"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>
                                          <Tooltip
                                            title="Zoom Out"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.handleZoomOut()
                                              }
                                            >
                                              <em
                                                className="icon ni ni-zoom-out"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>
                                          <Tooltip
                                            title="Rotate Left"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.rotateImage(-15)
                                              }
                                            >
                                              <em
                                                className="icon ni ni-curve-up-left"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>
                                          <Tooltip
                                            title="Rotate Right"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.rotateImage(15)
                                              }
                                            >
                                              <em
                                                className="icon ni ni-curve-up-right"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>

                                          <Tooltip
                                            title="Flip Horizontal"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.flipHorizontal()
                                              }
                                            >
                                              <em
                                                className="icon ni ni-swap"
                                                style={{ color: "white" }}
                                              ></em>{" "}
                                            </a>
                                          </Tooltip>

                                          <Tooltip
                                            title="Flip Vertical"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={() =>
                                                this.flipVertical()
                                              }
                                            >
                                              <em
                                                className="icon ni ni-swap-v"
                                                style={{ color: "white" }}
                                              ></em>{" "}
                                            </a>
                                          </Tooltip>
                                          <Tooltip
                                            title="Adjust Brightness"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-primary"
                                              onClick={
                                                this.toggleBrightnessRange
                                              }
                                            >
                                              <em
                                                className="icon ni ni-sun-fill"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>
                                          {showBrightnessRange && (
                                            <input
                                              type="range"
                                              min="0"
                                              max="200"
                                              value={brightness}
                                              onChange={
                                                this.handleBrightnessChange
                                              }
                                              style={{
                                                width: "15%",
                                                cursor: "pointer",
                                              }}
                                            autoComplete="new-password" />
                                          )}
                                          <Tooltip
                                            title="Reset Crop"
                                            placement="top"
                                          >
                                            <a
                                              className="btn btn-icon btn-sm btn-danger"
                                              onClick={() =>
                                                this.handleResetCrop(15)
                                              }
                                            >
                                              <em
                                                className="icon ni ni-reload-alt"
                                                style={{ color: "white" }}
                                              ></em>
                                            </a>
                                          </Tooltip>
                                        </div>
                                        <div className="col-md-12 mt-3 p-0">
                                          <div className="example-alert">
                                            <div className="alert alert-light">
                                              <ul className="list">
                                                <li>
                                                  Double-click on the image to
                                                  drag it.
                                                </li>
                                                <li>
                                                  Use the{" "}
                                                  <b>
                                                    <em className="icon ni ni-zoom-in"></em>
                                                  </b>{" "}
                                                  button to zoom in and the{" "}
                                                  <b>
                                                    <em className="icon ni ni-zoom-out"></em>
                                                  </b>{" "}
                                                  button to zoom out.
                                                </li>
                                                <li>
                                                  Use the{" "}
                                                  <b>
                                                    <em className="icon ni ni-curve-up-left"></em>
                                                  </b>{" "}
                                                  icon to rotate left and the{" "}
                                                  <b>
                                                    <em className="icon ni ni-curve-up-right"></em>{" "}
                                                  </b>
                                                  icon to rotate right.
                                                </li>
                                                <li>
                                                  Use the{" "}
                                                  <b>
                                                    <em className="icon ni ni-swap-v"></em>
                                                  </b>{" "}
                                                  icon to flip vertical and the{" "}
                                                  <b>
                                                    <em className="icon ni ni-swap"></em>{" "}
                                                  </b>
                                                  icon to flip horizontal.
                                                </li>
                                                <li>
                                                  Use the{" "}
                                                  <b>
                                                    <em className="icon ni ni-reload-alt"></em>
                                                  </b>{" "}
                                                  button to reset the image and
                                                  crop box.
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-12 mt-2">
                                    <div className="example-alert">
                                      <div className="alert alert-light">
                                        <ul className="list">
                                          <li>
                                            Accepted Formats: PNG, JPEG, JPG
                                          </li>
                                          <li>Recommended Size: 5MB</li>
                                          <li>
                                            <b>Recommended Dimensions:</b>
                                            <br /> Maximum (W:300 x H:66)
                                            <br /> Minimum (W:200 x H:44)
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="modal-footer"
                                style={{ justifyContent: "right" }}
                              >
                                <div className="d-flex justify-content-end">
                                  {this.state.signatory_button === true ? (
                                    <button
                                      className="btn btn-lg btn-primary"
                                      disabled
                                    >
                                      <em className="icon ni ni-swap"></em>{" "}
                                      Updating
                                      <div
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                      >
                                        <span className="sr-only">
                                          Loading...
                                        </span>
                                      </div>
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-lg btn-primary"
                                      onClick={() =>
                                        this.submitUpdateSignatory()
                                      }
                                    >
                                      Update Signatory
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* UPDATE MODAL START */}
                        {/* Password Verification Modal */}
                        <div
                          className={`modal fade ${
                            this.state.showPasswordVerificationModal
                              ? "show"
                              : ""
                          }`}
                          tabIndex="-1"
                          id="modalPasswordVerification"
                          style={{
                            display: this.state.showPasswordVerificationModal
                              ? "block"
                              : "none",
                            backgroundColor: this.state
                              .showPasswordVerificationModal
                              ? "rgba(0,0,0,0.5)"
                              : "transparent",
                          }}
                        >
                          <div
                            className="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  <em className="icon ni ni-lock-fill"></em>{" "}
                                  Verify Your Password
                                </h5>
                                <button
                                  type="button"
                                  className="close"
                                  onClick={this.closePasswordVerificationModal}
                                  aria-label="Close"
                                  style={{
                                    outline: "none",
                                    boxShadow: "none",
                                    border: "none",
                                    background: "none",
                                  }}
                                  onFocus={(e) =>
                                    (e.target.style.outline = "none")
                                  }
                                  onBlur={(e) =>
                                    (e.target.style.outline = "none")
                                  }
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                {this.state.loginPasswordError !== "" && (
                                  <div
                                    className="alert alert-danger"
                                    role="alert"
                                  >
                                    <small>
                                      <em
                                        className="icon ni ni-alert-circle"
                                        style={{ marginRight: "5px" }}
                                      ></em>
                                      {this.state.loginPasswordError}
                                    </small>
                                  </div>
                                )}
                                <div className="example-alert mb-3">
                                  <div
                                    className="alert alert-light alert-icon"
                                    style={{ paddingLeft: "3rem" }}
                                  >
                                    <em
                                      className="icon ni ni-info"
                                      style={{ marginTop: "2px" }}
                                    ></em>
                                    Please enter your login password to view the
                                    SMTP password.
                                  </div>
                                </div>
                                <div className="form-group">
                                  <div className="form-control-wrap">
                                    <input
                                      type={
                                        this.state.passwordShownVerify
                                          ? "text"
                                          : "password"
                                      }
                                      className="form-control form-control-lg"
                                      placeholder="Enter your login password"
                                      value={this.state.loginPassword}
                                      onChange={this.handleLoginPasswordChange}
                                      onKeyPress={
                                        this.handleLoginPasswordKeyPress
                                      }
                                      disabled={this.state.verifyingPassword}
                                      autoFocus
                                    autoComplete="new-password" />
                                    <a
                                      style={{
                                        left: "auto",
                                        right: "2px",
                                        top: "22px",
                                        position: "absolute",
                                        cursor: "pointer",
                                      }}
                                      tabIndex="-1"
                                      onClick={this.togglePasswordVerify}
                                      className="form-icon form-icon-right passcode-switch"
                                      data-target="password"
                                    >
                                      {this.state.passwordShownVerify ? (
                                        <em className="icon ni ni-eye-off"></em>
                                      ) : (
                                        <em className="icon ni ni-eye"></em>
                                      )}
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="modal-footer"
                                style={{
                                  justifyContent: "flex-end",
                                  padding: "1.25rem",
                                }}
                              >
                                <div className="d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={
                                      this.closePasswordVerificationModal
                                    }
                                    disabled={this.state.verifyingPassword}
                                    style={{ marginRight: "10px" }}
                                  >
                                    Cancel
                                  </button>
                                  {this.state.verifyingPassword ? (
                                    <button
                                      className="btn btn-primary"
                                      disabled
                                    >
                                      <div
                                        className="spinner-grow spinner-grow-sm mr-2"
                                        role="status"
                                      >
                                        <span className="sr-only">
                                          Loading...
                                        </span>
                                      </div>
                                      Verifying...
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={this.verifyLoginPassword}
                                    >
                                      <em className="icon ni ni-check"></em>
                                      Verify Password
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Password Verification Modal */}
                        {/* START DELETE MODAL  */}
                        <div
                          className="modal fade"
                          tabIndex="-1"
                          id="modalDeleteAlert"
                        >
                          <div className="modal-dialog" role="document">
                            <div className="modal-content">
                              <a
                                style={{ cursor: "pointer" }}
                                className="close"
                                onClick={() => {
                                  this.modalHideDel();
                                }}
                              >
                                <em className="icon ni ni-cross"></em>
                              </a>
                              <div className="modal-body modal-body-lg text-center">
                                <div className="nk-modal">
                                  <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>

                                  <h4 className="nk-modal-title">
                                    {this.state.onboarding_id
                                      ? "Delete Onboarding Item?"
                                      : "Delete Domain?"}
                                  </h4>

                                  <div className="nk-modal-text">
                                    <div className="caption-text">
                                      Are you sure you want to delete this
                                      {this.state.onboarding_id
                                        ? " onboarding item"
                                        : " domain"}
                                    </div>
                                  </div>
                                  <div className="nk-modal-action">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      className="btn btn-lg btn-mw btn-primary"
                                      onClick={() => {
                                        this.modalHideDel();
                                      }}
                                      disabled={this.state.isProcessing}
                                    >
                                      CANCEL
                                    </a>
                                    {"  "}
                                    {this.state.isProcessing ? (
                                      <button
                                        className="btn btn-lg btn-mw btn-danger"
                                        disabled
                                      >
                                        <em className="icon ni ni-trash"></em>
                                        <span>DELETING</span>
                                        <div
                                          className="spinner-grow spinner-grow-sm"
                                          role="status"
                                          style={{ marginLeft: "8px" }}
                                        >
                                          <span className="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                      </button>
                                    ) : (
                                      <button
                                        style={{ cursor: "pointer" }}
                                        className="btn btn-lg btn-mw btn-danger"
                                        onClick={() => {
                                          if (this.state.onboarding_id) {
                                            this.deleteOnboardingItem();
                                          } else {
                                            this.deleteDomain();
                                          }
                                        }}
                                        disabled={
                                          this.state.disabled ||
                                          this.state.isProcessing
                                        }
                                      >
                                        <span>DELETE</span>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* END DELETE MODAL  */}

                        {/* START EDIT MODAL  */}
                        <div
                          className="modal fade"
                          tabIndex="-1"
                          id="modalEditOnboarding"
                        >
                          <div
                            className="modal-dialog modal-xl modal-dialog-top"
                            role="document"
                          >
                            <div className="modal-content">
                              <a
                                href="#"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <em className="icon ni ni-cross"></em>
                              </a>
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  <em className="icon ni ni-edit text-primary" />{" "}
                                  <span>Update Onboarding Item</span>
                                </h5>
                              </div>
                              <div className="modal-body">
                                <div id="OnboardingEditDiv">
                                  <div
                                    className="col-12"
                                    style={{
                                      paddingLeft: "0px",
                                      paddingRight: "0px",
                                    }}
                                  >
                                    <MutextField
                                      id="edit-onboarding-title"
                                      name="edit-onboarding-title"
                                      label="Onboarding Item Title"
                                      value={this.state.editOnboardingTitle}
                                      onChange={(e) =>
                                        this.setState({
                                          editOnboardingTitle: e.target.value,
                                        })
                                      }
                                      variant="outlined"
                                      fullWidth
                                      placeholder="Enter onboarding item title"
                                      autoComplete="new-password"
                                      style={{ marginBottom: "18px" }}
                                    />

                                    {/* Tab Toggle: Form | Agreement */}
                                    <div
                                      style={{
                                        display: "flex",
                                        background: "#f0f0eb",
                                        borderRadius: "7px",
                                        padding: "4px",
                                        marginBottom: "18px",
                                        gap: "4px",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        onClick={() =>
                                          this.setState({
                                            editOnboardingType: "form",
                                          })
                                        }
                                        style={{
                                          flex: 1,
                                          padding: "9px 0",
                                          border: "none",
                                          borderRadius: "5px",
                                          fontSize: "14px",
                                          fontWeight: "500",
                                          cursor: "pointer",
                                          background:
                                            this.state.editOnboardingType ===
                                            "form"
                                              ? "#1d4f8a"
                                              : "transparent",
                                          color:
                                            this.state.editOnboardingType ===
                                            "form"
                                              ? "#fff"
                                              : "#7a7a6e",
                                          boxShadow:
                                            this.state.editOnboardingType ===
                                            "form"
                                              ? "0 2px 6px rgba(29,79,138,0.18)"
                                              : "none",
                                          transition: "all 0.2s",
                                        }}
                                      >
                                        Form
                                      </button>
                                      <button
                                        type="button"
                                        onClick={() =>
                                          this.setState({
                                            editOnboardingType: "agreement",
                                          })
                                        }
                                        style={{
                                          flex: 1,
                                          padding: "9px 0",
                                          border: "none",
                                          borderRadius: "5px",
                                          fontSize: "14px",
                                          fontWeight: "500",
                                          cursor: "pointer",
                                          background:
                                            this.state.editOnboardingType ===
                                            "agreement"
                                              ? "#1d4f8a"
                                              : "transparent",
                                          color:
                                            this.state.editOnboardingType ===
                                            "agreement"
                                              ? "#fff"
                                              : "#7a7a6e",
                                          boxShadow:
                                            this.state.editOnboardingType ===
                                            "agreement"
                                              ? "0 2px 6px rgba(29,79,138,0.18)"
                                              : "none",
                                          transition: "all 0.2s",
                                        }}
                                      >
                                        Agreement
                                      </button>
                                    </div>

                                    {/* Form Panel */}
                                    {this.state.editOnboardingType ===
                                      "form" && (
                                      <div
                                        className="form-group"
                                        style={{ marginBottom: "18px" }}
                                      >
                                        <Autocomplete
                                          options={this.getAvailableFormsForStep(
                                            this.state.editOnboardingId,
                                          ).map((form) => ({
                                            id: form.form_accountno,
                                            label: form.form_title,
                                            form: form,
                                          }))}
                                          getOptionLabel={(option) =>
                                            option.label
                                          }
                                          value={
                                            this.state.editOnboardingForm
                                              ? this.state.formsList.find(
                                                  (f) =>
                                                    f.form_accountno ===
                                                    this.state.editOnboardingForm,
                                                )
                                                ? {
                                                    id: this.state
                                                      .editOnboardingForm,
                                                    label:
                                                      this.state.formsList.find(
                                                        (f) =>
                                                          f.form_accountno ===
                                                          this.state
                                                            .editOnboardingForm,
                                                      )?.form_title,
                                                    form: this.state.formsList.find(
                                                      (f) =>
                                                        f.form_accountno ===
                                                        this.state
                                                          .editOnboardingForm,
                                                    ),
                                                  }
                                                : null
                                              : null
                                          }
                                          onChange={(e, newValue) => {
                                            const selectedFormId =
                                              newValue?.id || "";
                                            const selectedForm =
                                              this.state.formsList.find(
                                                (form) =>
                                                  form.form_accountno ===
                                                  selectedFormId,
                                              );
                                            this.setState({
                                              editOnboardingForm: selectedFormId,
                                              editOnboardingAllowMultiple:
                                                selectedForm?.allow_multiple !==
                                                undefined
                                                  ? selectedForm.allow_multiple
                                                  : 0,
                                            });
                                          }}
                                          disabled={this.state.formsLoading}
                                          clearOnBlur={false}
                                          clearOnEscape={false}
                                          noOptionsText="No Forms"
                                          renderInput={(params) => (
                                            <MutextField
                                              {...params}
                                              label="Select Form"
                                              variant="outlined"
                                              fullWidth
                                              autoComplete="new-password"
                                            />
                                          )}
                                        />
                                      </div>
                                    )}

                                    {/* Agreement Panel — sub-tab + single dropdown */}
                                    {this.state.editOnboardingType ===
                                      "agreement" && (
                                      <div style={{ marginBottom: "18px" }}>
                                        {/* Sub-tab: Partner | Client */}
                                        <div
                                          style={{
                                            display: "flex",
                                            background: "#f0f0eb",
                                            borderRadius: "7px",
                                            padding: "4px",
                                            marginBottom: "14px",
                                            gap: "4px",
                                          }}
                                        >
                                          {["Partner", "Client"].map((tab) => (
                                            <button
                                              key={tab}
                                              type="button"
                                              onClick={() =>
                                                this.setState({
                                                  editOnboardingAgreementTab:
                                                    tab,
                                                  editOnboardingAgreement: "",
                                                  editOnboardingAgreementTitle:
                                                    "",
                                                  editOnboardingAgreementInstruction:
                                                    "",
                                                  editOnboardingAgreementSource:
                                                    "",
                                                })
                                              }
                                              style={{
                                                flex: 1,
                                                padding: "7px 0",
                                                border: "none",
                                                borderRadius: "5px",
                                                fontSize: "13px",
                                                fontWeight: "500",
                                                cursor: "pointer",
                                                background:
                                                  this.state
                                                    .editOnboardingAgreementTab ===
                                                  tab
                                                    ? "#1d4f8a"
                                                    : "transparent",
                                                color:
                                                  this.state
                                                    .editOnboardingAgreementTab ===
                                                  tab
                                                    ? "#fff"
                                                    : "#7a7a6e",
                                                transition: "all 0.2s",
                                              }}
                                            >
                                              {tab} Agreements
                                            </button>
                                          ))}
                                        </div>

                                        {/* Single dropdown for the active tab */}
                                        <MutextField
                                          select
                                          label={`Select ${this.state.editOnboardingAgreementTab} Agreement`}
                                          value={
                                            this.state
                                              .editOnboardingAgreementSource ===
                                            this.state.editOnboardingAgreementTab
                                              ? this.state.editOnboardingAgreement
                                              : ""
                                          }
                                          onChange={(e) => {
                                            const selected =
                                              this.state.agreementsList.find(
                                                (a) =>
                                                  a.agreement_accountno ===
                                                  e.target.value,
                                              );
                                            this.setState({
                                              editOnboardingAgreement:
                                                e.target.value,
                                              editOnboardingAgreementTitle:
                                                selected?.agreement_title || "",
                                              editOnboardingAgreementInstruction:
                                                selected?.agreement_instruction ||
                                                "",
                                              editOnboardingAgreementSource:
                                                this.state
                                                  .editOnboardingAgreementTab,
                                            });
                                          }}
                                          variant="outlined"
                                          fullWidth
                                          disabled={this.state.agreementsLoading}
                                          SelectProps={{
                                            MenuProps: { disablePortal: true },
                                          }}
                                        >
                                          <MenuItem value="" disabled>
                                            {this.state.agreementsLoading
                                              ? "Loading..."
                                              : `Select ${this.state.editOnboardingAgreementTab} Agreement`}
                                          </MenuItem>
                                          {this.getAvailableAgreementsForStep(
                                            this.state.editOnboardingId,
                                            this.state.editOnboardingAgreementTab,
                                          )
                                            .map((agr) => (
                                              <MenuItem
                                                key={`${this.state.editOnboardingAgreementTab}-${agr.agreement_accountno}`}
                                                value={agr.agreement_accountno}
                                              >
                                                {agr.agreement_title}
                                              </MenuItem>
                                            ))}
                                        </MutextField>
                                      </div>
                                    )}

                                    {/* Checkboxes + Action buttons row */}
                                    <div className="d-flex align-items-center justify-content-between" style={{ marginTop: 8 }}>
                                      <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
                                        {this.state.editOnboardingType !== "agreement" && (
                                          <div className="custom-control custom-checkbox" style={{ display: "flex", alignItems: "center" }}>
                                            <input type="checkbox" className="custom-control-input" id="edit-allow-skip" checked={this.state.editOnboardingAllowSkip} onChange={(e) => this.setState({ editOnboardingAllowSkip: e.target.checked })} />
                                            <label className="custom-control-label" htmlFor="edit-allow-skip" style={{ fontWeight: "500", marginLeft: "8px", marginBottom: "0" }}>Allow Skip</label>
                                          </div>
                                        )}
                                        <div className="custom-control custom-checkbox" style={{ display: "flex", alignItems: "center" }}>
                                          <input type="checkbox" className="custom-control-input" id="edit-allow-Enable" checked={this.state.editOnboardingIsEnabled === 1} onChange={(e) => this.setState({ editOnboardingIsEnabled: e.target.checked ? 1 : 0 })} />
                                          <label className="custom-control-label" htmlFor="edit-allow-Enable" style={{ fontWeight: "500", marginLeft: "8px", marginBottom: "0" }}>Enable</label>
                                        </div>
                                      </div>
                                      <div style={{ display: "flex", gap: 10 }}>
                                        {this.state.add_question_loader === true ? (
                                          <button className="btn btn-lg btn-primary" disabled>
                                            <em className="icon ni ni-swap"></em> Saving
                                            <div className="spinner-grow spinner-grow-sm" role="status"><span className="sr-only">Loading...</span></div>
                                          </button>
                                        ) : (
                                          <>
                                            <a style={{ cursor: "pointer", color: "#fff" }} onClick={() => this.closeModal("modalEditOnboarding")} className="btn btn-primary btn-lg">
                                              <em className="icon ni ni-cross-round"></em><span>Cancel</span>
                                            </a>
                                            <a style={{ cursor: "pointer", color: "#fff" }} onClick={() => this.submitEditOnboarding()} className="btn btn-primary btn-lg">
                                              <em className="icon ni ni-edit" /> <span>Update Item</span>
                                            </a>
                                          </>
                                        )}
                                      </div>
                                    </div>

                                    {/* END BUTTONS */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="modal fade"
                          tabIndex="-1"
                          id="modalAddOnboarding"
                        >
                          <div
                            className="modal-dialog modal-lg modal-dialog-top"
                            role="document"
                          >
                            <div
                              className="modal-content"
                              style={{ borderRadius: "12px" }}
                            >
                              {/* Header */}
                              <div
                                className="modal-header"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  borderBottom: "1px solid #e8e8e8",
                                  padding: "20px 24px 16px",
                                }}
                              >
                                <h5
                                  className="modal-title"
                                  style={{
                                    fontSize: "17px",
                                    fontWeight: "600",
                                    color: "#1a1a2e",
                                    margin: 0,
                                  }}
                                >
                                  + Add Onboarding Item
                                </h5>
                                <a
                                  href="#"
                                  className="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                  style={{
                                    fontSize: "20px",
                                    color: "#888",
                                    lineHeight: 1,
                                    padding: "2px 6px",
                                  }}
                                >
                                  <em className="icon ni ni-cross"></em>
                                </a>
                              </div>

                              <div
                                className="modal-body"
                                style={{ padding: "24px" }}
                              >
                                {/* Title input */}
                                <MutextField
                                  id="add-onboarding-title"
                                  name="add-onboarding-title"
                                  label="Onboarding Item Title"
                                  value={this.state.editOnboardingTitle}
                                  onChange={(e) =>
                                    this.setState({
                                      editOnboardingTitle: e.target.value,
                                    })
                                  }
                                  variant="outlined"
                                  fullWidth
                                  placeholder="Enter onboarding item title"
                                  autoComplete="new-password"
                                  style={{ marginBottom: "18px" }}
                                />

                                {/* Tab Toggle: Form | Agreement */}
                                <div
                                  style={{
                                    display: "flex",
                                    background: "#f0f0eb",
                                    borderRadius: "7px",
                                    padding: "4px",
                                    marginBottom: "18px",
                                    gap: "4px",
                                  }}
                                >
                                  <button
                                    type="button"
                                    onClick={() =>
                                      this.setState({
                                        addOnboardingType: "form",
                                      })
                                    }
                                    style={{
                                      flex: 1,
                                      padding: "9px 0",
                                      border: "none",
                                      borderRadius: "5px",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      cursor: "pointer",
                                      background:
                                        this.state.addOnboardingType === "form"
                                          ? "#1d4f8a"
                                          : "transparent",
                                      color:
                                        this.state.addOnboardingType === "form"
                                          ? "#fff"
                                          : "#7a7a6e",
                                      boxShadow:
                                        this.state.addOnboardingType === "form"
                                          ? "0 2px 6px rgba(29,79,138,0.18)"
                                          : "none",
                                      transition: "all 0.2s",
                                    }}
                                  >
                                    Form
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      this.setState({
                                        addOnboardingType: "agreement",
                                      })
                                    }
                                    style={{
                                      flex: 1,
                                      padding: "9px 0",
                                      border: "none",
                                      borderRadius: "5px",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      cursor: "pointer",
                                      background:
                                        this.state.addOnboardingType ===
                                        "agreement"
                                          ? "#1d4f8a"
                                          : "transparent",
                                      color:
                                        this.state.addOnboardingType ===
                                        "agreement"
                                          ? "#fff"
                                          : "#7a7a6e",
                                      boxShadow:
                                        this.state.addOnboardingType ===
                                        "agreement"
                                          ? "0 2px 6px rgba(29,79,138,0.18)"
                                          : "none",
                                      transition: "all 0.2s",
                                    }}
                                  >
                                    Agreement
                                  </button>
                                </div>

                                {/* Form Panel */}
                                {this.state.addOnboardingType === "form" && (
                                  <div style={{ marginBottom: "18px" }}>
                                    <Autocomplete
                                      options={this.getAvailableFormsForStep(
                                        this.state.editOnboardingId,
                                      ).map((form) => ({
                                        id: form.form_accountno,
                                        label: form.form_title,
                                        form: form,
                                      }))}
                                      getOptionLabel={(option) => option.label}
                                      value={
                                        this.state.editOnboardingForm
                                          ? this.state.formsList.find(
                                              (f) =>
                                                f.form_accountno ===
                                                this.state.editOnboardingForm,
                                            )
                                            ? {
                                                id: this.state.editOnboardingForm,
                                                label:
                                                  this.state.formsList.find(
                                                    (f) =>
                                                      f.form_accountno ===
                                                      this.state
                                                        .editOnboardingForm,
                                                  )?.form_title,
                                                form: this.state.formsList.find(
                                                  (f) =>
                                                    f.form_accountno ===
                                                    this.state.editOnboardingForm,
                                                ),
                                              }
                                            : null
                                          : null
                                      }
                                      onChange={(e, newValue) => {
                                        const selectedFormId =
                                          newValue?.id || "";
                                        const selectedForm =
                                          this.state.formsList.find(
                                            (form) =>
                                              form.form_accountno ===
                                              selectedFormId,
                                          );
                                        this.setState({
                                          editOnboardingForm: selectedFormId,
                                          editOnboardingAllowMultiple:
                                            selectedForm?.allow_multiple !==
                                            undefined
                                              ? selectedForm.allow_multiple
                                              : 0,
                                        });
                                      }}
                                      disabled={this.state.formsLoading}
                                      clearOnBlur={false}
                                      clearOnEscape={false}
                                      noOptionsText="No Forms"
                                      renderInput={(params) => (
                                        <MutextField
                                          {...params}
                                          label="Select Form"
                                          variant="outlined"
                                          fullWidth
                                          autoComplete="new-password"
                                        />
                                      )}
                                    />
                                  </div>
                                )}

                                {/* Agreement Panel — sub-tab + single dropdown */}
                                {this.state.addOnboardingType ===
                                  "agreement" && (
                                  <div style={{ marginBottom: "18px" }}>
                                    {/* Sub-tab: Partner | Client */}
                                    <div
                                      style={{
                                        display: "flex",
                                        background: "#f0f0eb",
                                        borderRadius: "7px",
                                        padding: "4px",
                                        marginBottom: "14px",
                                        gap: "4px",
                                      }}
                                    >
                                      {["Partner", "Client"].map((tab) => (
                                        <button
                                          key={tab}
                                          type="button"
                                          onClick={() =>
                                            this.setState({
                                              addOnboardingAgreementTab: tab,
                                              editOnboardingAgreement: "",
                                              editOnboardingAgreementTitle: "",
                                              editOnboardingAgreementInstruction:
                                                "",
                                              editOnboardingAgreementSource: "",
                                            })
                                          }
                                          style={{
                                            flex: 1,
                                            padding: "7px 0",
                                            border: "none",
                                            borderRadius: "5px",
                                            fontSize: "13px",
                                            fontWeight: "500",
                                            cursor: "pointer",
                                            background:
                                              this.state
                                                .addOnboardingAgreementTab ===
                                              tab
                                                ? "#1d4f8a"
                                                : "transparent",
                                            color:
                                              this.state
                                                .addOnboardingAgreementTab ===
                                              tab
                                                ? "#fff"
                                                : "#7a7a6e",
                                            transition: "all 0.2s",
                                          }}
                                        >
                                          {tab} Agreements
                                        </button>
                                      ))}
                                    </div>
                                    {/* Single dropdown for active tab */}
                                    <MutextField
                                      select
                                      label={`Select ${this.state.addOnboardingAgreementTab} Agreement`}
                                      value={
                                        this.state
                                          .editOnboardingAgreementSource ===
                                        this.state.addOnboardingAgreementTab
                                          ? this.state.editOnboardingAgreement
                                          : ""
                                      }
                                      onChange={(e) => {
                                        const selected =
                                          this.state.agreementsList.find(
                                            (a) =>
                                              a.agreement_accountno ===
                                              e.target.value,
                                          );
                                        this.setState({
                                          editOnboardingAgreement: e.target.value,
                                          editOnboardingAgreementTitle:
                                            selected?.agreement_title || "",
                                          editOnboardingAgreementInstruction:
                                            selected?.agreement_instruction ||
                                            "",
                                          editOnboardingAgreementSource:
                                            this.state.addOnboardingAgreementTab,
                                        });
                                      }}
                                      variant="outlined"
                                      fullWidth
                                      disabled={this.state.agreementsLoading}
                                      SelectProps={{
                                        MenuProps: { disablePortal: true },
                                      }}
                                    >
                                      <MenuItem value="" disabled>
                                        {this.state.agreementsLoading
                                          ? "Loading..."
                                          : `Select ${this.state.addOnboardingAgreementTab} Agreement`}
                                      </MenuItem>
                                      {this.getAvailableAgreementsForStep(
                                        this.state.editOnboardingId,
                                        this.state.addOnboardingAgreementTab,
                                      )
                                        .map((agr) => (
                                          <MenuItem
                                            key={`${this.state.addOnboardingAgreementTab}-${agr.agreement_accountno}`}
                                            value={agr.agreement_accountno}
                                          >
                                            {agr.agreement_title}
                                          </MenuItem>
                                        ))}
                                    </MutextField>
                                  </div>
                                )}

                                {/* Checkboxes row */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "24px",
                                    marginBottom: "24px",
                                  }}
                                >
                                  {/* Allow Skip — hidden for agreements */}
                                  {this.state.addOnboardingType !== "agreement" && (
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="add-allow-skip"
                                        checked={
                                          this.state.editOnboardingAllowSkip
                                        }
                                        onChange={(e) =>
                                          this.setState({
                                            editOnboardingAllowSkip:
                                              e.target.checked,
                                          })
                                        }
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="add-allow-skip"
                                        style={{
                                          fontWeight: "500",
                                          marginLeft: "8px",
                                          marginBottom: "0",
                                          fontSize: "14px",
                                          color: "#444",
                                          cursor: "pointer",
                                        }}
                                      >
                                        Allow Skip
                                      </label>
                                    </div>
                                  )}

                                  {/* Enable */}
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id="add-allow-enable"
                                      checked={
                                        this.state.editOnboardingIsEnabled === 1
                                      }
                                      onChange={(e) =>
                                        this.setState({
                                          editOnboardingIsEnabled: e.target
                                            .checked
                                            ? 1
                                            : 0,
                                        })
                                      }
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="add-allow-enable"
                                      style={{
                                        fontWeight: "500",
                                        marginLeft: "8px",
                                        marginBottom: "0",
                                        fontSize: "14px",
                                        color: "#444",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Enable
                                    </label>
                                  </div>
                                </div>

                                {/* Footer buttons */}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "10px",
                                  }}
                                >
                                  {this.state.add_question_loader === true ? (
                                    <button
                                      className="btn btn-lg btn-primary"
                                      disabled
                                    >
                                      <em className="icon ni ni-swap"></em>{" "}
                                      Saving
                                      <div
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                      >
                                        <span className="sr-only">
                                          Loading...
                                        </span>
                                      </div>
                                    </button>
                                  ) : (
                                    <>
                                      <a
                                        style={{
                                          cursor: "pointer",
                                          color: "#fff",
                                        }}
                                        onClick={() =>
                                          this.closeModal("modalAddOnboarding")
                                        }
                                        className="btn btn-primary btn-lg"
                                      >
                                        <em className="icon ni ni-cross-round"></em>
                                        <span> Cancel</span>
                                      </a>
                                      <a
                                        style={{
                                          cursor: "pointer",
                                          color: "#fff",
                                        }}
                                        onClick={() =>
                                          this.submitEditOnboarding()
                                        }
                                        className="btn btn-primary btn-lg"
                                      >
                                        <em className="icon ni ni-plus" />{" "}
                                        <span>Add Item</span>
                                      </a>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* END EDIT MODAL  */}

                      {/* Add Summary Section Modal */}
                      <div
                        className="modal fade"
                        tabIndex="-1"
                        id="modalAddSummarySection"
                      >
                        <div
                          className="modal-dialog modal-lg modal-dialog-top"
                          role="document"
                        >
                          <div className="modal-content">
                            <a
                              href="#"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                            <div className="modal-header">
                              <h5 className="modal-title">
                                <em className="icon ni ni-plus text-primary"></em>{" "}
                                <span>Add Module</span>
                              </h5>
                            </div>
                            <div className="modal-body">
                              <div id="SummarySectionDiv">
                                <div
                                  className="col-12"
                                  style={{
                                    paddingLeft: "0px",
                                    paddingRight: "0px",
                                  }}
                                >
                                  {/* Error Messages */}
                                  {this.state
                                    .summarySection_title_error !== "" ? (
                                    <div className="example-alert mb-4">
                                      <div className="alert alert-pro alert-danger">
                                        <div className="alert-text">
                                          <h4>Error</h4>
                                          <p>
                                            {this.state
                                              .summarySection_title_error}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}

                                  <div className="row g-4">
                                    {/* Module Name Field */}
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <MutextField
                                          id="summary-section-title"
                                          name="summary-section-title"
                                          label="Module Name *"
                                          value={
                                            this.state.summarySection_title
                                          }
                                          onChange={
                                            this
                                              .handleSummarySectionTitleChange
                                          }
                                          error={
                                            this.state
                                              .summarySection_title_error !==
                                            ""
                                          }
                                          helperText={
                                            this.state
                                              .summarySection_title_error
                                          }
                                          variant="outlined"
                                          fullWidth
                                          placeholder="e.g., Volume Discount"
                                          autoComplete="new-password"
                                        />
                                      </div>
                                    </div>

                                    {/* Type and Scope */}
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <Autocomplete
                                          options={[
                                            { value: "DISCOUNT", label: "Discount" },
                                            { value: "TAX", label: "Tax" },
                                            { value: "SHIPPING", label: "Shipping" },
                                            { value: "FEE", label: "Fee" },
                                            { value: "CUSTOM", label: "Custom" },
                                          ]}
                                          getOptionLabel={(option) => option.label}
                                          value={
                                            [
                                              { value: "DISCOUNT", label: "Discount" },
                                              { value: "TAX", label: "Tax" },
                                              { value: "SHIPPING", label: "Shipping" },
                                              { value: "FEE", label: "Fee" },
                                              { value: "CUSTOM", label: "Custom" },
                                            ].find(
                                              (o) => o.value === this.state.summarySection_module_type
                                            ) || null
                                          }
                                          onChange={(e, newVal) => {
                                            if (newVal) {
                                              this.setState({ summarySection_module_type: newVal.value });
                                            }
                                          }}
                                          disableClearable
                                          renderInput={(params) => (
                                            <MutextField
                                              {...params}
                                              label="Type"
                                              variant="outlined"
                                            />
                                          )}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <Autocomplete
                                          options={[
                                            { value: "PERCENTAGE", label: "Percentage (%)" },
                                            { value: "FIXED", label: "Fixed Amount" },
                                          ]}
                                          getOptionLabel={(option) => option.label}
                                          value={
                                            [
                                              { value: "PERCENTAGE", label: "Percentage (%)" },
                                              { value: "FIXED", label: "Fixed Amount" },
                                            ].find(
                                              (o) => o.value === this.state.summarySection_scope
                                            ) || null
                                          }
                                          onChange={(e, newVal) => {
                                            if (newVal) {
                                              this.setState({ summarySection_scope: newVal.value });
                                            }
                                          }}
                                          disableClearable
                                          renderInput={(params) => (
                                            <MutextField
                                              {...params}
                                              label="Scope"
                                              variant="outlined"
                                            />
                                          )}
                                        />
                                      </div>
                                    </div>

                                    {/* Operation */}
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label
                                          style={{
                                            fontWeight: "500",
                                            marginBottom: "12px",
                                            display: "block",
                                          }}
                                        >
                                          Operation
                                        </label>
                                        <div style={{ display: "flex", gap: "12px" }}>
                                          <div
                                            onClick={() => this.handleSummarySectionTypeChange("SUBTRACT")}
                                            style={{
                                              flex: 1,
                                              padding: "14px 16px",
                                              border: `2px solid ${this.state.summarySection_type === "SUBTRACT" ? "#e85347" : "#e5e9f2"}`,
                                              borderRadius: "6px",
                                              backgroundColor: this.state.summarySection_type === "SUBTRACT" ? "#fff5f5" : "#fff",
                                              cursor: "pointer",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "10px",
                                            }}
                                          >
                                            <span style={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              width: "18px",
                                              height: "18px",
                                              borderRadius: "50%",
                                              border: `2px solid ${this.state.summarySection_type === "SUBTRACT" ? "#e85347" : "#8094ae"}`,
                                              backgroundColor: "#fff",
                                              flexShrink: 0,
                                            }}>
                                              {this.state.summarySection_type === "SUBTRACT" && (
                                                <span style={{
                                                  width: "8px",
                                                  height: "8px",
                                                  borderRadius: "50%",
                                                  backgroundColor: "#e85347",
                                                }} />
                                              )}
                                            </span>
                                            <div>
                                              <div style={{ fontWeight: "600", color: "#e85347" }}>
                                                (-) Subtract
                                              </div>
                                              <div style={{ fontSize: "12px", color: "#8094ae" }}>
                                                Deducts from subtotal
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            onClick={() => this.handleSummarySectionTypeChange("ADD")}
                                            style={{
                                              flex: 1,
                                              padding: "14px 16px",
                                              border: `2px solid ${this.state.summarySection_type === "ADD" ? "#1ee0ac" : "#e5e9f2"}`,
                                              borderRadius: "6px",
                                              backgroundColor: this.state.summarySection_type === "ADD" ? "#f0fdf8" : "#fff",
                                              cursor: "pointer",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "10px",
                                            }}
                                          >
                                            <span style={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              width: "18px",
                                              height: "18px",
                                              borderRadius: "50%",
                                              border: `2px solid ${this.state.summarySection_type === "ADD" ? "#1ee0ac" : "#8094ae"}`,
                                              backgroundColor: "#fff",
                                              flexShrink: 0,
                                            }}>
                                              {this.state.summarySection_type === "ADD" && (
                                                <span style={{
                                                  width: "8px",
                                                  height: "8px",
                                                  borderRadius: "50%",
                                                  backgroundColor: "#1ee0ac",
                                                }} />
                                              )}
                                            </span>
                                            <div>
                                              <div style={{ fontWeight: "600", color: "#1ee0ac" }}>
                                                (+) Add
                                              </div>
                                              <div style={{ fontSize: "12px", color: "#8094ae" }}>
                                                Adds to subtotal
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Field Visibility Settings */}
                                    <div className="col-lg-12">
                                      <label
                                        style={{
                                          fontWeight: "500",
                                          marginBottom: "12px",
                                          display: "block",
                                        }}
                                      >
                                        Field Visibility
                                      </label>
                                      <p
                                        style={{
                                          fontSize: "12px",
                                          color: "#8094ae",
                                          marginBottom: "15px",
                                        }}
                                      >
                                        Select which fields should be visible
                                        in the order summary section
                                      </p>

                                      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                                        {Object.entries(
                                          this.state.summarySection_fields,
                                        ).map(([fieldKey, field], index) => (
                                          <div
                                            key={fieldKey}
                                            onClick={() => this.handleFieldVisibilityToggle(fieldKey)}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              padding: "12px 16px",
                                              backgroundColor:
                                                index % 2 === 0
                                                  ? "#f5f6fa"
                                                  : "#fff",
                                              borderRadius: "4px",
                                              border: "1px solid #e5e9f2",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <span
                                              style={{
                                                flex: "1",
                                                marginBottom: "0",
                                                fontWeight: "500",
                                                color: "#364a63",
                                              }}
                                            >
                                              {field.label}
                                            </span>
                                            <div
                                              className="custom-control custom-switch"
                                              style={{ paddingLeft: "0" }}
                                              onClick={(e) => e.stopPropagation()}
                                            >
                                              <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                id={`field_visibility_${fieldKey}`}
                                                checked={field.visible}
                                                onChange={() =>
                                                  this.handleFieldVisibilityToggle(fieldKey)
                                                }
                                              />
                                              <label
                                                className="custom-control-label"
                                                htmlFor={`field_visibility_${fieldKey}`}
                                                style={{ cursor: "pointer" }}
                                              ></label>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer bg-light" style={{ justifyContent: "flex-end" }}>
                              <ul
                                className="nk-block-tools g-3 mb-0"
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  justifyContent: "flex-end",
                                }}
                              >
                                {this.state.add_summary_section_loader ===
                                true ? (
                                  <li className="nk-block-tools-opt">
                                    <button
                                      className="btn btn-lg btn-primary"
                                      disabled
                                    >
                                      <em className="icon ni ni-swap"></em>{" "}
                                      Saving
                                      <div
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                      >
                                        <span className="sr-only">
                                          Loading...
                                        </span>
                                      </div>
                                    </button>
                                  </li>
                                ) : (
                                  <>
                                    <li className="nk-block-tools-opt">
                                      <a
                                        style={{
                                          cursor: "pointer",
                                          backgroundColor: "#fff",
                                          color: "#526484",
                                          border: "1px solid #dbdfea",
                                          transition: "background-color 0.2s, color 0.2s",
                                        }}
                                        onMouseEnter={e => {
                                          e.currentTarget.style.backgroundColor = "#f5f6fa";
                                          e.currentTarget.style.color = "#364a63";
                                        }}
                                        onMouseLeave={e => {
                                          e.currentTarget.style.backgroundColor = "#fff";
                                          e.currentTarget.style.color = "#526484";
                                        }}
                                        onClick={() =>
                                          this.closeAddSummarySectionModal()
                                        }
                                        className="btn btn-lg"
                                      >
                                        <em className="icon ni ni-cross-round"></em>
                                        <span>Cancel</span>
                                      </a>
                                    </li>
                                    <li className="nk-block-tools-opt">
                                      <a
                                        style={{
                                          cursor: "pointer",
                                          color: "#fff",
                                        }}
                                        onClick={() =>
                                          this.addSummarySection()
                                        }
                                        className="btn btn-primary btn-lg"
                                      >
                                        <em className="icon ni ni-plus"></em>
                                        <span>Add Section</span>
                                      </a>
                                    </li>
                                  </>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* End Add Summary Section Modal */}

                      {/* Edit Summary Section Modal */}
                      <div
                        className="modal fade"
                        tabIndex="-1"
                        id="modalEditSummarySection"
                      >
                        <div
                          className="modal-dialog modal-lg modal-dialog-top"
                          role="document"
                        >
                          <div className="modal-content">
                            <a
                              href="#"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                            <div className="modal-header">
                              <h5 className="modal-title">
                                <em className="icon ni ni-edit text-primary"></em>{" "}
                                <span>Edit Summary Section</span>
                              </h5>
                            </div>
                            <div className="modal-body">
                              <div id="EditSummarySectionDiv">
                                <div
                                  className="col-12"
                                  style={{
                                    paddingLeft: "0px",
                                    paddingRight: "0px",
                                  }}
                                >
                                  {/* Error Messages */}
                                  {this.state
                                    .editSummarySection_title_error !== "" ? (
                                    <div className="example-alert mb-4">
                                      <div className="alert alert-pro alert-danger">
                                        <div className="alert-text">
                                          <h4>Error</h4>
                                          <p>
                                            {this.state
                                              .editSummarySection_title_error}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}

                                  <div className="row g-4">
                                    {/* Module Name Field */}
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <MutextField
                                          id="edit-summary-section-title"
                                          name="edit-summary-section-title"
                                          label="Module Name *"
                                          value={
                                            this.state.editSummarySection_title
                                          }
                                          onChange={
                                            this
                                              .handleEditSummarySectionTitleChange
                                          }
                                          error={
                                            this.state
                                              .editSummarySection_title_error !==
                                            ""
                                          }
                                          helperText={
                                            this.state
                                              .editSummarySection_title_error
                                          }
                                          variant="outlined"
                                          fullWidth
                                          placeholder="e.g., Volume Discount"
                                          autoComplete="new-password"
                                        />
                                      </div>
                                    </div>

                                    {/* Type and Scope */}
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <Autocomplete
                                          options={[
                                            { value: "DISCOUNT", label: "Discount" },
                                            { value: "TAX", label: "Tax" },
                                            { value: "SHIPPING", label: "Shipping" },
                                            { value: "FEE", label: "Fee" },
                                            { value: "CUSTOM", label: "Custom" },
                                          ]}
                                          getOptionLabel={(option) => option.label}
                                          value={
                                            [
                                              { value: "DISCOUNT", label: "Discount" },
                                              { value: "TAX", label: "Tax" },
                                              { value: "SHIPPING", label: "Shipping" },
                                              { value: "FEE", label: "Fee" },
                                              { value: "CUSTOM", label: "Custom" },
                                            ].find(
                                              (o) => o.value === this.state.editSummarySection_module_type
                                            ) || null
                                          }
                                          onChange={(e, newVal) => {
                                            if (newVal) {
                                              this.setState({ editSummarySection_module_type: newVal.value });
                                            }
                                          }}
                                          disableClearable
                                          renderInput={(params) => (
                                            <MutextField
                                              {...params}
                                              label="Type"
                                              variant="outlined"
                                            />
                                          )}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <Autocomplete
                                          options={[
                                            { value: "PERCENTAGE", label: "Percentage (%)" },
                                            { value: "FIXED", label: "Fixed Amount" },
                                          ]}
                                          getOptionLabel={(option) => option.label}
                                          value={
                                            [
                                              { value: "PERCENTAGE", label: "Percentage (%)" },
                                              { value: "FIXED", label: "Fixed Amount" },
                                            ].find(
                                              (o) => o.value === this.state.editSummarySection_scope
                                            ) || null
                                          }
                                          onChange={(e, newVal) => {
                                            if (newVal) {
                                              this.setState({ editSummarySection_scope: newVal.value });
                                            }
                                          }}
                                          disableClearable
                                          renderInput={(params) => (
                                            <MutextField
                                              {...params}
                                              label="Scope"
                                              variant="outlined"
                                            />
                                          )}
                                        />
                                      </div>
                                    </div>

                                    {/* Operation */}
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label
                                          style={{
                                            fontWeight: "500",
                                            marginBottom: "12px",
                                            display: "block",
                                          }}
                                        >
                                          Operation
                                        </label>
                                        <div style={{ display: "flex", gap: "12px" }}>
                                          <div
                                            onClick={() => this.handleEditSummarySectionTypeChange("SUBTRACT")}
                                            style={{
                                              flex: 1,
                                              padding: "14px 16px",
                                              border: `2px solid ${this.state.editSummarySection_type === "SUBTRACT" ? "#e85347" : "#e5e9f2"}`,
                                              borderRadius: "6px",
                                              backgroundColor: this.state.editSummarySection_type === "SUBTRACT" ? "#fff5f5" : "#fff",
                                              cursor: "pointer",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "10px",
                                            }}
                                          >
                                            <span style={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              width: "18px",
                                              height: "18px",
                                              borderRadius: "50%",
                                              border: `2px solid ${this.state.editSummarySection_type === "SUBTRACT" ? "#e85347" : "#8094ae"}`,
                                              backgroundColor: "#fff",
                                              flexShrink: 0,
                                            }}>
                                              {this.state.editSummarySection_type === "SUBTRACT" && (
                                                <span style={{
                                                  width: "8px",
                                                  height: "8px",
                                                  borderRadius: "50%",
                                                  backgroundColor: "#e85347",
                                                }} />
                                              )}
                                            </span>
                                            <div>
                                              <div style={{ fontWeight: "600", color: "#e85347" }}>
                                                (-) Subtract
                                              </div>
                                              <div style={{ fontSize: "12px", color: "#8094ae" }}>
                                                Deducts from subtotal
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            onClick={() => this.handleEditSummarySectionTypeChange("ADD")}
                                            style={{
                                              flex: 1,
                                              padding: "14px 16px",
                                              border: `2px solid ${this.state.editSummarySection_type === "ADD" ? "#1ee0ac" : "#e5e9f2"}`,
                                              borderRadius: "6px",
                                              backgroundColor: this.state.editSummarySection_type === "ADD" ? "#f0fdf8" : "#fff",
                                              cursor: "pointer",
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "10px",
                                            }}
                                          >
                                            <span style={{
                                              display: "inline-flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              width: "18px",
                                              height: "18px",
                                              borderRadius: "50%",
                                              border: `2px solid ${this.state.editSummarySection_type === "ADD" ? "#1ee0ac" : "#8094ae"}`,
                                              backgroundColor: "#fff",
                                              flexShrink: 0,
                                            }}>
                                              {this.state.editSummarySection_type === "ADD" && (
                                                <span style={{
                                                  width: "8px",
                                                  height: "8px",
                                                  borderRadius: "50%",
                                                  backgroundColor: "#1ee0ac",
                                                }} />
                                              )}
                                            </span>
                                            <div>
                                              <div style={{ fontWeight: "600", color: "#1ee0ac" }}>
                                                (+) Add
                                              </div>
                                              <div style={{ fontSize: "12px", color: "#8094ae" }}>
                                                Adds to subtotal
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Field Visibility Settings */}
                                    <div className="col-lg-12">
                                      <label
                                        style={{
                                          fontWeight: "500",
                                          marginBottom: "12px",
                                          display: "block",
                                        }}
                                      >
                                        Field Visibility
                                      </label>
                                      <p
                                        style={{
                                          fontSize: "12px",
                                          color: "#8094ae",
                                          marginBottom: "15px",
                                        }}
                                      >
                                        Select which fields should be visible
                                        in the order summary section
                                      </p>

                                      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                                        {Object.entries(
                                          this.state.editSummarySection_fields,
                                        ).map(([fieldKey, field], index) => (
                                          <div
                                            key={fieldKey}
                                            onClick={() => this.handleEditFieldVisibilityToggle(fieldKey)}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              padding: "12px 16px",
                                              backgroundColor:
                                                index % 2 === 0
                                                  ? "#f5f6fa"
                                                  : "#fff",
                                              borderRadius: "4px",
                                              border: "1px solid #e5e9f2",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <span
                                              style={{
                                                flex: "1",
                                                marginBottom: "0",
                                                fontWeight: "500",
                                                color: "#364a63",
                                              }}
                                            >
                                              {field.label}
                                            </span>
                                            <div
                                              className="custom-control custom-switch"
                                              style={{ paddingLeft: "0" }}
                                              onClick={(e) => e.stopPropagation()}
                                            >
                                              <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                id={`edit_field_visibility_${fieldKey}`}
                                                checked={field.visible}
                                                onChange={() =>
                                                  this.handleEditFieldVisibilityToggle(fieldKey)
                                                }
                                              />
                                              <label
                                                className="custom-control-label"
                                                htmlFor={`edit_field_visibility_${fieldKey}`}
                                                style={{ cursor: "pointer" }}
                                              ></label>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer bg-light" style={{ justifyContent: "flex-end" }}>
                              <ul
                                className="nk-block-tools g-3 mb-0"
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  justifyContent: "flex-end",
                                }}
                              >
                                {this.state.edit_summary_section_loader ===
                                true ? (
                                  <li className="nk-block-tools-opt">
                                    <button
                                      className="btn btn-lg btn-primary"
                                      disabled
                                    >
                                      <em className="icon ni ni-swap"></em>{" "}
                                      Saving
                                      <div
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                      >
                                        <span className="sr-only">
                                          Loading...
                                        </span>
                                      </div>
                                    </button>
                                  </li>
                                ) : (
                                  <>
                                    <li className="nk-block-tools-opt">
                                      <a
                                        style={{
                                          cursor: "pointer",
                                          backgroundColor: "#fff",
                                          color: "#526484",
                                          border: "1px solid #dbdfea",
                                          transition: "background-color 0.2s, color 0.2s",
                                        }}
                                        onMouseEnter={e => {
                                          e.currentTarget.style.backgroundColor = "#f5f6fa";
                                          e.currentTarget.style.color = "#364a63";
                                        }}
                                        onMouseLeave={e => {
                                          e.currentTarget.style.backgroundColor = "#fff";
                                          e.currentTarget.style.color = "#526484";
                                        }}
                                        onClick={() =>
                                          this.closeEditSummarySectionModal()
                                        }
                                        className="btn btn-lg"
                                      >
                                        <em className="icon ni ni-cross-round"></em>
                                        <span>Cancel</span>
                                      </a>
                                    </li>
                                    <li className="nk-block-tools-opt">
                                      <a
                                        style={{
                                          cursor: "pointer",
                                          color: "#fff",
                                        }}
                                        onClick={() =>
                                          this.updateSummarySection()
                                        }
                                        className="btn btn-primary btn-lg"
                                      >
                                        <em className="icon ni ni-check"></em>
                                        <span>Update Section</span>
                                      </a>
                                    </li>
                                  </>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* End Edit Summary Section Modal */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    userRoleItems: state.userRoleItems,
    leftMenuItems: state.leftMenuItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Upgrades);
